(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cF.bb === region.cU.bb)
	{
		return 'on line ' + region.cF.bb;
	}
	return 'on lines ' + region.cF.bb + ' through ' + region.cU.bb;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ev,
		impl.e4,
		impl.e_,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_enqueueEffects(managers, result.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		de: func(record.de),
		dF: record.dF,
		dq: record.dq
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.de;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dF;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dq) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ev,
		impl.e4,
		impl.e_,
		function(sendToApp, initialModel) {
			var view = impl.aT;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ev,
		impl.e4,
		impl.e_,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cC && impl.cC(sendToApp)
			var view = impl.aT;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.d0);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.bv) && (_VirtualDom_doc.title = title = doc.bv);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.eH;
	var onUrlRequest = impl.eI;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cC: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.du === next.du
							&& curr.c0 === next.c0
							&& curr.dn.a === next.dn.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ev: function(flags)
		{
			return A3(impl.ev, flags, _Browser_getUrl(), key);
		},
		aT: impl.aT,
		e4: impl.e4,
		e_: impl.e_
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { es: 'hidden', d8: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { es: 'mozHidden', d8: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { es: 'msHidden', d8: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { es: 'webkitHidden', d8: 'webkitvisibilitychange' }
		: { es: 'hidden', d8: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dA: _Browser_getScene(),
		dU: {
			af: _Browser_window.pageXOffset,
			ag: _Browser_window.pageYOffset,
			dW: _Browser_doc.documentElement.clientWidth,
			c: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		dW: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		c: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dA: {
				dW: node.scrollWidth,
				c: node.scrollHeight
			},
			dU: {
				af: node.scrollLeft,
				ag: node.scrollTop,
				dW: node.clientWidth,
				c: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dA: _Browser_getScene(),
			dU: {
				af: x,
				ag: y,
				dW: _Browser_doc.documentElement.clientWidth,
				c: _Browser_doc.documentElement.clientHeight
			},
			eg: {
				af: x + rect.left,
				ag: y + rect.top,
				dW: rect.width,
				c: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F2(function(request, maybeProgress)
{
	return _Scheduler_binding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		_Http_configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_Scheduler_fail($elm$http$Http$NetworkError));
		});
		xhr.addEventListener('timeout', function() {
			callback(_Scheduler_fail($elm$http$Http$Timeout));
		});
		xhr.addEventListener('load', function() {
			callback(_Http_handleResponse(xhr, request.ej.a));
		});

		try
		{
			xhr.open(request.eC, request.e5, true);
		}
		catch (e)
		{
			return callback(_Scheduler_fail($elm$http$Http$BadUrl(request.e5)));
		}

		_Http_configureRequest(xhr, request);

		var body = request.d0;
		xhr.send($elm$http$Http$Internal$isStringBody(body)
			? (xhr.setRequestHeader('Content-Type', body.a), body.b)
			: body.a
		);

		return function() { xhr.abort(); };
	});
});

function _Http_configureProgress(xhr, maybeProgress)
{
	if (!$elm$core$Maybe$isJust(maybeProgress))
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_Scheduler_rawSpawn(maybeProgress.a({
			d5: event.loaded,
			d6: event.total
		}));
	});
}

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.er; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}

	xhr.responseType = request.ej.b;
	xhr.withCredentials = request.fc;

	$elm$core$Maybe$isJust(request.cG) && (xhr.timeout = request.cG.a);
}


// RESPONSES

function _Http_handleResponse(xhr, responseToResult)
{
	var response = _Http_toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _Scheduler_fail($elm$http$Http$BadStatus(response));
	}

	var result = responseToResult(response);

	if ($elm$core$Result$isOk(result))
	{
		return _Scheduler_succeed(result.a);
	}
	else
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(A2($elm$http$Http$BadPayload, result.a, response));
	}
}

function _Http_toResponse(xhr)
{
	return {
		e5: xhr.responseURL,
		eW: { d9: xhr.status, de: xhr.statusText },
		er: _Http_parseHeaders(xhr.getAllResponseHeaders()),
		d0: xhr.response
	};
}

function _Http_parseHeaders(rawHeaders)
{
	var headers = $elm$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function _Http_expectStringResponse(responseToResult)
{
	return {
		$: 0,
		b: 'text',
		a: responseToResult
	};
}

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		b: expect.b,
		a: function(response) {
			var convertedResponse = expect.a(response);
			return A2($elm$core$Result$map, func, convertedResponse);
		}
	};
});


// BODY

function _Http_multipart(parts)
{


	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}

	return $elm$http$Http$Internal$FormDataBody(formData);
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.ec))
		{
			lang = options.ec.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.eq.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.e$,
		breaks: gfm && gfm.d3,
		sanitize: options.eT,
		smartypants: options.eV
	};
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.eE) { flags += 'm'; }
	if (options.d7) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $author$project$Main$OnUrlChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$OnUrlRequest = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.g) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.i),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.i);
		} else {
			var treeLen = builder.g * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.k) : builder.k;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.g);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.i) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.i);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{k: nodeList, g: (len / $elm$core$Array$branchFactor) | 0, i: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {cY: fragment, c0: host, dl: path, dn: port_, du: protocol, dv: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$PageNone = {$: 0};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$Material$defaultModel = {cK: $elm$core$Dict$empty, cM: $elm$core$Dict$empty, cN: $elm$core$Dict$empty, cQ: $elm$core$Dict$empty, cT: $elm$core$Dict$empty, cW: $elm$core$Dict$empty, c2: $elm$core$Dict$empty, dc: $elm$core$Dict$empty, t: $elm$core$Dict$empty, dw: $elm$core$Dict$empty, am: $elm$core$Dict$empty, cB: $elm$core$Dict$empty, dD: $elm$core$Dict$empty, bq: $elm$core$Dict$empty, dI: $elm$core$Dict$empty, dK: $elm$core$Dict$empty, dO: $elm$core$Dict$empty, dR: $elm$core$Dict$empty};
var $author$project$Main$EditMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$FameWallMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$ListMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$MarkdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$PageEdit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$PageFameWall = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$PageList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$PageMarkdown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$PagePhilosophy = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$PageProject = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$PageSourceCode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$PhilosophyMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$ProjectMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$SourceCodeMsg = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Main$initPageConfigDict = function (_v0) {
	var pageId = _v0.a;
	var pageConfig = _v0.b;
	var p_ = function () {
		var p = pageConfig;
		return p;
	}();
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2(pageId, pageConfig),
		$elm$core$List$concat(
			A2($elm$core$List$map, $author$project$Main$initPageConfigDict, p_.a_)));
};
var $author$project$Main$PageConfig = $elm$core$Basics$identity;
var $author$project$Main$initPageConfig = F4(
	function (title, href, data, children) {
		return {a_: children, cn: data, c1: href, bv: title};
	});
var $author$project$Main$markdownPrefix = function (name) {
	return '/silverfocs/markdown/' + name;
};
var $author$project$Main$invisiblePageConfigList = _List_fromArray(
	[
		_Utils_Tuple2(
		'md.sfocsres',
		A4(
			$author$project$Main$initPageConfig,
			'SilverFocs Resources',
			$author$project$Main$markdownPrefix('sfocsres'),
			'sfocs_resources/index.md',
			_List_Nil)),
		_Utils_Tuple2(
		'md.extres',
		A4(
			$author$project$Main$initPageConfig,
			'External Resources',
			$author$project$Main$markdownPrefix('extres'),
			'ext_resources/index.md',
			_List_Nil)),
		_Utils_Tuple2(
		'md.license',
		A4(
			$author$project$Main$initPageConfig,
			'External Resources',
			$author$project$Main$markdownPrefix('license'),
			'license/index.md',
			_List_Nil))
	]);
var $author$project$Config$current_year = 2026;
var $author$project$Main$famewallPrefix = '/silverfocs/famewall/';
var $author$project$Main$pageConfigDefault = A4($author$project$Main$initPageConfig, 'Home', '/silverfocs', 'home/index.md', _List_Nil);
var $author$project$Main$philosophyPrefix = '/silverfocs/philosophy/';
var $author$project$Main$projectPrefix = function (name) {
	return '/silverfocs/project/' + name;
};
var $author$project$Main$projectConfig = F3(
	function (list, projIndex, year) {
		var title = 'Year ' + $elm$core$String$fromInt(year);
		var id = 'project.' + $elm$core$String$fromInt(year);
		var href = $author$project$Main$projectPrefix(
			$elm$core$String$fromInt(year) + ('/p' + $elm$core$String$fromInt(projIndex)));
		return _Utils_Tuple2(
			id,
			A4(
				$author$project$Main$initPageConfig,
				title,
				href,
				$elm$core$String$fromInt(year),
				list));
	});
var $author$project$Main$projectConfigList = function (yearnum) {
	if (yearnum < 2020) {
		return _Utils_Tuple2(
			'',
			A4(
				$author$project$Main$initPageConfig,
				'',
				$author$project$Main$projectPrefix(''),
				'',
				_List_Nil));
	} else {
		var prevyear = A2(
			$elm$core$List$map,
			A2($author$project$Main$projectConfig, _List_Nil, 1),
			$elm$core$List$reverse(
				A2($elm$core$List$range, 2020, yearnum - 1)));
		return A3($author$project$Main$projectConfig, prevyear, 1, yearnum);
	}
};
var $author$project$Main$pageConfigList = _List_fromArray(
	[
		_Utils_Tuple2('md.home', $author$project$Main$pageConfigDefault),
		_Utils_Tuple2(
		'md.aboutus',
		A4(
			$author$project$Main$initPageConfig,
			'Company Directory',
			$author$project$Main$markdownPrefix('aboutus'),
			'team/index.md',
			_List_fromArray(
				[
					_Utils_Tuple2(
					'philosophy',
					A4($author$project$Main$initPageConfig, 'Game Philosophy', $author$project$Main$philosophyPrefix, '', _List_Nil)),
					_Utils_Tuple2(
					'famewall',
					A4($author$project$Main$initPageConfig, 'Wall of Fame', $author$project$Main$famewallPrefix, '', _List_Nil))
				]))),
		$author$project$Main$projectConfigList($author$project$Config$current_year)
	]);
var $author$project$Main$allPageConfigDict = $elm$core$Dict$fromList(
	$elm$core$List$concat(
		A2(
			$elm$core$List$map,
			$author$project$Main$initPageConfigDict,
			_Utils_ap($author$project$Main$pageConfigList, $author$project$Main$invisiblePageConfigList))));
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $author$project$Shared$Loading = {$: 1};
var $author$project$Pages$Edit$OnFetchPlayer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Player$Player = F3(
	function (id, name, level) {
		return {et: id, ct: level, eF: name};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Player$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Player$Player,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'level', $elm$json$Json$Decode$int));
var $elm$http$Http$Internal$EmptyBody = {$: 0};
var $elm$http$Http$emptyBody = $elm$http$Http$Internal$EmptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Internal$FormDataBody = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$Internal$isStringBody = function (body) {
	if (body.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = _Http_expectStringResponse;
var $elm$http$Http$expectJson = function (decoder) {
	return $elm$http$Http$expectStringResponse(
		function (response) {
			var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, response.d0);
			if (_v0.$ === 1) {
				var decodeError = _v0.a;
				return $elm$core$Result$Err(
					$elm$json$Json$Decode$errorToString(decodeError));
			} else {
				var value = _v0.a;
				return $elm$core$Result$Ok(value);
			}
		});
};
var $elm$http$Http$Internal$Request = $elm$core$Basics$identity;
var $elm$http$Http$request = $elm$core$Basics$identity;
var $elm$http$Http$get = F2(
	function (url, decoder) {
		return $elm$http$Http$request(
			{
				d0: $elm$http$Http$emptyBody,
				ej: $elm$http$Http$expectJson(decoder),
				er: _List_Nil,
				eC: 'GET',
				cG: $elm$core$Maybe$Nothing,
				e5: url,
				fc: false
			});
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$http$Http$toTask = function (_v0) {
	var request_ = _v0;
	return A2(_Http_toTask, request_, $elm$core$Maybe$Nothing);
};
var $elm$http$Http$send = F2(
	function (resultToMessage, request_) {
		return A2(
			$elm$core$Task$attempt,
			resultToMessage,
			$elm$http$Http$toTask(request_));
	});
var $author$project$Pages$Edit$fetchPlayer = F2(
	function (flags, playerId) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Edit$OnFetchPlayer,
			A2($elm$http$Http$get, flags.cJ + ('/players/' + playerId), $author$project$Player$decoder));
	});
var $author$project$Pages$Edit$init = F2(
	function (flags, playerId) {
		return _Utils_Tuple2(
			{aM: $author$project$Shared$Loading},
			A2($author$project$Pages$Edit$fetchPlayer, flags, playerId));
	});
var $author$project$Pages$FameWall$Mdc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectDialog$Closed = {$: 0};
var $author$project$Pages$FameWall$defaultModel = function (flags) {
	return {bI: _List_Nil, cQ: $author$project$Pages$ProjectDialog$Closed, m: flags, aI: $author$project$Material$defaultModel};
};
var $author$project$Pages$FameWall$OnFetchFameWall = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$FameWall$Content = F4(
	function (cellname, markdown, projects, imgURL) {
		return {cg: cellname, c3: imgURL, cv: markdown, cA: projects};
	});
var $author$project$Project$Project = function (name) {
	return function (code) {
		return function (status) {
			return function (author) {
				return function (title) {
					return function (stdout) {
						return function (stderr) {
							return function (year) {
								return function (buildEnable) {
									return function (avail) {
										return {d_: author, B: avail, cf: buildEnable, d9: code, eF: name, eW: status, eX: stderr, eY: stdout, bv: title, ao: year};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Project$Availability = F6(
	function (poster, thumbnail, trailer, elmdoc, booklet, play) {
		return {d1: booklet, eh: elmdoc, eL: play, eN: poster, dP: thumbnail, e0: trailer};
	});
var $author$project$Project$SpecAvail = F2(
	function (avail, reason) {
		return {B: avail, eQ: reason};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Project$decoderSpecAvail = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reason',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Project$SpecAvail)));
var $author$project$Project$decoderAvail = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'play',
	$author$project$Project$decoderSpecAvail,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'booklet',
		$author$project$Project$decoderSpecAvail,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'elm-doc',
			$author$project$Project$decoderSpecAvail,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'trailer',
				$author$project$Project$decoderSpecAvail,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'thumbnail',
					$author$project$Project$decoderSpecAvail,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'poster',
						$author$project$Project$decoderSpecAvail,
						$elm$json$Json$Decode$succeed($author$project$Project$Availability)))))));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Project$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'availability',
	$author$project$Project$decoderAvail,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'buildEnable',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'year',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'stderr',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'stdout',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'author',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Project$Project)))))))))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Pages$FameWall$contentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'img',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'projects',
		$elm$json$Json$Decode$list($author$project$Project$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'markdown',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cellname',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Pages$FameWall$Content)))));
var $author$project$Pages$FameWall$contentListDecoder = $elm$json$Json$Decode$list($author$project$Pages$FameWall$contentDecoder);
var $author$project$Pages$FameWall$fetchFameWall = function (flags) {
	return A2(
		$elm$http$Http$send,
		$author$project$Pages$FameWall$OnFetchFameWall,
		A2($elm$http$Http$get, flags.cJ + (flags.dp + ('/api/famewall/' + ('?v=' + flags.aR.c_))), $author$project$Pages$FameWall$contentListDecoder));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Material$init = function (_v0) {
	return $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$FameWall$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$FameWall$defaultModel(flags),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Pages$FameWall$fetchFameWall(flags),
					$author$project$Material$init($author$project$Pages$FameWall$Mdc)
				])));
};
var $author$project$Pages$List$Mdc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$List$defaultModel = {bM: false, aI: $author$project$Material$defaultModel, bi: $author$project$Shared$Loading};
var $author$project$Pages$List$OnFetchPlayers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$List$fetchPlayers = function (flags) {
	return A2(
		$elm$http$Http$send,
		$author$project$Pages$List$OnFetchPlayers,
		A2(
			$elm$http$Http$get,
			flags.cJ + '/players',
			$elm$json$Json$Decode$list($author$project$Player$decoder)));
};
var $author$project$Pages$List$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$List$defaultModel,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Pages$List$fetchPlayers(flags),
					$author$project$Material$init($author$project$Pages$List$Mdc)
				])));
};
var $author$project$Pages$Markdown$Mdc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Markdown$defaultModel = F2(
	function (flags, markdownName) {
		return {m: flags, cv: '', bU: markdownName, aI: $author$project$Material$defaultModel};
	});
var $author$project$Pages$Markdown$OnFetchMarkdown = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$expectString = $elm$http$Http$expectStringResponse(
	function (response) {
		return $elm$core$Result$Ok(response.d0);
	});
var $elm$http$Http$getString = function (url) {
	return $elm$http$Http$request(
		{d0: $elm$http$Http$emptyBody, ej: $elm$http$Http$expectString, er: _List_Nil, eC: 'GET', cG: $elm$core$Maybe$Nothing, e5: url, fc: false});
};
var $author$project$Pages$Markdown$fetchMarkdown = F2(
	function (flags, markdownName) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Markdown$OnFetchMarkdown,
			$elm$http$Http$getString(flags.cJ + (flags.dp + ('/api/markdown/' + (markdownName + ('?v=' + flags.aR.c_))))));
	});
var $author$project$Pages$Markdown$init = F2(
	function (flags, markdownName) {
		return _Utils_Tuple2(
			A2($author$project$Pages$Markdown$defaultModel, flags, markdownName),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Markdown$fetchMarkdown, flags, markdownName),
						$author$project$Material$init($author$project$Pages$Markdown$Mdc)
					])));
	});
var $author$project$Pages$Philosophy$defaultModel = function (flags) {
	return {bI: _List_Nil, m: flags, aI: $author$project$Material$defaultModel};
};
var $author$project$Pages$Philosophy$OnFetchPhilosophy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Philosophy$MarkdownCell = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Philosophy$WheelCell = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Philosophy$Nothing = {$: 2};
var $author$project$Pages$Philosophy$str2CellType = function (typeName) {
	switch (typeName) {
		case 'markdown':
			return A2($author$project$Pages$Philosophy$MarkdownCell, '', '');
		case 'wheel':
			return A2($author$project$Pages$Philosophy$WheelCell, '', _List_Nil);
		default:
			return $author$project$Pages$Philosophy$Nothing;
	}
};
var $author$project$Pages$Philosophy$decodeHelper = function (cellType) {
	var _v0 = $author$project$Pages$Philosophy$str2CellType(cellType);
	switch (_v0.$) {
		case 0:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Pages$Philosophy$MarkdownCell,
				A2($elm$json$Json$Decode$field, 'cellName', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string));
		case 1:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Pages$Philosophy$WheelCell,
				A2($elm$json$Json$Decode$field, 'cellName', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'content',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
		default:
			return $elm$json$Json$Decode$fail('Fail');
	}
};
var $author$project$Pages$Philosophy$decodeCell = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Pages$Philosophy$decodeHelper,
	A2($elm$json$Json$Decode$field, 'cellType', $elm$json$Json$Decode$string));
var $author$project$Pages$Philosophy$fetchPhilosophy = function (flags) {
	return A2(
		$elm$http$Http$send,
		$author$project$Pages$Philosophy$OnFetchPhilosophy,
		A2(
			$elm$http$Http$get,
			flags.cJ + (flags.dp + ('/api/philosophy/' + ('?v=' + flags.aR.c_))),
			$elm$json$Json$Decode$list($author$project$Pages$Philosophy$decodeCell)));
};
var $author$project$Pages$Philosophy$init = function (flags) {
	return _Utils_Tuple2(
		$author$project$Pages$Philosophy$defaultModel(flags),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Pages$Philosophy$fetchPhilosophy(flags)
				])));
};
var $author$project$Pages$Project$Mdc = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectDialog$Free = 1;
var $author$project$Pages$Project$defaultModel = F4(
	function (flags, year, projectName, navKey) {
		return {aY: 1, aq: $elm$core$Maybe$Nothing, cQ: $author$project$Pages$ProjectDialog$Closed, m: flags, aI: $author$project$Material$defaultModel, bV: navKey, aN: projectName, cA: _List_Nil, ao: year};
	});
var $author$project$Pages$Project$OnFetchProjectList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Config$get_backend_year = function (year) {
	return year - 2019;
};
var $author$project$Pages$Project$fetchProjectList = F3(
	function (flags, year, projectName) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Project$OnFetchProjectList,
			A2(
				$elm$http$Http$get,
				flags.cJ + (flags.dp + ('/api/project/list/' + ($elm$core$String$fromInt(
					$author$project$Config$get_backend_year(year)) + ('/' + projectName)))),
				$elm$json$Json$Decode$list($author$project$Project$decoder)));
	});
var $author$project$Pages$Project$init = F4(
	function (flags, year, projName, navKey) {
		return _Utils_Tuple2(
			A4($author$project$Pages$Project$defaultModel, flags, year, projName, navKey),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Pages$Project$fetchProjectList, flags, year, projName),
						$author$project$Material$init($author$project$Pages$Project$Mdc)
					])));
	});
var $author$project$Pages$SourceCode$Mdc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SourceCode$defaultModel = F2(
	function (flags, srcPath) {
		return {m: flags, aI: $author$project$Material$defaultModel, br: '', b8: srcPath};
	});
var $author$project$Pages$SourceCode$OnFetchSourceCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SourceCode$fetchSourceCode = F2(
	function (flags, srcPath) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$SourceCode$OnFetchSourceCode,
			$elm$http$Http$getString(flags.cJ + (flags.dp + ('/api/markdown/' + (srcPath + ('?v=' + flags.aR.c_))))));
	});
var $author$project$Pages$SourceCode$init = F2(
	function (flags, srcArray) {
		var srcPath = A2($elm$core$String$join, '/', srcArray);
		return _Utils_Tuple2(
			A2($author$project$Pages$SourceCode$defaultModel, flags, srcPath),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$SourceCode$fetchSourceCode, flags, srcPath),
						$author$project$Material$init($author$project$Pages$SourceCode$Mdc)
					])));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Main$loadCurrentPage = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = function () {
		var _v2 = model.b6;
		switch (_v2.$) {
			case 0:
				var _v3 = $author$project$Pages$List$init(model.m);
				var pageModel = _v3.a;
				var pageCmd = _v3.b;
				return _Utils_Tuple3(
					$author$project$Main$PageList(pageModel),
					'list',
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ListMsg, pageCmd));
			case 1:
				var playerId = _v2.a;
				var _v4 = A2($author$project$Pages$Edit$init, model.m, playerId);
				var pageModel = _v4.a;
				var pageCmd = _v4.b;
				return _Utils_Tuple3(
					$author$project$Main$PageEdit(pageModel),
					'view',
					A2($elm$core$Platform$Cmd$map, $author$project$Main$EditMsg, pageCmd));
			case 2:
				var pageId_ = 'md.home';
				var p_ = function () {
					var _v6 = $author$project$Main$pageConfigDefault;
					var p = _v6;
					return p;
				}();
				var _v5 = A2($author$project$Pages$Markdown$init, model.m, p_.cn);
				var pageModel = _v5.a;
				var pageCmd = _v5.b;
				return _Utils_Tuple3(
					$author$project$Main$PageMarkdown(pageModel),
					pageId_,
					A2($elm$core$Platform$Cmd$map, $author$project$Main$MarkdownMsg, pageCmd));
			case 3:
				var markdownName = _v2.a;
				var pageId_ = 'md.' + markdownName;
				var pageConfig = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Main$pageConfigDefault,
					A2($elm$core$Dict$get, pageId_, $author$project$Main$allPageConfigDict));
				var p_ = function () {
					var p = pageConfig;
					return p;
				}();
				var _v7 = A2($author$project$Pages$Markdown$init, model.m, p_.cn);
				var pageModel = _v7.a;
				var pageCmd = _v7.b;
				return _Utils_Tuple3(
					$author$project$Main$PageMarkdown(pageModel),
					pageId_,
					A2($elm$core$Platform$Cmd$map, $author$project$Main$MarkdownMsg, pageCmd));
			case 4:
				var srcPath = _v2.a;
				var _v9 = A2($author$project$Pages$SourceCode$init, model.m, srcPath);
				var pageModel = _v9.a;
				var pageCmd = _v9.b;
				return _Utils_Tuple3(
					$author$project$Main$PageSourceCode(pageModel),
					'src',
					A2($elm$core$Platform$Cmd$map, $author$project$Main$SourceCodeMsg, pageCmd));
			case 5:
				var year = _v2.a;
				var projName = _v2.b;
				var _v10 = A4($author$project$Pages$Project$init, model.m, year, projName, model.bV);
				var pageModel = _v10.a;
				var pageCmd = _v10.b;
				return _Utils_Tuple3(
					$author$project$Main$PageProject(pageModel),
					'project.' + $elm$core$String$fromInt(year),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$ProjectMsg, pageCmd));
			case 6:
				var _v11 = $author$project$Pages$FameWall$init(model.m);
				var pageModel = _v11.a;
				var pageCmd = _v11.b;
				return _Utils_Tuple3(
					$author$project$Main$PageFameWall(pageModel),
					'famewall',
					A2($elm$core$Platform$Cmd$map, $author$project$Main$FameWallMsg, pageCmd));
			case 7:
				var _v12 = $author$project$Pages$Philosophy$init(model.m);
				var pageModel = _v12.a;
				var pageCmd = _v12.b;
				return _Utils_Tuple3(
					$author$project$Main$PagePhilosophy(pageModel),
					'philosophy',
					A2($elm$core$Platform$Cmd$map, $author$project$Main$PhilosophyMsg, pageCmd));
			default:
				return _Utils_Tuple3($author$project$Main$PageNone, 'none', $elm$core$Platform$Cmd$none);
		}
	}();
	var page = _v1.a;
	var pageId = _v1.b;
	var newCmd = _v1.c;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{z: page, b0: pageId}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd, newCmd])));
};
var $author$project$Routes$NotFoundRoute = {$: 8};
var $author$project$Routes$FamewallRoute = {$: 6};
var $author$project$Routes$MarkdownHomeRoute = {$: 2};
var $author$project$Routes$MarkdownRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Routes$PhilosophyRoute = {$: 7};
var $author$project$Routes$PlayerRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routes$PlayersRoute = {$: 0};
var $author$project$Routes$ProjectRoute = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Routes$SourceCodeRoute = function (a) {
	return {$: 4, a: a};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {ar: frag, av: params, an: unvisited, bC: value, ay: visited};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.ay;
			var unvisited = _v0.an;
			var params = _v0.av;
			var frag = _v0.ar;
			var value = _v0.bC;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.ay;
		var unvisited = _v0.an;
		var params = _v0.av;
		var frag = _v0.ar;
		var value = _v0.bC;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.ay;
			var unvisited = _v1.an;
			var params = _v1.av;
			var frag = _v1.ar;
			var value = _v1.bC;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routes$restHelpE = function (maxDepth) {
	return (maxDepth < 1) ? A2($elm$url$Url$Parser$map, _List_Nil, $elm$url$Url$Parser$top) : $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$url$Url$Parser$map, _List_Nil, $elm$url$Url$Parser$top),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (str, li) {
						return A2($elm$core$List$cons, str, li);
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					$author$project$Routes$restHelpO(maxDepth - 1)))
			]));
};
var $author$project$Routes$restHelpO = function (maxDepth) {
	return (maxDepth < 1) ? A2($elm$url$Url$Parser$map, _List_Nil, $elm$url$Url$Parser$top) : $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2($elm$url$Url$Parser$map, _List_Nil, $elm$url$Url$Parser$top),
				A2(
				$elm$url$Url$Parser$map,
				F2(
					function (str, li) {
						return A2($elm$core$List$cons, str, li);
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					$author$project$Routes$restHelpE(maxDepth - 1)))
			]));
};
var $author$project$Routes$rest = $author$project$Routes$restHelpE(10);
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.ay;
		var unvisited = _v0.an;
		var params = _v0.av;
		var frag = _v0.ar;
		var value = _v0.bC;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Routes$matchers = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$MarkdownHomeRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				$elm$url$Url$Parser$top)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$PlayerRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('players'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$PlayersRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				$elm$url$Url$Parser$s('players'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$MarkdownHomeRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				$elm$url$Url$Parser$s('markdown'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$MarkdownRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('markdown'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$SourceCodeRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('src'),
					$author$project$Routes$rest))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$ProjectRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('project'),
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$FamewallRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				$elm$url$Url$Parser$s('famewall'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routes$PhilosophyRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('silverfocs'),
				$elm$url$Url$Parser$s('philosophy')))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.an;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.bC);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.bC);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.dl),
					$elm$url$Url$Parser$prepareQuery(url.dv),
					url.cY,
					$elm$core$Basics$identity)));
	});
var $author$project$Routes$parseUrl = function (url) {
	var _v0 = A2($elm$url$Url$Parser$parse, $author$project$Routes$matchers, url);
	if (!_v0.$) {
		var route = _v0.a;
		return route;
	} else {
		return $author$project$Routes$NotFoundRoute;
	}
};
var $author$project$Main$init = F3(
	function (flags, url, navKey) {
		var model = {
			a0: true,
			m: flags,
			aI: $author$project$Material$defaultModel,
			bV: navKey,
			z: $author$project$Main$PageNone,
			b0: 'md.home',
			b6: $author$project$Routes$parseUrl(url)
		};
		return $author$project$Main$loadCurrentPage(
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Main$Mdc = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Internal$Msg$MenuMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $author$project$Internal$Component$subs = F5(
	function (ctor, get, subscriptions, lift, model) {
		return $elm$core$Platform$Sub$batch(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (idx, state, ss) {
						return A2(
							$elm$core$List$cons,
							A2(
								$elm$core$Platform$Sub$map,
								A2(
									$elm$core$Basics$composeL,
									lift,
									ctor(idx)),
								subscriptions(state)),
							ss);
					}),
				_List_Nil,
				get(model)));
	});
var $author$project$Internal$Menu$Model$DocumentClick = {$: 7};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {dm: pids, dH: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {a1: event, c8: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.dm,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.c8;
		var event = _v0.a1;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.dH);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Internal$Menu$Implementation$subscriptions = function (model) {
	return $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($author$project$Internal$Menu$Model$DocumentClick));
};
var $author$project$Internal$Menu$Implementation$subs = A3(
	$author$project$Internal$Component$subs,
	$author$project$Internal$Msg$MenuMsg,
	function ($) {
		return $.t;
	},
	$author$project$Internal$Menu$Implementation$subscriptions);
var $author$project$Internal$Msg$SelectMsg = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Internal$Select$Model$MenuMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Internal$Select$Implementation$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Internal$Select$Model$MenuMsg,
		$author$project$Internal$Menu$Implementation$subscriptions(model.t));
};
var $author$project$Internal$Select$Implementation$subs = A3(
	$author$project$Internal$Component$subs,
	$author$project$Internal$Msg$SelectMsg,
	function ($) {
		return $.cB;
	},
	$author$project$Internal$Select$Implementation$subscriptions);
var $author$project$Material$subscriptions = F2(
	function (lift, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2($author$project$Internal$Menu$Implementation$subs, lift, model.aI),
					A2($author$project$Internal$Select$Implementation$subs, lift, model.aI)
				]));
	});
var $author$project$Pages$Edit$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$FameWall$subscriptions = function (model) {
	return A2($author$project$Material$subscriptions, $author$project$Pages$FameWall$Mdc, model);
};
var $author$project$Pages$List$subscriptions = function (model) {
	return A2($author$project$Material$subscriptions, $author$project$Pages$List$Mdc, model);
};
var $author$project$Pages$Markdown$subscriptions = function (model) {
	return A2($author$project$Material$subscriptions, $author$project$Pages$Markdown$Mdc, model);
};
var $author$project$Pages$Philosophy$Mdc = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Philosophy$subscriptions = function (model) {
	return A2($author$project$Material$subscriptions, $author$project$Pages$Philosophy$Mdc, model);
};
var $author$project$Pages$Project$NoneMsg = {$: 17};
var $author$project$Pages$Project$OnCloseDialog = {$: 12};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Pages$ProjectDialog$keyTrans = F3(
	function (closeMsg, noneMsg, keyCode) {
		if (keyCode === 27) {
			return closeMsg;
		} else {
			return noneMsg;
		}
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Pages$ProjectDialog$subscriptions = F2(
	function (closeMsg, noneMsg) {
		return $elm$browser$Browser$Events$onKeyDown(
			A2(
				$elm$json$Json$Decode$map,
				A2($author$project$Pages$ProjectDialog$keyTrans, closeMsg, noneMsg),
				$elm$html$Html$Events$keyCode));
	});
var $author$project$Pages$Project$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Material$subscriptions, $author$project$Pages$Project$Mdc, model),
				A2($author$project$Pages$ProjectDialog$subscriptions, $author$project$Pages$Project$OnCloseDialog, $author$project$Pages$Project$NoneMsg)
			]));
};
var $author$project$Pages$SourceCode$subscriptions = function (model) {
	return A2($author$project$Material$subscriptions, $author$project$Pages$SourceCode$Mdc, model);
};
var $author$project$Main$subscriptions = function (model) {
	var pageSub = function () {
		var _v0 = model.z;
		switch (_v0.$) {
			case 1:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$ListMsg,
					$author$project$Pages$List$subscriptions(pageModel));
			case 2:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$EditMsg,
					$author$project$Pages$Edit$subscriptions(pageModel));
			case 3:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$MarkdownMsg,
					$author$project$Pages$Markdown$subscriptions(pageModel));
			case 4:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$SourceCodeMsg,
					$author$project$Pages$SourceCode$subscriptions(pageModel));
			case 5:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$ProjectMsg,
					$author$project$Pages$Project$subscriptions(pageModel));
			case 6:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$FameWallMsg,
					$author$project$Pages$FameWall$subscriptions(pageModel));
			case 7:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Main$PhilosophyMsg,
					$author$project$Pages$Philosophy$subscriptions(pageModel));
			default:
				return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Material$subscriptions, $author$project$Main$Mdc, model),
				pageSub
			]));
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Basics$not = _Basics_not;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.du;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.cY,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.dv,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.dn,
					_Utils_ap(http, url.c0)),
				url.dl)));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Internal$Dispatch$forward = function (msgs) {
	return $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Task$perform($elm$core$Basics$identity),
				$elm$core$Task$succeed),
			msgs));
};
var $author$project$Internal$Msg$ButtonMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Idle = {$: 0};
var $author$project$Internal$Ripple$Model$defaultModel = {aA: 0, x: $author$project$Internal$Ripple$Model$Idle, ci: $elm$core$Maybe$Nothing, bP: false};
var $author$project$Internal$Button$Model$defaultModel = {am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Component$indexed = F3(
	function (get_model, set_model, model0) {
		var set_ = F3(
			function (idx, store, model) {
				return A2(
					set_model,
					A3(
						$elm$core$Dict$insert,
						idx,
						model,
						get_model(store)),
					store);
			});
		var get_ = F2(
			function (idx, store) {
				return A2(
					$elm$core$Maybe$withDefault,
					model0,
					A2(
						$elm$core$Dict$get,
						idx,
						get_model(store)));
			});
		return {cZ: get_, eU: set_};
	});
var $author$project$Internal$Button$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cK;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cK: x});
		}),
	$author$project$Internal$Button$Model$defaultModel);
var $author$project$Internal$Component$react = F8(
	function (get, set, ctor, update, lift, msg, idx, store) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$map(
				A2(set, idx, store)),
			A3(
				update,
				A2(
					$elm$core$Basics$composeL,
					lift,
					ctor(idx)),
				msg,
				A2(get, idx, store)));
	});
var $author$project$Internal$Button$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Internal$Helpers$delayedCmd = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $author$project$Internal$Ripple$Model$Activate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Activated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Ripple$Model$ActivationEnded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Ripple$Model$Deactivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Ripple$Model$DeactivationEnded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Ripple$Model$Reactivate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$normalizedEventCoords = F3(
	function (event, pageOffset, clientRect) {
		var _v0 = pageOffset;
		var x = _v0.af;
		var y = _v0.ag;
		var documentX = x + clientRect.af;
		var documentY = x + clientRect.ag;
		var _v1 = event.eK;
		var pageX = _v1.di;
		var pageY = _v1.dj;
		return {af: pageX - documentX, ag: pageY - documentY};
	});
var $author$project$Internal$Ripple$Implementation$fgTranslationCoords = F2(
	function (isUnbounded, _v0) {
		var frame = _v0.Z;
		var activationEvent = _v0.ap;
		var windowPageOffset = _v0.dX;
		var wasActivatedByPointer = _v0.dV;
		var maxDimension = A2($elm$core$Basics$max, frame.dW, frame.c);
		var initialSize = maxDimension * 0.6;
		var startPoint = function () {
			var _v1 = A3($author$project$Internal$Ripple$Implementation$normalizedEventCoords, activationEvent, windowPageOffset, frame);
			var x = _v1.af;
			var y = _v1.ag;
			return {af: x - (initialSize / 2), ag: y - (initialSize / 2)};
		}();
		var endPoint = {af: (frame.dW - initialSize) / 2, ag: (frame.c - initialSize) / 2};
		return {cV: endPoint, dE: startPoint};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Internal$Ripple$Implementation$animateActivation = F4(
	function (isUnbounded, frame, windowPageOffset, activationEvent) {
		var wasActivatedByPointer = true;
		var _v0 = A2(
			$author$project$Internal$Ripple$Implementation$fgTranslationCoords,
			isUnbounded,
			{ap: activationEvent, Z: frame, dV: wasActivatedByPointer, dX: windowPageOffset});
		var startPoint = _v0.dE;
		var endPoint = _v0.cV;
		var translateEnd = isUnbounded ? '' : ($elm$core$String$fromFloat(endPoint.af) + ('px, ' + ($elm$core$String$fromFloat(endPoint.ag) + 'px')));
		var translateStart = isUnbounded ? '' : ($elm$core$String$fromFloat(startPoint.af) + ('px, ' + ($elm$core$String$fromFloat(startPoint.ag) + 'px')));
		return {ad: translateEnd, ae: translateStart};
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Internal$Ripple$Model$numbers = {eb: 225, ep: 150, ew: 0.6, eJ: 10, dM: 300};
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $author$project$Internal$Ripple$Implementation$layoutInternal = F2(
	function (isUnbounded, frame) {
		var maxDim = A2($elm$core$Basics$max, frame.dW, frame.c);
		var initialSize = $elm$core$Basics$floor(maxDim * $author$project$Internal$Ripple$Model$numbers.ew);
		var hypotenuse = $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, frame.dW, 2) + A2($elm$core$Basics$pow, frame.c, 2));
		var boundedRadius = hypotenuse + $author$project$Internal$Ripple$Model$numbers.eJ;
		var maxRadius = isUnbounded ? maxDim : boundedRadius;
		var fgScale = maxRadius / initialSize;
		return {P: fgScale, Q: initialSize};
	});
var $author$project$Internal$Ripple$Implementation$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.x);
		_v0$13:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bP: true}),
						$elm$core$Platform$Cmd$none);
				case 1:
					var _v2 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bP: false}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var _v3 = _v0.a;
					var isUnbounded = _v3.a;
					var clientRect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ci: $elm$core$Maybe$Just(clientRect)
							}),
						$elm$core$Platform$Cmd$none);
				case 2:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var domId = _v4.a;
						var activateData = _v4.b;
						var _v5 = _v0.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Activate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					} else {
						var _v6 = _v0.a;
						var domId = _v6.a;
						var activateData = _v6.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Reactivate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					}
				case 4:
					switch (_v0.b.$) {
						case 1:
							var _v7 = _v0.a;
							var activateData = _v7.a;
							var element = _v7.b;
							var activationEvent = _v0.b.a.ap;
							return _Utils_eq(activateData.a1.a2, activationEvent.a2) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{x: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v8) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 2:
							var _v9 = _v0.a;
							var activateData = _v9.a;
							var element = _v9.b;
							var activationEvent = _v0.b.a.ap;
							return _Utils_eq(activateData.a1.a2, activationEvent.a2) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{x: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v10) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							var _v11 = _v0.a;
							var activateData = _v11.a;
							var element = _v11.b;
							var _v12 = _v0.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{x: $author$project$Internal$Ripple$Model$Idle}),
								A2(
									$elm$core$Task$perform,
									function (_v13) {
										return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
									},
									$elm$core$Task$succeed(0)));
					}
				case 3:
					if (_v0.a.b.$ === 1) {
						var _v14 = _v0.a;
						var activateData = _v14.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var _v15 = _v0.a;
						var activateData = _v15.a;
						var element = _v15.b.a.eg;
						var viewport = _v15.b.a.dU;
						var newAnimationCounter = model.aA + 1;
						var _v16 = A4($author$project$Internal$Ripple$Implementation$animateActivation, activateData.a8, element, viewport, activateData.a1);
						var translateStart = _v16.ae;
						var translateEnd = _v16.ad;
						var _v17 = A2($author$project$Internal$Ripple$Implementation$layoutInternal, activateData.a8, element);
						var fgScale = _v17.P;
						var initialSize = _v17.Q;
						var activatedData = {
							ap: activateData.a1,
							cd: false,
							bJ: false,
							P: fgScale,
							Z: {c: element.c, p: element.af, f: element.ag, dW: element.dW},
							Q: initialSize,
							ad: translateEnd,
							ae: translateStart,
							cH: activateData.cH
						};
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aA: newAnimationCounter,
									x: $author$project$Internal$Ripple$Model$Activated(activatedData)
								}),
							A2(
								$elm$core$Task$perform,
								function (_v18) {
									return $author$project$Internal$Ripple$Model$ActivationEnded(newAnimationCounter);
								},
								$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.eb)));
					}
				case 5:
					if (_v0.b.$ === 1) {
						var animationCount = _v0.a.a;
						var activatedData = _v0.b.a;
						if (_Utils_eq(animationCount, model.aA)) {
							if (activatedData.bJ) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											x: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
										}),
									A2(
										$elm$core$Task$perform,
										function (_v19) {
											return $author$project$Internal$Ripple$Model$DeactivationEnded(model.aA);
										},
										$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.dM)));
							} else {
								var newActivatedData = _Utils_update(
									activatedData,
									{cd: true});
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											x: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
										}),
									$elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$13;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var _v20 = _v0.a;
						var activatedData = _v0.b.a;
						if (activatedData.cd) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										x: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
									}),
								A2(
									$elm$core$Task$perform,
									function (_v21) {
										return $author$project$Internal$Ripple$Model$DeactivationEnded(model.aA);
									},
									$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.dM)));
						} else {
							var newActivatedData = _Utils_update(
								activatedData,
								{bJ: true});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										x: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$13;
					}
				default:
					if (_v0.b.$ === 2) {
						var animationCount = _v0.a.a;
						return _Utils_eq(animationCount, model.aA) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{x: $author$project$Internal$Ripple$Model$Idle}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$13;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Internal$Button$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{am: rippleState})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Button$Model$RippleMsg),
					rippleCmd));
		} else {
			var doRipple = msg.a;
			var msg_ = msg.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Internal$Helpers$delayedCmd,
					doRipple ? 150 : 0,
					msg_));
		}
	});
var $author$project$Internal$Button$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Button$Implementation$getSet.cZ, $author$project$Internal$Button$Implementation$getSet.eU, $author$project$Internal$Msg$ButtonMsg, $author$project$Internal$Button$Implementation$update);
var $author$project$Internal$Msg$CheckboxMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$Checkbox$Model$defaultModel = {bD: $elm$core$Maybe$Nothing, ey: false, bS: $elm$core$Maybe$Nothing};
var $author$project$Internal$Checkbox$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cM;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cM: x});
		}),
	$author$project$Internal$Checkbox$Model$defaultModel);
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Internal$Checkbox$Model$CheckedIndeterminate = 3;
var $author$project$Internal$Checkbox$Model$CheckedUnchecked = 2;
var $author$project$Internal$Checkbox$Model$IndeterminateChecked = 4;
var $author$project$Internal$Checkbox$Model$IndeterminateUnchecked = 5;
var $author$project$Internal$Checkbox$Model$UncheckedChecked = 0;
var $author$project$Internal$Checkbox$Model$UncheckedIndeterminate = 1;
var $author$project$Internal$Checkbox$Implementation$animationState = F2(
	function (oldState, state) {
		var _v0 = _Utils_Tuple2(oldState, state);
		_v0$6:
		while (true) {
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					if (!_v0.b.a) {
						var _v5 = _v0.a;
						var _v6 = _v0.b.a;
						return $elm$core$Maybe$Just(4);
					} else {
						var _v7 = _v0.a;
						var _v8 = _v0.b.a;
						return $elm$core$Maybe$Just(5);
					}
				} else {
					break _v0$6;
				}
			} else {
				if (_v0.a.a === 1) {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a.a;
						var _v2 = _v0.b;
						return $elm$core$Maybe$Just(1);
					} else {
						if (!_v0.b.a) {
							var _v9 = _v0.a.a;
							var _v10 = _v0.b.a;
							return $elm$core$Maybe$Just(0);
						} else {
							break _v0$6;
						}
					}
				} else {
					if (_v0.b.$ === 1) {
						var _v3 = _v0.a.a;
						var _v4 = _v0.b;
						return $elm$core$Maybe$Just(3);
					} else {
						if (_v0.b.a === 1) {
							var _v11 = _v0.a.a;
							var _v12 = _v0.b.a;
							return $elm$core$Maybe$Just(2);
						} else {
							break _v0$6;
						}
					}
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Internal$Checkbox$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 2:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{ey: focus})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var lastKnownState = msg.a;
				var state = msg.b;
				var animation = A2(
					$elm$core$Maybe$andThen,
					function (lastKnownState_) {
						return A2($author$project$Internal$Checkbox$Implementation$animationState, lastKnownState_, state);
					},
					lastKnownState);
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bD: animation,
								bS: $elm$core$Maybe$Just(state)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bD: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Checkbox$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Checkbox$Implementation$getSet.cZ, $author$project$Internal$Checkbox$Implementation$getSet.eU, $author$project$Internal$Msg$CheckboxMsg, $author$project$Internal$Checkbox$Implementation$update);
var $author$project$Internal$Msg$ChipMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Chip$Model$defaultModel = {am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Chip$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cN;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cN: x});
		}),
	$author$project$Internal$Chip$Model$defaultModel);
var $author$project$Internal$Chip$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Chip$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
			var ripple = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{am: ripple})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Chip$Model$RippleMsg),
					cmd));
		} else {
			var msg_ = msg.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2($author$project$Internal$Helpers$delayedCmd, 150, msg_));
		}
	});
var $author$project$Internal$Chip$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Chip$Implementation$getSet.cZ, $author$project$Internal$Chip$Implementation$getSet.eU, $author$project$Internal$Msg$ChipMsg, $author$project$Internal$Chip$Implementation$update);
var $author$project$Internal$Msg$DialogMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Dialog$Model$defaultModel = {aX: false, n: false};
var $author$project$Internal$Dialog$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cQ;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{cQ: x});
		}),
	$author$project$Internal$Dialog$Model$defaultModel);
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Internal$Dialog$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return (!_Utils_eq(isOpen, model.n)) ? _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aX: true, n: isOpen})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aX: false})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Dialog$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Dialog$Implementation$getSet.cZ, $author$project$Internal$Dialog$Implementation$getSet.eU, $author$project$Internal$Msg$DialogMsg, $author$project$Internal$Dialog$Implementation$update);
var $author$project$Internal$Msg$DrawerMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Internal$Drawer$Model$defaultModel = {aX: false, bG: false, n: false};
var $author$project$Internal$Drawer$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cT;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cT: x});
		}),
	$author$project$Internal$Drawer$Model$defaultModel);
var $author$project$Internal$Drawer$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{aX: true, bG: !isOpen, n: true})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								aX: false,
								bG: false,
								n: model.bG ? false : model.n
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Drawer$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Drawer$Implementation$getSet.cZ, $author$project$Internal$Drawer$Implementation$getSet.eU, $author$project$Internal$Msg$DrawerMsg, $author$project$Internal$Drawer$Implementation$update);
var $author$project$Internal$Msg$FabMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Internal$Component$generalise = F4(
	function (update, lift, msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(update, msg, model)));
	});
var $author$project$Internal$Fab$Model$defaultModel = {am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Fab$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cW;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cW: x});
		}),
	$author$project$Internal$Fab$Model$defaultModel);
var $author$project$Internal$Fab$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Fab$Implementation$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{am: rippleState}),
				A2($elm$core$Platform$Cmd$map, $author$project$Internal$Fab$Model$RippleMsg, rippleCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Fab$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Fab$Implementation$getSet.cZ,
	$author$project$Internal$Fab$Implementation$getSet.eU,
	$author$project$Internal$Msg$FabMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Fab$Implementation$update));
var $author$project$Internal$Msg$IconButtonMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Internal$IconButton$Model$defaultModel = {h: false, am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$IconButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.c2;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{c2: x});
		}),
	$author$project$Internal$IconButton$Model$defaultModel);
var $author$project$Internal$IconButton$Model$RippleMsg = $elm$core$Basics$identity;
var $author$project$Internal$IconButton$Implementation$update = F2(
	function (msg, model) {
		var msg_ = msg;
		var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
		var ripple = _v1.a;
		var effects = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{am: ripple}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, effects));
	});
var $author$project$Internal$IconButton$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$IconButton$Implementation$getSet.cZ,
	$author$project$Internal$IconButton$Implementation$getSet.eU,
	$author$project$Internal$Msg$IconButtonMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$IconButton$Implementation$update));
var $author$project$Internal$Msg$ListMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Internal$List$Model$defaultModel = {bP: $elm$core$Maybe$Nothing, bk: $elm$core$Dict$empty};
var $author$project$Internal$List$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dc;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dc: x});
		}),
	$author$project$Internal$List$Model$defaultModel);
var $author$project$Internal$List$Model$NoOp = {$: 0};
var $author$project$Internal$List$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Internal$List$Implementation$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$List$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 1:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bk)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bk: A3($elm$core$Dict$insert, index, ripple, model.bk)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$List$Model$RippleMsg(index)),
						effects));
			case 3:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bP: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 2:
				var id = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bP: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return lift($author$project$Internal$List$Model$NoOp);
						},
						$elm$browser$Browser$Dom$focus(id)));
			case 4:
				var index = msg.a;
				var m = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bP: $elm$core$Maybe$Nothing})),
					$author$project$Internal$List$Implementation$send(
						m(index)));
			default:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$List$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$List$Implementation$getSet.cZ, $author$project$Internal$List$Implementation$getSet.eU, $author$project$Internal$Msg$ListMsg, $author$project$Internal$List$Implementation$update);
var $author$project$Internal$Menu$Model$defaultModel = {aX: false, as: $elm$core$Maybe$Nothing, aG: $elm$core$Maybe$Nothing, cs: false, dc: $author$project$Internal$List$Model$defaultModel, n: false, K: $elm$core$Maybe$Nothing};
var $author$project$Internal$Menu$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.t;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{t: x});
		}),
	$author$project$Internal$Menu$Model$defaultModel);
var $author$project$Internal$Menu$Model$AnimationEnd = {$: 2};
var $author$project$Internal$Menu$Model$Close = {$: 4};
var $author$project$Internal$Menu$Model$ListMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Internal$Menu$Model$NoOp = {$: 0};
var $author$project$Internal$Menu$Model$Open = {$: 3};
var $author$project$Internal$Menu$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					var $temp$lift = lift,
						$temp$msg = model.n ? $author$project$Internal$Menu$Model$Close : $author$project$Internal$Menu$Model$Open,
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 3:
					return (!model.n) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aX: true, as: $elm$core$Maybe$Nothing, n: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 4:
					return model.n ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aX: true, n: false})),
						A2($elm$core$Maybe$withDefault, false, model.K) ? A2(
							$author$project$Internal$Helpers$delayedCmd,
							70,
							lift($author$project$Internal$Menu$Model$AnimationEnd)) : A2(
							$author$project$Internal$Helpers$delayedCmd,
							0,
							lift($author$project$Internal$Menu$Model$AnimationEnd))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Internal$Helpers$delayedCmd,
							50,
							lift($author$project$Internal$Menu$Model$Close)));
				case 1:
					var config = msg.a;
					var geometry = msg.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry),
									K: $elm$core$Maybe$Just(config.K)
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									function (_v1) {
										return lift($author$project$Internal$Menu$Model$NoOp);
									},
									$elm$browser$Browser$Dom$focus(config.cX)),
									config.K ? A2(
									$author$project$Internal$Helpers$delayedCmd,
									120,
									lift($author$project$Internal$Menu$Model$AnimationEnd)) : A2(
									$author$project$Internal$Helpers$delayedCmd,
									0,
									lift($author$project$Internal$Menu$Model$AnimationEnd))
								])));
				case 2:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aX: false})),
						$elm$core$Platform$Cmd$none);
				case 7:
					if (model.n && (!_Utils_eq(model.as, $elm$core$Maybe$Nothing))) {
						var $temp$lift = lift,
							$temp$msg = $author$project$Internal$Menu$Model$Close,
							$temp$model = model;
						lift = $temp$lift;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				case 8:
					var shiftKey = msg.a.cD;
					var altKey = msg.a.ce;
					var ctrlKey = msg.a.cm;
					var metaKey = msg.a.cw;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return (isEscape || (isSpace || isEnter)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{cs: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 9:
					var shiftKey = msg.a.cD;
					var altKey = msg.a.ce;
					var ctrlKey = msg.a.cm;
					var metaKey = msg.a.cw;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$map(
							function (newModel) {
								return _Utils_update(
									newModel,
									{cs: false});
							}),
						((isEscape || (isSpace || isEnter)) && ((!(altKey || (ctrlKey || metaKey))) && model.cs)) ? A3($author$project$Internal$Menu$Implementation$update, lift, $author$project$Internal$Menu$Model$Close, model) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none));
				default:
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (maybeNewList) {
							if (!maybeNewList.$) {
								var newList = maybeNewList.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										model,
										{dc: newList}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A3(
							$author$project$Internal$List$Implementation$update,
							A2($elm$core$Basics$composeL, lift, $author$project$Internal$Menu$Model$ListMsg),
							msg_,
							model.dc));
			}
		}
	});
var $author$project$Internal$Menu$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Menu$Implementation$getSet.cZ, $author$project$Internal$Menu$Implementation$getSet.eU, $author$project$Internal$Msg$MenuMsg, $author$project$Internal$Menu$Implementation$update);
var $author$project$Internal$Msg$RadioButtonMsg = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Internal$RadioButton$Model$defaultModel = {ey: false, am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$RadioButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dw;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dw: x});
		}),
	$author$project$Internal$RadioButton$Model$defaultModel);
var $author$project$Internal$RadioButton$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$RadioButton$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{am: ripple})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$RadioButton$Model$RippleMsg),
						effects));
			case 1:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{ey: focus})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$RadioButton$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$RadioButton$Implementation$getSet.cZ, $author$project$Internal$RadioButton$Implementation$getSet.eU, $author$project$Internal$Msg$RadioButtonMsg, $author$project$Internal$RadioButton$Implementation$update);
var $author$project$Internal$Msg$RippleMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.am;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{am: x});
		}),
	$author$project$Internal$Ripple$Model$defaultModel);
var $author$project$Internal$Ripple$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Ripple$Implementation$getSet.cZ,
	$author$project$Internal$Ripple$Implementation$getSet.eU,
	$author$project$Internal$Msg$RippleMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Ripple$Implementation$update));
var $author$project$Internal$Select$Model$defaultModel = {bP: false, c6: false, t: $author$project$Internal$Menu$Model$defaultModel, am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Select$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.cB;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{cB: x});
		}),
	$author$project$Internal$Select$Model$defaultModel);
var $author$project$Internal$Select$Model$NoOp = {$: 0};
var $author$project$Internal$Select$Model$OpenMenu = function (a) {
	return {$: 6, a: a};
};
var $author$project$Internal$Select$Model$RippleMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Internal$Menu$Model$Toggle = {$: 5};
var $author$project$Internal$Helpers$cmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$Select$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 3:
					var changedValue = msg.a;
					var dirty = changedValue !== '';
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{c6: dirty})),
						$elm$core$Platform$Cmd$none);
				case 1:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bP: false})),
						$elm$core$Platform$Cmd$none);
				case 2:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bP: true})),
						$elm$core$Platform$Cmd$none);
				case 4:
					var msg_ = msg.a;
					var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
					var ripple = _v1.a;
					var effects = _v1.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{am: ripple})),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, lift, $author$project$Internal$Select$Model$RippleMsg),
							effects));
				case 5:
					var menuIndex = msg.a;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return (isEscape || (isSpace || isEnter)) ? _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Internal$Helpers$delayedCmd,
							16,
							lift(
								$author$project$Internal$Select$Model$OpenMenu(menuIndex)))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					var menuIndex = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$author$project$Internal$Helpers$cmd(
							lift(
								$author$project$Internal$Select$Model$MenuMsg($author$project$Internal$Menu$Model$Open))));
				case 7:
					var $temp$lift = lift,
						$temp$msg = $author$project$Internal$Select$Model$MenuMsg($author$project$Internal$Menu$Model$Toggle),
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 8:
					var index = msg.a;
					var onSelect_ = msg.b;
					var v = msg.c;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Internal$Helpers$cmd(
									onSelect_(v)),
									A2(
									$elm$core$Task$attempt,
									function (_v2) {
										return lift($author$project$Internal$Select$Model$NoOp);
									},
									$elm$browser$Browser$Dom$focus(index))
								])));
				default:
					var msg_ = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (maybeNewMenu) {
							if (!maybeNewMenu.$) {
								var newMenu = maybeNewMenu.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										model,
										{t: newMenu}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A3(
							$author$project$Internal$Menu$Implementation$update,
							A2($elm$core$Basics$composeL, lift, $author$project$Internal$Select$Model$MenuMsg),
							msg_,
							model.t));
			}
		}
	});
var $author$project$Internal$Select$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Select$Implementation$getSet.cZ, $author$project$Internal$Select$Implementation$getSet.eU, $author$project$Internal$Msg$SelectMsg, $author$project$Internal$Select$Implementation$update);
var $author$project$Internal$Msg$SliderMsg = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Internal$Slider$Model$defaultModel = {M: false, aV: $elm$core$Maybe$Nothing, bO: false, as: $elm$core$Maybe$Nothing, a5: false, b1: false};
var $author$project$Internal$Slider$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dD;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dD: x});
		}),
	$author$project$Internal$Slider$Model$defaultModel);
var $author$project$Internal$Slider$Model$ActualUp = {$: 11};
var $author$project$Internal$Slider$Model$Init = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Slider$Model$defaultGeometry = {
	Y: false,
	j: 100,
	e: 0,
	bj: {p: 0, dW: 0},
	T: $elm$core$Maybe$Nothing
};
var $author$project$Internal$Slider$Implementation$valueFromPageX = F2(
	function (geometry, pageX) {
		var xPos = pageX - geometry.bj.p;
		var isRtl = false;
		var pctComplete = isRtl ? (1 - (xPos / geometry.bj.dW)) : (xPos / geometry.bj.dW);
		return geometry.e + (pctComplete * (geometry.j - geometry.e));
	});
var $author$project$Internal$Slider$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					return (!model.b1) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bO: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bO: false, b1: false})),
						$elm$core$Platform$Cmd$none);
				case 8:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{a5: false})),
						$elm$core$Platform$Cmd$none);
				case 3:
					var pageX = msg.b.di;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									M: true,
									aV: $elm$core$Maybe$Just(activeValue),
									a5: true,
									b1: true
								})),
						$elm$core$Platform$Cmd$none);
				case 7:
					var pageX = msg.b.di;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									M: true,
									aV: $elm$core$Maybe$Just(activeValue),
									a5: false,
									b1: true
								})),
						$elm$core$Platform$Cmd$none);
				case 9:
					var pageX = msg.a.di;
					if (model.M) {
						var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.as);
						var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_update(
									model,
									{
										aV: $elm$core$Maybe$Just(activeValue),
										a5: false
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var geometry = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry)
								})),
						$elm$core$Platform$Cmd$none);
				case 2:
					var geometry = msg.a;
					var $temp$lift = lift,
						$temp$msg = $author$project$Internal$Slider$Model$Init(geometry),
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{bO: true})),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(model),
						A2(
							$elm$core$Task$perform,
							lift,
							$elm$core$Task$succeed($author$project$Internal$Slider$Model$ActualUp)));
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{M: false, aV: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Internal$Slider$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Slider$Implementation$getSet.cZ, $author$project$Internal$Slider$Implementation$getSet.eU, $author$project$Internal$Msg$SliderMsg, $author$project$Internal$Slider$Implementation$update);
var $author$project$Internal$Msg$SnackbarMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Internal$Snackbar$Model$Inert = {$: 0};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Internal$Snackbar$Model$defaultModel = {n: false, b3: _List_Nil, aO: -1, b9: $author$project$Internal$Snackbar$Model$Inert};
var $author$project$Internal$Snackbar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.bq;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{bq: x});
		}),
	$author$project$Internal$Snackbar$Model$defaultModel);
var $author$project$Internal$Snackbar$Model$Clicked = 1;
var $author$project$Internal$Snackbar$Model$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Snackbar$Model$Fading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Snackbar$Model$Timeout = 0;
var $author$project$Internal$Snackbar$Implementation$next = function (model) {
	return $elm$core$Platform$Cmd$map(
		$author$project$Internal$Snackbar$Model$Move(model.aO));
};
var $author$project$Internal$Snackbar$Model$Active = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Snackbar$Implementation$tryDequeue = function (model) {
	var _v0 = _Utils_Tuple2(model.b9, model.b3);
	if ((!_v0.a.$) && _v0.b.b) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var c = _v2.a;
		var cs = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					n: false,
					b3: cs,
					aO: model.aO + 1,
					b9: $author$project$Internal$Snackbar$Model$Active(c)
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Internal$Snackbar$Model$Move(model.aO + 1),
				A2($author$project$Internal$Helpers$delayedCmd, c.cG, 0)));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Internal$Snackbar$Implementation$move = F2(
	function (transition, model) {
		var _v0 = _Utils_Tuple2(model.b9, transition);
		if (_v0.b === 1) {
			if (_v0.a.$ === 1) {
				var contents = _v0.a.a;
				var _v3 = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b9: $author$project$Internal$Snackbar$Model$Fading(contents)
						}),
					A2(
						$author$project$Internal$Snackbar$Implementation$next,
						model,
						A2($author$project$Internal$Helpers$delayedCmd, contents.bN, 0)));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Internal$Snackbar$Implementation$tryDequeue(model);
				case 1:
					var contents = _v0.a.a;
					var _v4 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b9: $author$project$Internal$Snackbar$Model$Fading(contents)
							}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							A2($author$project$Internal$Helpers$delayedCmd, contents.bN, 0)));
				default:
					var contents = _v0.a.a;
					var _v5 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b9: $author$project$Internal$Snackbar$Model$Inert}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							$author$project$Internal$Helpers$cmd(0)));
			}
		}
	});
var $author$project$Internal$Snackbar$Implementation$update = F3(
	function (fwd, msg, model) {
		switch (msg.$) {
			case 0:
				var seq = msg.a;
				var transition = msg.b;
				return _Utils_eq(seq, model.aO) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(fwd),
					A2($author$project$Internal$Snackbar$Implementation$move, transition, model)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var dismissOnAction = msg.a;
				var actionOnDismiss = msg.b;
				var fwdEffect = function () {
					if (!actionOnDismiss.$) {
						var msg_ = actionOnDismiss.a;
						return $author$project$Internal$Helpers$cmd(msg_);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, fwdEffect]));
					},
					dismissOnAction ? A3(
						$author$project$Internal$Snackbar$Implementation$update,
						fwd,
						A2($author$project$Internal$Snackbar$Model$Move, model.aO, 1),
						model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{n: true}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Snackbar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Snackbar$Implementation$getSet.cZ,
	$author$project$Internal$Snackbar$Implementation$getSet.eU,
	$author$project$Internal$Msg$SnackbarMsg,
	F3(
		function (fwd, msg, model) {
			return A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A3($author$project$Internal$Snackbar$Implementation$update, fwd, msg, model));
		}));
var $author$project$Internal$Msg$SwitchMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Internal$Switch$Model$defaultModel = {ey: false, am: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Switch$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dI;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dI: x});
		}),
	$author$project$Internal$Switch$Model$defaultModel);
var $author$project$Internal$Switch$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Switch$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.am);
				var rippleState = _v1.a;
				var rippleCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{am: rippleState}),
					A2($elm$core$Platform$Cmd$map, $author$project$Internal$Switch$Model$RippleMsg, rippleCmd));
			case 1:
				var focus = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ey: focus}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Switch$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Switch$Implementation$getSet.cZ,
	$author$project$Internal$Switch$Implementation$getSet.eU,
	$author$project$Internal$Msg$SwitchMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Switch$Implementation$update));
var $author$project$Internal$Msg$TabBarMsg = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Internal$TabBar$Model$defaultModel = {r: 0, as: $elm$core$Maybe$Nothing, bk: $elm$core$Dict$empty, dT: 0};
var $author$project$Internal$TabBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dK;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dK: x});
		}),
	$author$project$Internal$TabBar$Model$defaultModel);
var $author$project$Internal$TabBar$Model$NoOp = {$: 0};
var $author$project$Internal$TabBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Internal$TabBar$Implementation$calculateScrollIncrement = F5(
	function (geometry, index, nextIndex, scrollPosition, barWidth) {
		var maybe_next_tab = $elm$core$List$head(
			A2($elm$core$List$drop, nextIndex, geometry.bs));
		var extraScrollAmount = 20;
		if (!maybe_next_tab.$) {
			var next_tab = maybe_next_tab.a;
			var relativeContentRight = next_tab.cl - scrollPosition;
			var relativeContentLeft = (next_tab.ck - scrollPosition) - barWidth;
			var rightIncrement = relativeContentLeft + extraScrollAmount;
			var leftIncrement = relativeContentRight - extraScrollAmount;
			return (_Utils_cmp(nextIndex, index) < 0) ? A2($elm$core$Basics$min, leftIncrement, 0) : A2($elm$core$Basics$max, rightIncrement, 0);
		} else {
			return 0;
		}
	});
var $author$project$Internal$TabBar$Model$defaultGeometry = {
	dB: {I: 0},
	dJ: {I: 0},
	bs: _List_Nil
};
var $author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge = F4(
	function (index, tab_, scrollPosition, barWidth) {
		var rootRight = tab_.aJ + tab_.I;
		var rootLeft = tab_.aJ;
		var relativeRootRight = (rootRight - scrollPosition) - barWidth;
		var relativeRootLeft = rootLeft - scrollPosition;
		var relativeRootDelta = relativeRootLeft + relativeRootRight;
		var rightEdgeIsCloser = (relativeRootRight > 0) || (relativeRootDelta > 0);
		var leftEdgeIsCloser = (relativeRootLeft < 0) || (relativeRootDelta < 0);
		return leftEdgeIsCloser ? (index - 1) : (rightEdgeIsCloser ? (index + 1) : (-1));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Internal$TabBar$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bk)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bk: A3($elm$core$Dict$insert, index, ripple, model.bk)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$TabBar$Model$RippleMsg(index)),
						effects));
			case 1:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 3:
				var geometry = msg.a;
				return _Utils_Tuple2(
					function () {
						var tabBarWidth = geometry.dJ.I;
						var scrollAreaWidth = geometry.dB.I;
						var isOverflowing = _Utils_cmp(tabBarWidth, scrollAreaWidth) > 0;
						var translateOffset = (!isOverflowing) ? 0 : model.dT;
						return $elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									as: $elm$core$Maybe$Just(geometry),
									dT: translateOffset
								}));
					}(),
					$elm$core$Platform$Cmd$none);
			default:
				var domId = msg.a;
				var tab_index = msg.b;
				var scrollPosition = msg.c;
				var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$TabBar$Model$defaultGeometry, model.as);
				var tabAtIndex = function (i) {
					return A2(
						$elm$core$Maybe$withDefault,
						{ck: 0, cl: 0, aJ: 0, I: 0},
						$elm$core$List$head(
							A2($elm$core$List$drop, i, geometry.bs)));
				};
				var tab_ = tabAtIndex(tab_index);
				var barWidth = geometry.dJ.I;
				var next_tab_index = A4($author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge, tab_index, tab_, scrollPosition, barWidth);
				var scrollIncrement = A5($author$project$Internal$TabBar$Implementation$calculateScrollIncrement, geometry, tab_index, next_tab_index, scrollPosition, barWidth);
				var newScrollPosition = (!tab_index) ? 0 : (_Utils_eq(
					tab_index,
					$elm$core$List$length(geometry.bs) - 1) ? geometry.dB.I : (scrollPosition + scrollIncrement));
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{r: tab_index})),
					A2(
						$elm$core$Task$perform,
						lift,
						A2(
							$elm$core$Task$onError,
							function (_v3) {
								return $elm$core$Task$succeed($author$project$Internal$TabBar$Model$NoOp);
							},
							A2(
								$elm$core$Task$map,
								function (_v2) {
									return $author$project$Internal$TabBar$Model$NoOp;
								},
								A3($elm$browser$Browser$Dom$setViewportOf, domId + '__scroll-area', newScrollPosition, 0)))));
		}
	});
var $author$project$Internal$TabBar$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TabBar$Implementation$getSet.cZ, $author$project$Internal$TabBar$Implementation$getSet.eU, $author$project$Internal$Msg$TabBarMsg, $author$project$Internal$TabBar$Implementation$update);
var $author$project$Internal$Msg$TextFieldMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Internal$TextField$Model$defaultModel = {bP: false, as: $elm$core$Maybe$Nothing, c6: false, bC: $elm$core$Maybe$Nothing};
var $author$project$Internal$TextField$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dO;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{dO: x});
		}),
	$author$project$Internal$TextField$Model$defaultModel);
var $author$project$Internal$TextField$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var str = msg.a;
				var dirty = str !== '';
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								c6: dirty,
								bC: $elm$core$Maybe$Just(str)
							})),
					$elm$core$Platform$Cmd$none);
			case 0:
				var geometry = function () {
					var _v1 = model.bC;
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						return model.as;
					}
				}();
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bP: false, as: geometry})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var geometry = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								bP: true,
								as: $elm$core$Maybe$Just(geometry)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TextField$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TextField$Implementation$getSet.cZ, $author$project$Internal$TextField$Implementation$getSet.eU, $author$project$Internal$Msg$TextFieldMsg, $author$project$Internal$TextField$Implementation$update);
var $author$project$Internal$Msg$TopAppBarMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Internal$TopAppBar$Model$defaultModel = {X: 0, c7: true, ba: $elm$core$Maybe$Nothing, bk: $elm$core$Dict$empty, dG: $elm$core$Maybe$Nothing, L: $elm$core$Maybe$Nothing, cb: true};
var $author$project$Internal$TopAppBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.dR;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{dR: x});
		}),
	$author$project$Internal$TopAppBar$Model$defaultModel);
var $author$project$Internal$TopAppBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Internal$TopAppBar$Implementation$checkForUpdate = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (topAppBarHeight) {
			var offscreenBoundaryTop = -topAppBarHeight;
			var hasAnyPixelsOnscreen = _Utils_cmp(model.X, offscreenBoundaryTop) > 0;
			var hasAnyPixelsOffscreen = model.X < 0;
			var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
			return partiallyShowing ? _Utils_Tuple2(
				_Utils_update(
					model,
					{cb: false}),
				true) : ((!model.cb) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{cb: true}),
				true) : ((!_Utils_eq(model.c7, hasAnyPixelsOnscreen)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{c7: hasAnyPixelsOnscreen}),
				true) : _Utils_Tuple2(model, false)));
		},
		model.L);
};
var $author$project$Internal$TopAppBar$Implementation$moveTopAppBar = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var updatedModel = _v0.a;
			var partiallyShowing = _v0.b;
			return partiallyShowing ? A2(
				$elm$core$Maybe$map,
				function (topAppBarHeight) {
					var styleTop = function () {
						var maxTopAppBarHeight = 128;
						return (_Utils_cmp(
							$elm$core$Basics$abs(updatedModel.X),
							topAppBarHeight) > 0) ? (-maxTopAppBarHeight) : updatedModel.X;
					}();
					return _Utils_update(
						updatedModel,
						{
							dG: $elm$core$Maybe$Just(styleTop)
						});
				},
				updatedModel.L) : $elm$core$Maybe$Just(updatedModel);
		},
		$author$project$Internal$TopAppBar$Implementation$checkForUpdate(model));
};
var $author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler = F2(
	function (scrollPosition, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Internal$TopAppBar$Implementation$moveTopAppBar,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var topAppBarHeight = _v0.a;
						var lastScrollPosition = _v0.b;
						var isCurrentlyBeingResized = false;
						var currentScrollPosition = A2($elm$core$Basics$max, scrollPosition, 0);
						var diff = currentScrollPosition - lastScrollPosition;
						var currentAppBarOffsetTop = model.X - diff;
						var updatedAppBarOffsetTop = (!isCurrentlyBeingResized) ? ((currentAppBarOffsetTop > 0) ? 0 : ((_Utils_cmp(
							$elm$core$Basics$abs(currentAppBarOffsetTop),
							topAppBarHeight) > 0) ? (-topAppBarHeight) : currentAppBarOffsetTop)) : model.X;
						var updatedModel = _Utils_update(
							model,
							{
								X: updatedAppBarOffsetTop,
								ba: $elm$core$Maybe$Just(currentScrollPosition)
							});
						return A2(
							$elm$core$Maybe$withDefault,
							updatedModel,
							$author$project$Internal$TopAppBar$Implementation$moveTopAppBar(updatedModel));
					},
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (topAppBarHeight, lastScrollPosition) {
								return _Utils_Tuple2(topAppBarHeight, lastScrollPosition);
							}),
						model.L,
						model.ba))));
	});
var $author$project$Internal$TopAppBar$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.bk)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bk: A3($elm$core$Dict$insert, index, ripple, model.bk)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Internal$TopAppBar$Model$RippleMsg(index),
						effects));
			case 1:
				var scrollPosition = msg.a.ax;
				var topAppBarHeight = msg.a.L;
				return _Utils_Tuple2(
					A2(
						$author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler,
						scrollPosition,
						_Utils_update(
							model,
							{
								ba: $elm$core$Maybe$Just(scrollPosition),
								L: $elm$core$Maybe$Just(topAppBarHeight)
							})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var scrollPosition = msg.a.ax;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, model),
					$elm$core$Platform$Cmd$none);
			default:
				var scrollPosition = msg.a.ax;
				var topAppBarHeight = msg.a.L;
				var currentHeight = topAppBarHeight;
				var currentAppBarOffsetTop = model.X - (topAppBarHeight - currentHeight);
				var updatedModel = (!_Utils_eq(
					$elm$core$Maybe$Just(topAppBarHeight),
					model.L)) ? _Utils_update(
					model,
					{
						X: currentAppBarOffsetTop,
						L: $elm$core$Maybe$Just(currentHeight),
						cb: false
					}) : model;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, updatedModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TopAppBar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$TopAppBar$Implementation$getSet.cZ,
	$author$project$Internal$TopAppBar$Implementation$getSet.eU,
	$author$project$Internal$Msg$TopAppBarMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$TopAppBar$Implementation$update));
var $author$project$Material$update_ = F3(
	function (lift, msg, store) {
		switch (msg.$) {
			case 0:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 1:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Button$Implementation$react, lift, msg_, idx, store);
			case 2:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Checkbox$Implementation$react, lift, msg_, idx, store);
			case 3:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Chip$Implementation$react, lift, msg_, idx, store);
			case 4:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Dialog$Implementation$react, lift, msg_, idx, store);
			case 5:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Drawer$Implementation$react, lift, msg_, idx, store);
			case 6:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Fab$Implementation$react, lift, msg_, idx, store);
			case 7:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$IconButton$Implementation$react, lift, msg_, idx, store);
			case 8:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$List$Implementation$react, lift, msg_, idx, store);
			case 9:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Menu$Implementation$react, lift, msg_, idx, store);
			case 10:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$RadioButton$Implementation$react, lift, msg_, idx, store);
			case 11:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Ripple$Implementation$react, lift, msg_, idx, store);
			case 12:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Select$Implementation$react, lift, msg_, idx, store);
			case 13:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Slider$Implementation$react, lift, msg_, idx, store);
			case 14:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Snackbar$Implementation$react, lift, msg_, idx, store);
			case 15:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Switch$Implementation$react, lift, msg_, idx, store);
			case 16:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TabBar$Implementation$react, lift, msg_, idx, store);
			case 17:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TextField$Implementation$react, lift, msg_, idx, store);
			default:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TopAppBar$Implementation$react, lift, msg_, idx, store);
		}
	});
var $author$project$Material$update = F3(
	function (lift, msg, container) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$withDefault(container),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$map(
					function (mdc) {
						return _Utils_update(
							container,
							{aI: mdc});
					}),
				A3(
					$author$project$Material$update_,
					lift,
					msg,
					function ($) {
						return $.aI;
					}(container))));
	});
var $author$project$Shared$Failure = {$: 3};
var $author$project$Shared$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Edit$OnPlayerSave = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Player$encode = function (player) {
	var attributes = _List_fromArray(
		[
			_Utils_Tuple2(
			'id',
			$elm$json$Json$Encode$string(player.et)),
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(player.eF)),
			_Utils_Tuple2(
			'level',
			$elm$json$Json$Encode$int(player.ct))
		]);
	return $elm$json$Json$Encode$object(attributes);
};
var $elm$http$Http$Internal$StringBody = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		$elm$http$Http$Internal$StringBody,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Pages$Edit$savePlayerUrl = F2(
	function (flags, playerId) {
		return flags.cJ + ('/players/' + playerId);
	});
var $author$project$Pages$Edit$savePlayerRequest = F2(
	function (flags, player) {
		return $elm$http$Http$request(
			{
				d0: $elm$http$Http$jsonBody(
					$author$project$Player$encode(player)),
				ej: $elm$http$Http$expectJson($author$project$Player$decoder),
				er: _List_Nil,
				eC: 'PATCH',
				cG: $elm$core$Maybe$Nothing,
				e5: A2($author$project$Pages$Edit$savePlayerUrl, flags, player.et),
				fc: false
			});
	});
var $author$project$Pages$Edit$savePlayer = F2(
	function (flags, player) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Edit$OnPlayerSave,
			A2($author$project$Pages$Edit$savePlayerRequest, flags, player));
	});
var $author$project$Pages$Edit$update = F3(
	function (flags, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var player = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aM: $author$project$Shared$Loaded(player)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aM: $author$project$Shared$Failure}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var player = msg.a;
				var howMuch = msg.b;
				var updatedPlayer = _Utils_update(
					player,
					{ct: player.ct + howMuch});
				return _Utils_Tuple2(
					model,
					A2($author$project$Pages$Edit$savePlayer, flags, updatedPlayer));
			default:
				if (!msg.a.$) {
					var player = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aM: $author$project$Shared$Loaded(player)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$ProjectDialog$Trailor = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$ProjectCardView$gen_demo_url_prefix = F3(
	function (flags, year, name) {
		return flags.cJ + (flags.dp + ('/demo/' + ($elm$core$String$fromInt(year + 2019) + ('/' + name))));
	});
var $author$project$Ports$openWindow = _Platform_outgoingPort('openWindow', $elm$json$Json$Encode$string);
var $author$project$Pages$ProjectCardView$openBookletCmd = F3(
	function (flags, year, name) {
		return $author$project$Ports$openWindow(
			A3($author$project$Pages$ProjectCardView$gen_demo_url_prefix, flags, year, name) + '/doc/booklet.pdf');
	});
var $author$project$Pages$ProjectCardView$gen_elm_doc_url = F3(
	function (flags, year, name) {
		return flags.cJ + (flags.dp + ('/elm-doc/' + ($elm$core$String$fromInt(year + 2019) + ('/' + name))));
	});
var $author$project$Pages$ProjectCardView$openDocCmd = F3(
	function (flags, year, name) {
		return $author$project$Ports$openWindow(
			A3($author$project$Pages$ProjectCardView$gen_elm_doc_url, flags, year, name));
	});
var $author$project$Pages$ProjectCardView$openPlayCmd = F3(
	function (flags, year, name) {
		return $author$project$Ports$openWindow(
			A3($author$project$Pages$ProjectCardView$gen_demo_url_prefix, flags, year, name) + '/');
	});
var $author$project$Pages$ProjectCardView$openPosterCmd = F3(
	function (flags, year, name) {
		return $author$project$Ports$openWindow(
			A3($author$project$Pages$ProjectCardView$gen_demo_url_prefix, flags, year, name) + '/doc/poster.pdf');
	});
var $author$project$Pages$FameWall$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var msg_ = msg.a;
				return A3($author$project$Material$update, $author$project$Pages$FameWall$Mdc, msg_, model);
			case 0:
				if (!msg.a.$) {
					var contents = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bI: contents}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openPlayCmd, model.m, year, name));
			case 3:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cQ: A2($author$project$Pages$ProjectDialog$Trailor, year, name)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cQ: $author$project$Pages$ProjectDialog$Closed}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openPosterCmd, model.m, year, name));
			case 5:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openBookletCmd, model.m, year, name));
			case 6:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openDocCmd, model.m, year, name));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$List$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var msg_ = msg.a;
				return A3($author$project$Material$update, $author$project$Pages$List$Mdc, msg_, model);
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				if (!msg.a.$) {
					var players = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bi: $author$project$Shared$Loaded(players)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bi: $author$project$Shared$Failure}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bM: !model.bM}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Markdown$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var msg_ = msg.a;
			return A3($author$project$Material$update, $author$project$Pages$Markdown$Mdc, msg_, model);
		} else {
			if (!msg.a.$) {
				var markdown = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cv: markdown}),
					$elm$core$Platform$Cmd$none);
			} else {
				var err = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cv: '# Sorry, Page not Exist!'}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Pages$Wheel$drawWheel = _Platform_outgoingPort(
	'drawWheel',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)(b)
				]));
	});
var $author$project$Pages$Philosophy$initWheel = F2(
	function (cellName, contents) {
		return $author$project$Pages$Wheel$drawWheel(
			_Utils_Tuple2(cellName, contents));
	});
var $author$project$Pages$Philosophy$initWheels = function (cells) {
	var helper = function (x) {
		switch (x.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var cellName = x.a;
				var contents = x.b;
				return A2($author$project$Pages$Philosophy$initWheel, cellName, contents);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	};
	return $elm$core$Platform$Cmd$batch(
		A2($elm$core$List$map, helper, cells));
};
var $author$project$Pages$Philosophy$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var msg_ = msg.a;
			return A3($author$project$Material$update, $author$project$Pages$Philosophy$Mdc, msg_, model);
		} else {
			if (!msg.a.$) {
				var cells = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bI: cells}),
					$author$project$Pages$Philosophy$initWheels(cells));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Pages$ProjectDialog$Bulk = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectDialog$Compressing = 0;
var $author$project$Pages$ProjectDialog$Log = {$: 2};
var $author$project$Pages$Project$OnBuildProject = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Project$buildProject = F4(
	function (flags, year, name, branch) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Project$OnBuildProject(year),
			A2(
				$elm$http$Http$get,
				flags.cJ + (flags.dp + ('/api/project/build/' + ($elm$core$String$fromInt(year) + ('/' + (name + ('/' + branch)))))),
				$author$project$Project$decoder));
	});
var $author$project$Project$defaultSpecAvail = {B: false, eQ: ''};
var $author$project$Project$defaultAvailability = {d1: $author$project$Project$defaultSpecAvail, eh: $author$project$Project$defaultSpecAvail, eL: $author$project$Project$defaultSpecAvail, eN: $author$project$Project$defaultSpecAvail, dP: $author$project$Project$defaultSpecAvail, e0: $author$project$Project$defaultSpecAvail};
var $author$project$Project$defaultProject = {d_: 'unknown', B: $author$project$Project$defaultAvailability, cf: true, d9: -1, eF: 'unknown', eW: 'fail', eX: $elm$core$Maybe$Nothing, eY: $elm$core$Maybe$Nothing, bv: 'unknown', ao: 0};
var $author$project$Pages$Project$OnFetchBulkDownload = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Project$fetchBulkDownload = F3(
	function (flags, year, projectName) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Project$OnFetchBulkDownload,
			A2(
				$elm$http$Http$get,
				flags.cJ + (flags.dp + ('/api/project/download_start/' + ($elm$core$String$fromInt(
					$author$project$Config$get_backend_year(year)) + ('/' + projectName)))),
				$elm$json$Json$Decode$int));
	});
var $author$project$Pages$Project$OnFetchProjectLog = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Project$fetchProjectLog = F3(
	function (flags, year, name) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Project$OnFetchProjectLog,
			A2(
				$elm$http$Http$get,
				flags.cJ + (flags.dp + ('/api/project/log/' + ($elm$core$String$fromInt(year) + ('/' + name)))),
				$author$project$Project$decoder));
	});
var $author$project$Pages$Project$gen_bulk_url = function (model) {
	return model.m.cJ + (model.m.dp + ('/api/project/bulk_download/' + ($elm$core$String$fromInt(
		$author$project$Config$get_backend_year(model.ao)) + ('/' + model.aN))));
};
var $author$project$Pages$Project$refetchBulkstatus = F3(
	function (flags, year, projectName) {
		return A2(
			$elm$http$Http$send,
			$author$project$Pages$Project$OnFetchBulkDownload,
			A2(
				$elm$http$Http$get,
				flags.cJ + (flags.dp + ('/api/project/download_status/' + ($elm$core$String$fromInt(
					$author$project$Config$get_backend_year(year)) + ('/' + projectName)))),
				$elm$json$Json$Decode$int));
	});
var $author$project$Pages$Project$OnRefreshLog = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Project$refreshBuilding = function (project) {
	return (project.eW === 'building') ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		A2(
			$elm$core$Task$andThen,
			$elm$core$Basics$always(
				$elm$core$Task$succeed(
					A2($author$project$Pages$Project$OnRefreshLog, project.ao, project.eF))),
			$elm$core$Process$sleep(5000))) : $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$Project$OnRefreshBulk = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Project$refreshBulk = function (model) {
	return (!model.aY) ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		A2(
			$elm$core$Task$andThen,
			function (_v0) {
				return $elm$core$Task$succeed(
					A2($author$project$Pages$Project$OnRefreshBulk, model.ao, model.aN));
			},
			$elm$core$Process$sleep(500))) : $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$Project$updateProjects = F2(
	function (projects, project) {
		var replace = function (p) {
			return _Utils_eq(p.eF, project.eF) ? project : p;
		};
		return A2($elm$core$List$map, replace, projects);
	});
var $author$project$Pages$Project$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var msg_ = msg.a;
				return A3($author$project$Material$update, $author$project$Pages$Project$Mdc, msg_, model);
			case 0:
				if (!msg.a.$) {
					var projects = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cA: projects}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cA: _List_Nil}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.b.$) {
					var year = msg.a;
					var project = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Nothing,
								cQ: $author$project$Pages$ProjectDialog$Log,
								cA: A2($author$project$Pages$Project$updateProjects, model.cA, project)
							}),
						A3($author$project$Pages$Project$fetchProjectLog, model.m, year, project.eF));
				} else {
					var year = msg.a;
					var err = msg.b.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				if (!msg.a.$) {
					var project = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aq: $elm$core$Maybe$Just(project),
								cA: A2($author$project$Pages$Project$updateProjects, model.cA, project)
							}),
						$author$project$Pages$Project$refreshBuilding(project));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var year = msg.a;
				var name = msg.b;
				var branch = msg.c;
				return _Utils_Tuple2(
					model,
					A4($author$project$Pages$Project$buildProject, model.m, year, name, branch));
			case 5:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aq: $elm$core$Maybe$Nothing, cQ: $author$project$Pages$ProjectDialog$Log}),
					A3($author$project$Pages$Project$fetchProjectLog, model.m, year, name));
			case 6:
				var year = msg.a;
				var name = msg.b;
				return _Utils_eq(
					A2($elm$core$Maybe$withDefault, $author$project$Project$defaultProject, model.aq).eF,
					name) ? _Utils_Tuple2(
					model,
					A3($author$project$Pages$Project$fetchProjectLog, model.m, year, name)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 7:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openBookletCmd, model.m, year, name));
			case 9:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openPosterCmd, model.m, year, name));
			case 10:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cQ: A2($author$project$Pages$ProjectDialog$Trailor, year, name)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openPlayCmd, model.m, year, name));
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cQ: $author$project$Pages$ProjectDialog$Closed}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: 0,
							cQ: $author$project$Pages$ProjectDialog$Bulk(0)
						}),
					A3($author$project$Pages$Project$fetchBulkDownload, model.m, year, name));
			case 8:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$ProjectCardView$openDocCmd, model.m, year, name));
			case 14:
				if (!msg.a.$) {
					var code = msg.a.a;
					return (code === 1) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aY: 1,
								cQ: $author$project$Pages$ProjectDialog$Bulk(1)
							}),
						$author$project$Ports$openWindow(
							$author$project$Pages$Project$gen_bulk_url(model))) : _Utils_Tuple2(
						model,
						$author$project$Pages$Project$refreshBulk(model));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 15:
				var year = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Pages$Project$refetchBulkstatus, model.m, year, name));
			case 16:
				var projName = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.bV,
						'/silverfocs/project/' + ($elm$core$String$fromInt(model.ao) + ('/' + projName))));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$SourceCode$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var msg_ = msg.a;
			return A3($author$project$Material$update, $author$project$Pages$SourceCode$Mdc, msg_, model);
		} else {
			if (!msg.a.$) {
				var src = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{br: src}),
					$elm$core$Platform$Cmd$none);
			} else {
				var err = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{br: 'Sorry, Source Code not Found!'}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.z);
		switch (_v0.a.$) {
			case 9:
				var msg_ = _v0.a.a;
				return A3($author$project$Material$update, $author$project$Main$Mdc, msg_, model);
			case 10:
				var _v1 = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: !model.a0}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var urlRequest = _v0.a.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.bV,
							$elm$url$Url$toString(url)));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 0:
				var url = _v0.a.a;
				var newRoute = $author$project$Routes$parseUrl(url);
				return $author$project$Main$loadCurrentPage(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{b6: newRoute}),
						$elm$core$Platform$Cmd$none));
			case 2:
				if (_v0.b.$ === 1) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v3 = A2($author$project$Pages$List$update, subMsg, pageModel);
					var newPageModel = _v3.a;
					var newCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageList(newPageModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$ListMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				if (_v0.b.$ === 2) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v4 = A3($author$project$Pages$Edit$update, model.m, subMsg, pageModel);
					var newPageModel = _v4.a;
					var newCmd = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageEdit(newPageModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$EditMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				if (_v0.b.$ === 3) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v5 = A2($author$project$Pages$Markdown$update, subMsg, pageModel);
					var newPageModel = _v5.a;
					var newCmd = _v5.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageMarkdown(newPageModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$MarkdownMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				if (_v0.b.$ === 4) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v6 = A2($author$project$Pages$SourceCode$update, subMsg, pageModel);
					var newPageModel = _v6.a;
					var newCmd = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageSourceCode(newPageModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$SourceCodeMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				if (_v0.b.$ === 5) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v7 = A2($author$project$Pages$Project$update, subMsg, pageModel);
					var newPageModel = _v7.a;
					var newCmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageProject(newPageModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$ProjectMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				if (_v0.b.$ === 6) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v8 = A2($author$project$Pages$FameWall$update, subMsg, pageModel);
					var newFameWallModel = _v8.a;
					var newCmd = _v8.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PageFameWall(newFameWallModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$FameWallMsg, newCmd));
				} else {
					var subMsg = _v0.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (_v0.b.$ === 7) {
					var subMsg = _v0.a.a;
					var pageModel = _v0.b.a;
					var _v9 = A2($author$project$Pages$Philosophy$update, subMsg, pageModel);
					var newPhilosophyModel = _v9.a;
					var newCmd = _v9.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								z: $author$project$Main$PagePhilosophy(newPhilosophyModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$PhilosophyMsg, newCmd));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Main$notFoundView = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Not found')
		]));
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$section = _VirtualDom_node('section');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Pages$Edit$ChangeLevel = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Pages$Edit$btnLevelDecrease = function (player) {
	var message = A2($author$project$Pages$Edit$ChangeLevel, player, -1);
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn ml-3 h1'),
				$elm$html$Html$Events$onClick(message)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa fa-minus-circle')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Edit$btnLevelIncrease = function (player) {
	var message = A2($author$project$Pages$Edit$ChangeLevel, player, 1);
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn ml-3 h1'),
				$elm$html$Html$Events$onClick(message)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa fa-plus-circle')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Pages$Edit$inputLevel = function (player) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-end py-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mr-3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Level')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bold text-2xl')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(player.ct))
							])),
						$author$project$Pages$Edit$btnLevelDecrease(player),
						$author$project$Pages$Edit$btnLevelIncrease(player)
					]))
			]));
};
var $author$project$Pages$Edit$viewWithData = function (player) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(player.eF)
					])),
				$author$project$Pages$Edit$inputLevel(player)
			]));
};
var $author$project$Pages$Edit$view = function (model) {
	var content = function () {
		var _v0 = model.aM;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				return $elm$html$Html$text('Loading ...');
			case 2:
				var player = _v0.a;
				return $author$project$Pages$Edit$viewWithData(player);
			default:
				return $elm$html$Html$text('Error');
		}
	}();
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('p-4')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Pages$FameWall$OnCloseTrailer = {$: 9};
var $author$project$Pages$ProjectDialog$isTrailer = function (dialog) {
	if (dialog.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Internal$Options$Set = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Options$option = $author$project$Internal$Options$Set;
var $author$project$Internal$Dialog$Implementation$onClose = function (handler) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					bd: $elm$core$Maybe$Just(handler)
				});
		});
};
var $author$project$Material$Dialog$onClose = $author$project$Internal$Dialog$Implementation$onClose;
var $author$project$Internal$Dialog$Implementation$open = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{n: true});
	});
var $author$project$Material$Dialog$open = $author$project$Internal$Dialog$Implementation$open;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $author$project$Internal$Options$Class = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$cs = function (c) {
	return $author$project$Internal$Options$Class(c);
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Dispatch$flatten = function (decoders) {
	var tryMergeStep = F3(
		function (value, decoder, result) {
			return A2(
				$elm$core$Maybe$withDefault,
				result,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var message = _v0.de;
						var stopPropagation = _v0.dF;
						var preventDefault = _v0.dq;
						return {
							de: A2($elm$core$List$cons, message, result.de),
							dq: preventDefault || result.dq,
							dF: stopPropagation || result.dF
						};
					},
					$elm$core$Result$toMaybe(
						A2($elm$json$Json$Decode$decodeValue, decoder, value))));
		});
	var tryMerge = function (value) {
		return A3(
			$elm$core$List$foldl,
			tryMergeStep(value),
			{de: _List_Nil, dq: false, dF: false},
			decoders);
	};
	return A2($elm$json$Json$Decode$map, tryMerge, $elm$json$Json$Decode$value);
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Internal$Dispatch$toAttributes = function (_v0) {
	var config = _v0;
	var _v1 = config.cu;
	if (!_v1.$) {
		var lift = _v1.a;
		return A2(
			$elm$core$List$map,
			function (_v3) {
				var event = _v3.a;
				var flatDecoder = _v3.b;
				return A2(
					$elm$html$Html$Events$custom,
					event,
					lift(flatDecoder));
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$map,
					function (_v2) {
						return $author$project$Internal$Dispatch$flatten;
					},
					config.ai)));
	} else {
		return A2(
			$elm$core$List$concatMap,
			function (_v4) {
				var event = _v4.a;
				var decoders = _v4.b;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$Events$custom(event),
					decoders);
			},
			$elm$core$Dict$toList(config.ai));
	}
};
var $author$project$Internal$Options$addAttributes = F2(
	function (summary, attrs) {
		var styleText = A2(
			$elm$core$String$join,
			'; ',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return A2(
						$elm$core$String$join,
						': ',
						_List_fromArray(
							[key, value]));
				},
				summary.W));
		var style = (styleText !== '') ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'style', styleText)
			]) : _List_Nil;
		var all = _Utils_ap(
			summary.U,
			_Utils_ap(
				style,
				_Utils_ap(
					A2($elm$core$List$map, $elm$html$Html$Attributes$class, summary.V),
					_Utils_ap(
						attrs,
						_Utils_ap(
							summary._,
							$author$project$Internal$Dispatch$toAttributes(summary.s))))));
		return all;
	});
var $author$project$Internal$Options$Summary = F6(
	function (classes, css, attrs, internal, dispatch, config) {
		return {U: attrs, V: classes, ea: config, W: css, s: dispatch, _: internal};
	});
var $author$project$Internal$Dispatch$Config = $elm$core$Basics$identity;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Internal$Dispatch$add = F3(
	function (event, decoder, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				ai: A3(
					$elm$core$Dict$update,
					event,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$cons(decoder)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								_List_fromArray(
									[decoder])),
							$elm$core$Maybe$Just)),
					config.ai)
			});
	});
var $author$project$Internal$Dispatch$setLift = F2(
	function (lift, _v0) {
		var decoders = _v0.ai;
		return {
			ai: decoders,
			cu: $elm$core$Maybe$Just(lift)
		};
	});
var $author$project$Internal$Options$collect1_ = F2(
	function (options, acc) {
		switch (options.$) {
			case 0:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						V: A2($elm$core$List$cons, x, acc.V)
					});
			case 1:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						W: A2($elm$core$List$cons, x, acc.W)
					});
			case 2:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						U: A2($elm$core$List$cons, x, acc.U)
					});
			case 3:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						_: A2($elm$core$List$cons, x, acc._)
					});
			case 6:
				var event = options.a;
				var decoder = options.b;
				return _Utils_update(
					acc,
					{
						s: A3($author$project$Internal$Dispatch$add, event, decoder, acc.s)
					});
			case 4:
				var opts = options.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1_, acc, opts);
			case 7:
				var lift = options.a;
				return _Utils_update(
					acc,
					{
						s: A2($author$project$Internal$Dispatch$setLift, lift, acc.s)
					});
			case 5:
				return acc;
			default:
				return acc;
		}
	});
var $author$project$Internal$Dispatch$defaultConfig = {ai: $elm$core$Dict$empty, cu: $elm$core$Maybe$Nothing};
var $author$project$Internal$Options$collect_ = A2(
	$elm$core$List$foldl,
	$author$project$Internal$Options$collect1_,
	A6($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig, 0));
var $author$project$Internal$Options$styled = F2(
	function (ctor, props) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				$author$project$Internal$Options$collect_(props),
				_List_Nil));
	});
var $author$project$Internal$Dialog$Implementation$content = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$section,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-dialog__content'),
			options));
};
var $author$project$Material$Dialog$content = $author$project$Internal$Dialog$Implementation$content;
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$source = _VirtualDom_node('source');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Material$Options$styled = $author$project$Internal$Options$styled;
var $author$project$Internal$Dialog$Implementation$title = $author$project$Internal$Options$cs('mdc-dialog__title');
var $author$project$Material$Dialog$title = $author$project$Internal$Dialog$Implementation$title;
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Pages$ProjectDialog$trailerDialogBody = F3(
	function (flags, year, name) {
		var title = 'Trailer of ' + name;
		return _List_fromArray(
			[
				A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$h2,
				_List_fromArray(
					[$author$project$Material$Dialog$title]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2(
				$author$project$Material$Dialog$content,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$video,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'height', '100%'),
								A2($elm$html$Html$Attributes$style, 'width', '100%'),
								$elm$html$Html$Attributes$controls(true),
								$elm$html$Html$Attributes$autoplay(true)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$source,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(
										A3($author$project$Pages$ProjectCardView$gen_demo_url_prefix, flags, year, name) + '/doc/trailer.mp4')
									]),
								_List_Nil)
							]))
					]))
			]);
	});
var $author$project$Internal$Dialog$Model$EndAnimation = {$: 2};
var $author$project$Internal$Dialog$Model$NoOp = {$: 0};
var $author$project$Internal$Dialog$Model$StartAnimation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Options$collect1 = F2(
	function (opt, acc) {
		switch (opt.$) {
			case 0:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						V: A2($elm$core$List$cons, x, acc.V)
					});
			case 1:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						W: A2($elm$core$List$cons, x, acc.W)
					});
			case 2:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						U: A2($elm$core$List$cons, x, acc.U)
					});
			case 3:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						_: A2($elm$core$List$cons, x, acc._)
					});
			case 4:
				var opts = opt.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1, acc, opts);
			case 5:
				var g = opt.a;
				return _Utils_update(
					acc,
					{
						ea: g(acc.ea)
					});
			case 6:
				var event = opt.a;
				var decoder = opt.b;
				return _Utils_update(
					acc,
					{
						s: A3($author$project$Internal$Dispatch$add, event, decoder, acc.s)
					});
			case 7:
				var lift = opt.a;
				return _Utils_update(
					acc,
					{
						s: A2($author$project$Internal$Dispatch$setLift, lift, acc.s)
					});
			default:
				return acc;
		}
	});
var $author$project$Internal$Options$recollect = F2(
	function (summary, properties) {
		var reversed_summary = A3($elm$core$List$foldl, $author$project$Internal$Options$collect1, summary, properties);
		var new_summary = {
			U: $elm$core$List$reverse(reversed_summary.U),
			V: $elm$core$List$reverse(reversed_summary.V),
			ea: reversed_summary.ea,
			W: $elm$core$List$reverse(reversed_summary.W),
			s: reversed_summary.s,
			_: $elm$core$List$reverse(reversed_summary._)
		};
		return new_summary;
	});
var $author$project$Internal$Options$apply = F4(
	function (summary, ctor, options, attrs) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				A2($author$project$Internal$Options$recollect, summary, options),
				attrs));
	});
var $author$project$Internal$Options$Attribute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Options$aria = F2(
	function (key, val) {
		return $author$project$Internal$Options$Attribute(
			A2($elm$html$Html$Attributes$attribute, 'aria-' + key, val));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Internal$Dialog$Implementation$checkScrimClick = $debois$elm_dom$DOM$target(
	A2(
		$elm$json$Json$Decode$map,
		function (className) {
			var hasClass = function (_class) {
				return A2($elm$core$String$contains, ' ' + (_class + ' '), ' ' + (className + ' '));
			};
			return hasClass('mdc-dialog__scrim') ? true : false;
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['className']),
			$elm$json$Json$Decode$string)));
var $author$project$Internal$Options$collect = A2(
	$elm$core$Basics$composeR,
	A5($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig),
	$author$project$Internal$Options$recollect);
var $author$project$Internal$Dialog$Implementation$container = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-dialog__container'),
			options));
};
var $author$project$Internal$Options$data = F2(
	function (key, val) {
		return $author$project$Internal$Options$Attribute(
			A2($elm$html$Html$Attributes$attribute, 'data-' + key, val));
	});
var $author$project$Internal$Dialog$Implementation$defaultConfig = {bc: false, bd: $elm$core$Maybe$Nothing, n: false};
var $author$project$Internal$Options$Many = function (a) {
	return {$: 4, a: a};
};
var $author$project$Internal$Options$many = $author$project$Internal$Options$Many;
var $author$project$Internal$Options$Listener = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Internal$Options$on = F2(
	function (event, decodeMessage) {
		return A2(
			$author$project$Internal$Options$Listener,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (message) {
					return {de: message, dq: false, dF: false};
				},
				decodeMessage));
	});
var $author$project$Material$Options$data = $author$project$Internal$Options$data;
var $author$project$Material$Options$many = $author$project$Internal$Options$many;
var $author$project$Material$Options$on = $author$project$Internal$Options$on;
var $author$project$Internal$GlobalEvents$listener = F2(
	function (name, decoder) {
		return $author$project$Material$Options$many(
			_List_fromArray(
				[
					A2($author$project$Material$Options$on, name, decoder),
					A2($author$project$Material$Options$data, name, '{}')
				]));
	});
var $author$project$Internal$GlobalEvents$onTick = $author$project$Internal$GlobalEvents$listener('globaltick');
var $author$project$Internal$Options$role = function (value) {
	return $author$project$Internal$Options$Attribute(
		A2($elm$html$Html$Attributes$attribute, 'role', value));
};
var $author$project$Internal$Dialog$Implementation$scrim = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-dialog__scrim'),
			options));
};
var $author$project$Internal$Dialog$Implementation$surface = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-dialog__surface'),
			options));
};
var $author$project$Internal$Options$None = {$: 8};
var $author$project$Internal$Options$nop = $author$project$Internal$Options$None;
var $author$project$Internal$Options$when = F2(
	function (guard, prop) {
		return guard ? prop : $author$project$Internal$Options$nop;
	});
var $author$project$Internal$Dialog$Implementation$dialog = F4(
	function (lift, model, options, nodes) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Dialog$Implementation$defaultConfig, options);
		var config = summary.ea;
		var stateChanged = !_Utils_eq(config.n, model.n);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-dialog'),
					$author$project$Internal$Options$role('alertdialog'),
					A2($author$project$Internal$Options$aria, 'modal', 'true'),
					A2(
					$author$project$Internal$Options$when,
					stateChanged,
					$author$project$Internal$GlobalEvents$onTick(
						$elm$json$Json$Decode$succeed(
							lift(
								$author$project$Internal$Dialog$Model$StartAnimation(config.n))))),
					A2(
					$author$project$Internal$Options$when,
					model.n && config.n,
					$author$project$Internal$Options$cs('mdc-dialog--open')),
					A2(
					$author$project$Internal$Options$when,
					(config.n && stateChanged) || (config.n && model.aX),
					$author$project$Internal$Options$cs('mdc-dialog--opening')),
					A2(
					$author$project$Internal$Options$when,
					((!config.n) && stateChanged) || ((!config.n) && model.aX),
					$author$project$Internal$Options$cs('mdc-dialog--closing')),
					A2(
					$author$project$Internal$Options$when,
					model.aX,
					A2(
						$author$project$Internal$Options$on,
						'transitionend',
						$elm$json$Json$Decode$succeed(
							lift($author$project$Internal$Dialog$Model$EndAnimation)))),
					A3(
					$elm$core$Basics$composeL,
					$author$project$Internal$Options$when(model.n && (config.n && (!config.bc))),
					$author$project$Internal$Options$many,
					_List_fromArray(
						[
							A2($author$project$Internal$Options$data, 'focustrap', '{}'),
							A2(
							$author$project$Internal$Options$on,
							'keydown',
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (key, keyCode) {
										return (_Utils_eq(
											key,
											$elm$core$Maybe$Just('Escape')) || (keyCode === 27)) ? A2(
											$elm$core$Maybe$withDefault,
											lift($author$project$Internal$Dialog$Model$NoOp),
											config.bd) : lift($author$project$Internal$Dialog$Model$NoOp);
									}),
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$json$Json$Decode$map,
											$elm$core$Maybe$Just,
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['key']),
												$elm$json$Json$Decode$string)),
											$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
										])),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['keyCode']),
									$elm$json$Json$Decode$int)))
						]))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Internal$Dialog$Implementation$container,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Internal$Dialog$Implementation$surface, _List_Nil, nodes)
						])),
					config.bc ? $elm$html$Html$text('') : A2(
					$author$project$Internal$Dialog$Implementation$scrim,
					_List_fromArray(
						[
							A2(
							$author$project$Internal$Options$on,
							'click',
							A2(
								$elm$json$Json$Decode$map,
								function (isScrimClick) {
									return isScrimClick ? A2(
										$elm$core$Maybe$withDefault,
										lift($author$project$Internal$Dialog$Model$NoOp),
										config.bd) : lift($author$project$Internal$Dialog$Model$NoOp);
								},
								$author$project$Internal$Dialog$Implementation$checkScrimClick))
						]),
					_List_Nil)
				]));
	});
var $author$project$Internal$Msg$Dispatch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$Lift = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Options$dispatch = function (lift) {
	return $author$project$Internal$Options$Lift(
		$elm$json$Json$Decode$map(
			function (_v0) {
				var message = _v0.de;
				var stopPropagation = _v0.dF;
				var preventDefault = _v0.dq;
				return {
					de: lift(
						$author$project$Internal$Msg$Dispatch(message)),
					dq: preventDefault,
					dF: stopPropagation
				};
			}));
};
var $author$project$Internal$Component$render = F3(
	function (get_model, view, ctor) {
		return F4(
			function (lift, idx, store, options) {
				return A3(
					view,
					A2(
						$elm$core$Basics$composeL,
						lift,
						ctor(idx)),
					A2(get_model, idx, store),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Options$dispatch(lift),
						options));
			});
	});
var $author$project$Internal$Dialog$Implementation$view = A3($author$project$Internal$Component$render, $author$project$Internal$Dialog$Implementation$getSet.cZ, $author$project$Internal$Dialog$Implementation$dialog, $author$project$Internal$Msg$DialogMsg);
var $author$project$Material$Dialog$view = $author$project$Internal$Dialog$Implementation$view;
var $author$project$Material$Options$when = $author$project$Internal$Options$when;
var $author$project$Pages$ProjectDialog$trailorDialog = F5(
	function (generalMdc, materialModel, dialog, closeMsg, flags) {
		return A5(
			$author$project$Material$Dialog$view,
			generalMdc,
			'trailor-log',
			materialModel,
			_List_fromArray(
				[
					A2(
					$author$project$Material$Options$when,
					$author$project$Pages$ProjectDialog$isTrailer(dialog),
					$author$project$Material$Dialog$open),
					$author$project$Material$Dialog$onClose(closeMsg)
				]),
			function () {
				if (dialog.$ === 1) {
					var year = dialog.a;
					var name = dialog.b;
					return A3($author$project$Pages$ProjectDialog$trailerDialogBody, flags, year, name);
				} else {
					return _List_Nil;
				}
			}());
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Pages$FameWall$injectLinks = F3(
	function (markdown, flags, content) {
		return A3(
			$elm$core$String$replace,
			'(/src/',
			'(' + (flags.dp + '/src/'),
			A3(
				$elm$core$String$replace,
				'(/demo/',
				'(' + (flags.cJ + (flags.dp + '/demo/')),
				A3(
					$elm$core$String$replace,
					'src=\"./',
					'src=\"' + (flags.cJ + (flags.dp + ('/api/famewall/' + (content.cg + '/')))),
					A3($elm$core$String$replace, '](./', '](' + (flags.cJ + (flags.dp + ('/api/famewall/' + (content.cg + '/')))), markdown))));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Markdown$markdownOptions = {
	ec: $elm$core$Maybe$Nothing,
	eq: $elm$core$Maybe$Just(
		{d3: true, e$: true}),
	eT: false,
	eV: true
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$FameWall$viewImg = F3(
	function (flags, width, path) {
		if ($elm$core$String$isEmpty(path)) {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		} else {
			var imgURL = _Utils_ap(
				flags.cJ,
				_Utils_ap(flags.dp, path));
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imgURL),
						A2($elm$html$Html$Attributes$style, 'float', 'right'),
						$elm$html$Html$Attributes$width(width),
						A2($elm$html$Html$Attributes$style, 'margin-right', '1%'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '10%')
					]),
				_List_Nil);
		}
	});
var $author$project$Pages$FameWall$OnClickBooklet = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$FameWall$OnClickBuild = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$FameWall$OnClickDoc = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$FameWall$OnClickPlay = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$FameWall$OnClickPoster = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$FameWall$OnClickTrailer = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$FameWall$Todo = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$FameWall$bttnMsgSet = {d2: $author$project$Pages$FameWall$OnClickBooklet, d4: $author$project$Pages$FameWall$OnClickBuild, ee: $author$project$Pages$FameWall$OnClickDoc, eA: $author$project$Pages$FameWall$Todo, eM: $author$project$Pages$FameWall$OnClickPlay, eO: $author$project$Pages$FameWall$OnClickPoster, e1: $author$project$Pages$FameWall$OnClickTrailer};
var $author$project$Pages$ProjectCardView$getProjectWrapperStyle = function (project) {
	return project.B.dP.B ? _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'grid-row', 'span 2')
		]) : _List_Nil;
};
var $author$project$Internal$Card$Implementation$view = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-card'),
			options));
};
var $author$project$Material$Card$view = $author$project$Internal$Card$Implementation$view;
var $author$project$Internal$Card$Implementation$actionButtons = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-card__action-buttons'),
			options));
};
var $author$project$Material$Card$actionButtons = $author$project$Internal$Card$Implementation$actionButtons;
var $author$project$Internal$Card$Implementation$actionIcons = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-card__action-icons'),
			options));
};
var $author$project$Material$Card$actionIcons = $author$project$Internal$Card$Implementation$actionIcons;
var $author$project$Internal$Card$Implementation$actions = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-card__actions'),
			options));
};
var $author$project$Material$Card$actions = $author$project$Internal$Card$Implementation$actions;
var $author$project$Internal$Options$CSS = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Options$css = F2(
	function (key, value) {
		return $author$project$Internal$Options$CSS(
			_Utils_Tuple2(key, value));
	});
var $author$project$Material$Options$css = $author$project$Internal$Options$css;
var $author$project$Internal$Card$Implementation$actionIcon = $author$project$Internal$Options$cs('mdc-card__action mdc-card__action-icon');
var $author$project$Material$Card$actionIcon = $author$project$Internal$Card$Implementation$actionIcon;
var $author$project$Internal$IconButton$Implementation$disabled = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{aB: true});
	});
var $author$project$Material$IconButton$disabled = $author$project$Internal$IconButton$Implementation$disabled;
var $author$project$Internal$IconButton$Implementation$icon = function (value) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{aF: value});
		});
};
var $author$project$Material$IconButton$icon = $author$project$Internal$IconButton$Implementation$icon;
var $author$project$Internal$IconButton$Implementation$label = function (value) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{a9: value});
		});
};
var $author$project$Material$IconButton$label = $author$project$Internal$IconButton$Implementation$label;
var $author$project$Internal$Options$onClick = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Material$Options$onClick = $author$project$Internal$Options$onClick;
var $author$project$Internal$Theme$Implementation$primary = $author$project$Internal$Options$cs('mdc-theme--primary');
var $author$project$Material$Theme$primary = $author$project$Internal$Theme$Implementation$primary;
var $author$project$Internal$Theme$Implementation$secondaryDark = $author$project$Internal$Options$cs('mdc-theme--secondary-dark');
var $author$project$Material$Theme$secondaryDark = $author$project$Internal$Theme$Implementation$secondaryDark;
var $author$project$Pages$ProjectCardView$projectButtonAttributes = F4(
	function (project, avail, _v0, size) {
		var icon = _v0.a;
		var iconName = _v0.b;
		var event = _v0.c;
		return _Utils_ap(
			(!avail.B) ? _List_fromArray(
				[$author$project$Material$IconButton$disabled]) : _List_Nil,
			_List_fromArray(
				[
					$author$project$Material$Card$actionIcon,
					$author$project$Material$IconButton$icon(
					{ab: icon, h: icon}),
					$author$project$Material$IconButton$label(
					{ab: iconName, h: iconName}),
					$author$project$Material$Options$onClick(
					A2(event, project.ao, project.eF)),
					A2(
					$author$project$Material$Options$css,
					'width',
					$elm$core$String$fromInt(4 * size) + 'px'),
					A2(
					$author$project$Material$Options$css,
					'height',
					$elm$core$String$fromInt(4 * size) + 'px'),
					A2(
					$author$project$Material$Options$css,
					'font-size',
					$elm$core$String$fromInt(2 * size) + 'px'),
					A2(
					$author$project$Material$Options$css,
					'padding',
					$elm$core$String$fromInt(1 * size) + 'px'),
					((iconName === 'play') && avail.B) ? $author$project$Material$Theme$primary : $author$project$Material$Theme$secondaryDark
				]));
	});
var $author$project$Pages$ProjectCardView$projectButtonTooltip = F2(
	function (project, avail) {
		return avail.B ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltiptext')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(avail.eQ)
					]))
			]);
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Internal$Options$attribute = A2(
	$elm$core$Basics$composeL,
	$author$project$Internal$Options$Attribute,
	$elm$html$Html$Attributes$map($elm$core$Basics$never));
var $author$project$Internal$IconButton$Implementation$defaultConfig = {
	az: $elm$core$Maybe$Nothing,
	aB: false,
	aF: {ab: '', h: ''},
	a9: {ab: '', h: ''},
	h: false
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Internal$IconButton$Implementation$iconElement = $author$project$Internal$Options$cs('mdc-icon-button__icon');
var $author$project$Internal$IconButton$Implementation$onIconElement = $author$project$Internal$Options$cs('mdc-icon-button__icon--on');
var $author$project$Internal$Ripple$Model$Blur = {$: 1};
var $author$project$Internal$Ripple$Model$Deactivate = {$: 6};
var $author$project$Internal$Ripple$Model$Focus = {$: 0};
var $author$project$Internal$Ripple$Model$SetCssVariables = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$activationEventTypes = _List_fromArray(
	['touchstart', 'pointerdown', 'mousedown']);
var $author$project$Internal$Ripple$Model$cssClasses = {d$: 'mdc-ripple-upgraded--background-focused', en: 'mdc-ripple-upgraded--foreground-activation', eo: 'mdc-ripple-upgraded--foreground-deactivation', eS: 'mdc-ripple-upgraded', e3: 'mdc-ripple-upgraded--unbounded'};
var $elm$core$Basics$round = _Basics_round;
var $author$project$Internal$Ripple$Model$strings = {e6: '--mdc-ripple-fg-scale', e7: '--mdc-ripple-fg-size', e8: '--mdc-ripple-fg-translate-end', e9: '--mdc-ripple-fg-translate-start', fa: '--mdc-ripple-left', fb: '--mdc-ripple-top'};
var $author$project$Internal$Ripple$Implementation$cssVariables = F2(
	function (isUnbounded, _v0) {
		var fgScale = _v0.P;
		var translateStart = _v0.ae;
		var translateEnd = _v0.ad;
		var initialSize = _v0.Q;
		var frame = _v0.Z;
		var unboundedCoords = isUnbounded ? {
			p: $elm$core$Basics$round((frame.dW - initialSize) / 2),
			f: $elm$core$Basics$round((frame.c - initialSize) / 2)
		} : {p: 0, f: 0};
		var fgSize = $elm$core$String$fromInt(initialSize) + 'px';
		var variables = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.e7, fgSize),
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.e6,
						$elm$core$String$fromFloat(fgScale))
					]),
					isUnbounded ? _List_fromArray(
					[
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.fb,
						$elm$core$String$fromFloat(unboundedCoords.f) + 'px'),
						A2(
						$author$project$Internal$Options$css,
						$author$project$Internal$Ripple$Model$strings.fa,
						$elm$core$String$fromFloat(unboundedCoords.p) + 'px')
					]) : _List_fromArray(
					[
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.e9, translateStart),
						A2($author$project$Internal$Options$css, $author$project$Internal$Ripple$Model$strings.e8, translateEnd)
					])
				]));
		return variables;
	});
var $author$project$Internal$Ripple$Model$Activate0 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Event = F2(
	function (eventType, pagePoint) {
		return {a2: eventType, eK: pagePoint};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Internal$Ripple$Implementation$decodeActivate = function (_v0) {
	var domId = _v0.cS;
	var isUnbounded = _v0.a8;
	var isActivated = _v0.c5;
	var previousActivationEvent = _v0.dr;
	var decodePagePoint = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (pageX, pageY) {
				return {di: pageX, dj: pageY};
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['pageX']),
			$elm$json$Json$Decode$float),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['pageY']),
			$elm$json$Json$Decode$float));
	var firstChangedTouch = A2(
		$elm$json$Json$Decode$andThen,
		function (changedTouches) {
			var _v3 = $elm$core$List$head(changedTouches);
			if (!_v3.$) {
				var pagePoint = _v3.a;
				return $elm$json$Json$Decode$succeed(pagePoint);
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['changedTouches']),
			$elm$json$Json$Decode$list(decodePagePoint)));
	var decodeIsSurfaceDisabled = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$always(true),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['disabled']),
					$elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(false)
			]));
	var decodeEventType = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type']),
		$elm$json$Json$Decode$string);
	var decodeIsSameInteraction = function () {
		if (previousActivationEvent.$ === 1) {
			return $elm$json$Json$Decode$succeed(false);
		} else {
			var event = previousActivationEvent.a;
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$eq(event.a2),
				decodeEventType);
		}
	}();
	var decodeEvent = A2(
		$elm$json$Json$Decode$andThen,
		function (eventType) {
			if (eventType === 'touchstart') {
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Internal$Ripple$Model$Event(eventType),
					firstChangedTouch);
			} else {
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Internal$Ripple$Model$Event(eventType),
					decodePagePoint);
			}
		},
		decodeEventType);
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail(''))),
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (isSurfaceDisabled, isSameInteraction, event) {
					return (isActivated || (isSurfaceDisabled || isSameInteraction)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$author$project$Internal$Ripple$Model$Activate0,
							domId,
							{a1: event, ez: false, a8: isUnbounded, cH: false}));
				}),
			decodeIsSurfaceDisabled,
			decodeIsSameInteraction,
			decodeEvent));
};
var $author$project$Internal$Ripple$Model$ClientRect = F4(
	function (top, left, width, height) {
		return {c: height, p: left, f: top, dW: width};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $author$project$Internal$Ripple$Implementation$decodeClientRect = $debois$elm_dom$DOM$target(
	A5($elm$json$Json$Decode$map4, $author$project$Internal$Ripple$Model$ClientRect, $debois$elm_dom$DOM$offsetTop, $debois$elm_dom$DOM$offsetLeft, $debois$elm_dom$DOM$offsetWidth, $debois$elm_dom$DOM$offsetHeight));
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Internal$Options$id = A2($elm$core$Basics$composeL, $author$project$Internal$Options$Attribute, $elm$html$Html$Attributes$id);
var $author$project$Internal$GlobalEvents$onMouseUp = $author$project$Internal$GlobalEvents$listener('globalmouseup');
var $author$project$Internal$GlobalEvents$onPointerUp = $author$project$Internal$GlobalEvents$listener('globalpointerup');
var $author$project$Internal$GlobalEvents$onTouchEnd = $author$project$Internal$GlobalEvents$listener('globaltouchend');
var $author$project$Internal$Ripple$Implementation$view = F5(
	function (isUnbounded, domId, lift, model, options) {
		var focusHandler = A2(
			$author$project$Internal$Options$on,
			'focus',
			$elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Focus)));
		var deactivateHandler = function (event) {
			var deactivate = $elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Deactivate));
			return $author$project$Internal$Options$many(
				_List_fromArray(
					[
						$author$project$Internal$GlobalEvents$onTouchEnd(deactivate),
						$author$project$Internal$GlobalEvents$onMouseUp(deactivate),
						$author$project$Internal$GlobalEvents$onPointerUp(deactivate)
					]));
		};
		var blurHandler = A2(
			$author$project$Internal$Options$on,
			'blur',
			$elm$json$Json$Decode$succeed(
				lift($author$project$Internal$Ripple$Model$Blur)));
		var baseProperties = $author$project$Internal$Options$many(
			_List_fromArray(
				[
					$author$project$Internal$Options$id(domId),
					$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.eS),
					A2(
					$author$project$Internal$Options$when,
					isUnbounded,
					$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.e3)),
					model.bP ? $author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.d$) : $author$project$Internal$Options$nop
				]));
		var baseInteractionHandler = $author$project$Internal$Options$many(
			_List_fromArray(
				[focusHandler, blurHandler]));
		var activateHandler = $author$project$Internal$Options$many(
			A2(
				$elm$core$List$map,
				function (tipe) {
					return A2(
						$author$project$Internal$Options$on,
						tipe,
						A2(
							$elm$json$Json$Decode$map,
							lift,
							$author$project$Internal$Ripple$Implementation$decodeActivate(
								{
									cS: domId,
									c5: function () {
										var _v3 = model.x;
										if (_v3.$ === 1) {
											var activationState = _v3.a;
											return !activationState.bJ;
										} else {
											return false;
										}
									}(),
									a8: isUnbounded,
									dr: function () {
										var _v4 = model.x;
										if (_v4.$ === 1) {
											var activationEvent = _v4.a.ap;
											return $elm$core$Maybe$Just(activationEvent);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}()
								})));
				},
				$author$project$Internal$Ripple$Model$activationEventTypes));
		var _v0 = model.x;
		switch (_v0.$) {
			case 0:
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[baseInteractionHandler, activateHandler]));
				var cssVars = function () {
					var _v1 = model.ci;
					if (!_v1.$) {
						var clientRect = _v1.a;
						var _v2 = A2($author$project$Internal$Ripple$Implementation$layoutInternal, isUnbounded, clientRect);
						var fgScale = _v2.P;
						var initialSize = _v2.Q;
						return A2(
							$author$project$Internal$Ripple$Implementation$cssVariables,
							isUnbounded,
							{P: fgScale, Z: clientRect, Q: initialSize, ad: '0px', ae: '0px'});
					} else {
						return _List_Nil;
					}
				}();
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							A2(
							$author$project$Internal$Options$when,
							_Utils_eq(model.ci, $elm$core$Maybe$Nothing),
							$author$project$Internal$GlobalEvents$onTick(
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeL,
										lift,
										$author$project$Internal$Ripple$Model$SetCssVariables(isUnbounded)),
									$author$project$Internal$Ripple$Implementation$decodeClientRect)))
						]));
				return {ex: interactionHandler, eP: properties};
			case 1:
				var activatedData = _v0.a;
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseInteractionHandler,
							activateHandler,
							deactivateHandler(activatedData.ap)
						]));
				var cssVars = A2(
					$author$project$Internal$Ripple$Implementation$cssVariables,
					isUnbounded,
					{P: activatedData.P, Z: activatedData.Z, Q: activatedData.Q, ad: activatedData.ad, ae: activatedData.ae});
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.en),
							A2(
							$author$project$Internal$Options$when,
							isUnbounded,
							A2($author$project$Internal$Options$data, 'mdc-ripple-is-unbounded', '1'))
						]));
				return {ex: interactionHandler, eP: properties};
			default:
				var activatedData = _v0.a;
				var interactionHandler = $author$project$Internal$Options$many(
					_List_fromArray(
						[baseInteractionHandler, activateHandler]));
				var cssVars = A2(
					$author$project$Internal$Ripple$Implementation$cssVariables,
					isUnbounded,
					{P: activatedData.P, Z: activatedData.Z, Q: activatedData.Q, ad: activatedData.ad, ae: activatedData.ae});
				var properties = $author$project$Internal$Options$many(
					_List_fromArray(
						[
							baseProperties,
							$author$project$Internal$Options$many(cssVars),
							$author$project$Internal$Options$cs($author$project$Internal$Ripple$Model$cssClasses.eo)
						]));
				return {ex: interactionHandler, eP: properties};
		}
	});
var $author$project$Internal$IconButton$Implementation$iconButton = F5(
	function (domId, lift, model, options, list) {
		var ripple = A5(
			$author$project$Internal$Ripple$Implementation$view,
			true,
			domId,
			A2($elm$core$Basics$composeL, lift, $elm$core$Basics$identity),
			model.am,
			_List_Nil);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$IconButton$Implementation$defaultConfig, options);
		var config = summary.ea;
		var icons = _List_fromArray(
			[
				A3(
				$author$project$Internal$Options$styled,
				$elm$html$Html$i,
				_List_fromArray(
					[
						$author$project$Internal$IconButton$Implementation$iconElement,
						$author$project$Internal$Options$cs('material-icons'),
						$author$project$Internal$IconButton$Implementation$onIconElement
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.aF.h)
					])),
				A3(
				$author$project$Internal$Options$styled,
				$elm$html$Html$i,
				_List_fromArray(
					[
						$author$project$Internal$IconButton$Implementation$iconElement,
						$author$project$Internal$Options$cs('material-icons')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.aF.ab)
					]))
			]);
		var isToggle = !_Utils_eq(config.aF.h, config.aF.ab);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-icon-button'),
					A2(
					$author$project$Internal$Options$when,
					_Utils_eq(config.az, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('material-icons')),
					A2(
					$author$project$Internal$Options$when,
					config.h,
					$author$project$Internal$Options$cs('mdc-icon-button--on')),
					A2(
					$author$project$Internal$Options$aria,
					'label',
					config.h ? config.a9.h : config.a9.ab),
					A2(
					$author$project$Internal$Options$when,
					isToggle,
					A2($author$project$Internal$Options$aria, 'hidden', 'True')),
					A2(
					$author$project$Internal$Options$when,
					isToggle && config.h,
					A2($author$project$Internal$Options$aria, 'pressed', 'True')),
					A2(
					$author$project$Internal$Options$when,
					isToggle && (!config.h),
					A2($author$project$Internal$Options$aria, 'pressed', 'False')),
					A2(
					$author$project$Internal$Options$when,
					config.aB,
					$author$project$Internal$Options$attribute(
						$elm$html$Html$Attributes$disabled(true))),
					$author$project$Internal$Options$many(
					_List_fromArray(
						[ripple.ex, ripple.eP]))
				]),
			_List_Nil,
			_Utils_ap(
				list,
				(!_Utils_eq(config.az, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						A3(
						$author$project$Internal$Options$styled,
						$elm$html$Html$i,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs(
								A2($elm$core$Maybe$withDefault, 'material-icons', config.az)),
								config.h ? $author$project$Internal$Options$cs(config.aF.h) : $author$project$Internal$Options$cs(config.aF.ab)
							]),
						_List_Nil)
					]) : (_Utils_eq(config.aF.h, config.aF.ab) ? _List_fromArray(
					[
						$elm$html$Html$text(config.aF.h)
					]) : icons)));
	});
var $author$project$Internal$IconButton$Implementation$view = F2(
	function (lift, index) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$IconButton$Implementation$getSet.cZ,
			$author$project$Internal$IconButton$Implementation$iconButton(index),
			$author$project$Internal$Msg$IconButtonMsg,
			lift,
			index);
	});
var $author$project$Material$IconButton$view = $author$project$Internal$IconButton$Implementation$view;
var $author$project$Pages$ProjectCardView$viewProjectButton = F6(
	function (generalMdc, model, project, _v0, avail, size) {
		var icon = _v0.a;
		var iconName = _v0.b;
		var event = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltipbutton')
				]),
			A2(
				$elm$core$List$cons,
				A5(
					$author$project$Material$IconButton$view,
					generalMdc,
					project.eF + ('-action-icon-' + iconName),
					model,
					A4(
						$author$project$Pages$ProjectCardView$projectButtonAttributes,
						project,
						avail,
						_Utils_Tuple3(icon, iconName, event),
						size),
					_List_Nil),
				A2($author$project$Pages$ProjectCardView$projectButtonTooltip, project, avail)));
	});
var $author$project$Internal$Card$Implementation$actionButton = $author$project$Internal$Options$cs('mdc-card__action mdc-card__action-button');
var $author$project$Material$Card$actionButton = $author$project$Internal$Card$Implementation$actionButton;
var $author$project$Internal$Menu$Implementation$attach = F2(
	function (lift, idx) {
		return $author$project$Internal$Options$onClick(
			lift(
				A2($author$project$Internal$Msg$MenuMsg, idx, $author$project$Internal$Menu$Model$Toggle)));
	});
var $author$project$Material$Menu$attach = $author$project$Internal$Menu$Implementation$attach;
var $author$project$Internal$Button$Implementation$outlined = $author$project$Internal$Options$cs('mdc-button--outlined');
var $author$project$Material$Button$outlined = $author$project$Internal$Button$Implementation$outlined;
var $author$project$Internal$Button$Implementation$ripple = $author$project$Internal$Options$option(
	function (options) {
		return _Utils_update(
			options,
			{am: true});
	});
var $author$project$Material$Button$ripple = $author$project$Internal$Button$Implementation$ripple;
var $author$project$Internal$Menu$Implementation$surfaceAnchor = $author$project$Internal$Options$cs('mdc-menu-surface--anchor');
var $author$project$Material$Menu$surfaceAnchor = $author$project$Internal$Menu$Implementation$surfaceAnchor;
var $author$project$Internal$Theme$Implementation$textPrimaryOnBackground = $author$project$Internal$Options$cs('mdc-theme--text-primary-on-background');
var $author$project$Material$Theme$textPrimaryOnBackground = $author$project$Internal$Theme$Implementation$textPrimaryOnBackground;
var $author$project$Internal$Theme$Implementation$textSecondaryOnLight = $author$project$Internal$Options$cs('mdc-theme--text-secondary-on-light');
var $author$project$Material$Theme$textSecondaryOnLight = $author$project$Internal$Theme$Implementation$textSecondaryOnLight;
var $author$project$Internal$Button$Model$Click = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Internal$Button$Implementation$defaultConfig = {aB: false, aF: $elm$core$Maybe$Nothing, aH: $elm$core$Maybe$Nothing, bX: $elm$core$Maybe$Nothing, am: false, by: false};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Internal$Icon$Implementation$defaultConfig = {bW: 'i'};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Internal$Icon$Implementation$view = F2(
	function (options, name) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Icon$Implementation$defaultConfig, options);
		var config = summary.ea;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$node(config.bW),
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('material-icons'),
					A2($author$project$Internal$Options$aria, 'hidden', 'true')
				]),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Internal$Button$Implementation$button = F5(
	function (domId, lift, model, options, nodes) {
		var rippleInterface = A5(
			$author$project$Internal$Ripple$Implementation$view,
			false,
			domId,
			A2($elm$core$Basics$composeL, lift, $author$project$Internal$Button$Model$RippleMsg),
			model.am,
			_List_Nil);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Button$Implementation$defaultConfig, options);
		var config = summary.ea;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			(!_Utils_eq(config.aH, $elm$core$Maybe$Nothing)) ? $elm$html$Html$a : $elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-button'),
					A2(
					$author$project$Internal$Options$when,
					(!_Utils_eq(config.aH, $elm$core$Maybe$Nothing)) && (!config.aB),
					$author$project$Internal$Options$attribute(
						$elm$html$Html$Attributes$href(
							A2($elm$core$Maybe$withDefault, '', config.aH)))),
					A2(
					$author$project$Internal$Options$when,
					config.aB,
					$author$project$Internal$Options$attribute(
						$elm$html$Html$Attributes$disabled(true))),
					A2(
					$author$project$Internal$Options$when,
					config.aB,
					$author$project$Internal$Options$cs('mdc-button--disabled')),
					A3(
					$elm$core$Basics$composeL,
					$author$project$Internal$Options$when(config.am),
					$author$project$Internal$Options$many,
					_List_fromArray(
						[rippleInterface.ex, rippleInterface.eP])),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Internal$Options$nop,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Internal$Options$onClick, lift),
							$author$project$Internal$Button$Model$Click(config.am)),
						config.bX))
				]),
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-button__ripple')
								]),
							_List_Nil)
						]),
						(!config.by) ? A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon_) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-button__icon')
											]),
										icon_)
									]);
							},
							config.aF)) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mdc-button__label')
								]),
							nodes)
						]),
						config.by ? A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (icon_) {
								return _List_fromArray(
									[
										A2(
										$author$project$Internal$Icon$Implementation$view,
										_List_fromArray(
											[
												$author$project$Internal$Options$cs('mdc-button__icon')
											]),
										icon_)
									]);
							},
							config.aF)) : _List_Nil
					])));
	});
var $author$project$Internal$Button$Implementation$view = F2(
	function (lift, index) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$Button$Implementation$getSet.cZ,
			$author$project$Internal$Button$Implementation$button(index),
			$author$project$Internal$Msg$ButtonMsg,
			lift,
			index);
	});
var $author$project$Material$Button$view = $author$project$Internal$Button$Implementation$view;
var $author$project$Internal$Menu$Implementation$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Menu$Implementation$li = F2(
	function (options, children) {
		return A2(
			$author$project$Internal$Menu$Implementation$ListItem,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$role('menuitem'),
				options),
			children);
	});
var $author$project$Material$Menu$li = $author$project$Internal$Menu$Implementation$li;
var $author$project$Internal$Keyboard$decodeKey = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['key']),
	$elm$json$Json$Decode$string);
var $author$project$Internal$Keyboard$decodeKeyCode = $elm$html$Html$Events$keyCode;
var $author$project$Internal$Menu$Implementation$onSelect = function (msg) {
	var trigger = F2(
		function (key, keyCode) {
			var isSpace = (key === 'Space') || (keyCode === 32);
			var isEnter = (key === 'Enter') || (keyCode === 13);
			return (isSpace || isEnter) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('');
		});
	return $author$project$Internal$Options$many(
		_List_fromArray(
			[
				$author$project$Internal$Options$onClick(msg),
				A2(
				$author$project$Internal$Options$on,
				'keyup',
				A2(
					$elm$json$Json$Decode$andThen,
					$elm$core$Basics$identity,
					A3($elm$json$Json$Decode$map2, trigger, $author$project$Internal$Keyboard$decodeKey, $author$project$Internal$Keyboard$decodeKeyCode)))
			]));
};
var $author$project$Material$Menu$onSelect = $author$project$Internal$Menu$Implementation$onSelect;
var $author$project$Internal$Menu$Implementation$ul = F2(
	function (options, items) {
		return {cr: items, au: options};
	});
var $author$project$Material$Menu$ul = $author$project$Internal$Menu$Implementation$ul;
var $author$project$Pages$ProjectCardView$projectBranchMap = F3(
	function (branches, proj, bttnMsg) {
		return A2(
			$author$project$Material$Menu$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (branch) {
					return A2(
						$author$project$Material$Menu$li,
						_List_fromArray(
							[
								$author$project$Material$Menu$onSelect(
								A3(bttnMsg.d4, proj.ao, proj.eF, branch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(branch)
							]));
				},
				branches));
	});
var $author$project$Internal$Menu$Model$CloseDelayed = {$: 6};
var $author$project$Internal$Menu$Model$Init = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Internal$Menu$Model$KeyDown = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Internal$Menu$Model$KeyUp = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Internal$Menu$Implementation$horizontalOffset = F3(
	function (config, corner, geometry) {
		var isRightAligned = corner.b;
		var avoidHorizontalOverlap = config.N.b;
		return isRightAligned ? (avoidHorizontalOverlap ? (geometry.w.dW - config.d.p) : config.d.b) : (avoidHorizontalOverlap ? (geometry.w.dW - config.d.b) : config.d.p);
	});
var $author$project$Internal$Menu$Implementation$menuMaxHeight = F3(
	function (config, corner, geometry) {
		var isBottomAligned = corner.a;
		return config.N.a ? (isBottomAligned ? (geometry.v.f + config.d.f) : (geometry.v.a - config.d.a)) : 0;
	});
var $author$project$Internal$Menu$Implementation$originCorner = F2(
	function (config, geometry) {
		var isRtl = false;
		var isFlipRtl = config.N.G;
		var isBottomAligned = config.N.a;
		var flipRtl = false;
		var center = false;
		var avoidHorizontalOverlap = config.N.b;
		var isAlignedRight = (avoidHorizontalOverlap && (!isRtl)) || ((!avoidHorizontalOverlap) && (isFlipRtl && isRtl));
		var availableTop = isBottomAligned ? ((geometry.v.f + geometry.w.c) + config.d.a) : (geometry.v.f + config.d.f);
		var topOverflow = geometry.t.c - availableTop;
		var availableRight = isAlignedRight ? (geometry.v.b - config.d.b) : ((geometry.v.b + geometry.w.dW) - config.d.p);
		var rightOverflow = geometry.t.dW - availableRight;
		var availableLeft = isAlignedRight ? ((geometry.v.p + geometry.w.dW) + config.d.b) : (geometry.v.p + config.d.p);
		var leftOverflow = geometry.t.dW - availableLeft;
		var right = ((leftOverflow < 0) && (isAlignedRight && isRtl)) || ((avoidHorizontalOverlap && ((!isAlignedRight) && (leftOverflow < 0))) || ((rightOverflow > 0) && (_Utils_cmp(leftOverflow, rightOverflow) < 0)));
		var availableBottom = isBottomAligned ? (geometry.v.a - config.d.a) : ((geometry.v.a + geometry.w.c) + config.d.f);
		var bottomOverflow = geometry.t.c - availableBottom;
		var bottom = (bottomOverflow > 0) && (_Utils_cmp(topOverflow, bottomOverflow) < 0);
		return {a: bottom, O: center, G: flipRtl, b: right};
	});
var $author$project$Internal$Menu$Implementation$verticalOffset = F3(
	function (config, corner, geometry) {
		var marginToEdge = 32;
		var isBottomAligned = corner.a;
		var avoidVerticalOverlap = config.N.a;
		var canOverlapVertically = !avoidVerticalOverlap;
		return isBottomAligned ? ((canOverlapVertically && (_Utils_cmp(geometry.t.c, geometry.v.f + geometry.w.c) > 0)) ? (-(A2($elm$core$Basics$min, geometry.t.c, geometry.dU.c - marginToEdge) - (geometry.v.f + geometry.w.c))) : (avoidVerticalOverlap ? (geometry.w.c - config.d.f) : (-config.d.a))) : ((canOverlapVertically && (_Utils_cmp(geometry.t.c, geometry.v.a + geometry.w.c) > 0)) ? (-(A2($elm$core$Basics$min, geometry.t.c, geometry.dU.c - marginToEdge) - (geometry.v.f + geometry.w.c))) : (avoidVerticalOverlap ? (geometry.w.c + config.d.a) : config.d.f));
	});
var $author$project$Internal$Menu$Implementation$autoPosition = F2(
	function (config, geometry) {
		var corner = A2($author$project$Internal$Menu$Implementation$originCorner, config, geometry);
		var horizontalAlignment = corner.b ? 'right' : 'left';
		var horizontalAlignment_ = ((geometry.w.dW / geometry.t.dW) > 0.67) ? 'center' : horizontalAlignment;
		var horizontalOffset_ = A3($author$project$Internal$Menu$Implementation$horizontalOffset, config, corner, geometry);
		var maxMenuHeight = A3($author$project$Internal$Menu$Implementation$menuMaxHeight, config, corner, geometry);
		var verticalAlignment = corner.a ? 'bottom' : 'top';
		var verticalOffset_ = A3($author$project$Internal$Menu$Implementation$verticalOffset, config, corner, geometry);
		var position = {
			a: (verticalAlignment === 'bottom') ? $elm$core$Maybe$Just(
				$elm$core$String$fromFloat(verticalOffset_) + 'px') : $elm$core$Maybe$Nothing,
			p: (horizontalAlignment === 'left') ? $elm$core$Maybe$Just(
				$elm$core$String$fromFloat(horizontalOffset_) + 'px') : $elm$core$Maybe$Nothing,
			b: (horizontalAlignment === 'right') ? $elm$core$Maybe$Just(
				$elm$core$String$fromFloat(horizontalOffset_) + 'px') : $elm$core$Maybe$Nothing,
			f: (verticalAlignment === 'top') ? $elm$core$Maybe$Just(
				$elm$core$String$fromFloat(verticalOffset_) + 'px') : $elm$core$Maybe$Nothing
		};
		var verticalAlignment_ = function () {
			if ((!config.N.a) && ($elm$core$Basics$abs(verticalOffset_ / geometry.t.c) > 0.1)) {
				var verticalOffsetPercent = $elm$core$Basics$abs(verticalOffset_ / geometry.t.c) * 100;
				var originPercent = corner.a ? (100 - verticalOffsetPercent) : verticalOffsetPercent;
				return $elm$core$String$fromFloat(
					$elm$core$Basics$round(originPercent * 100) / 100) + '%';
			} else {
				return verticalAlignment;
			}
		}();
		return {
			dd: (!(!maxMenuHeight)) ? ($elm$core$String$fromFloat(maxMenuHeight) + 'px') : 'auto',
			$7: position,
			dS: horizontalAlignment_ + (' ' + verticalAlignment_)
		};
	});
var $author$project$Internal$Menu$Model$Geometry = F4(
	function (viewport, viewportDistance, anchor, menu) {
		return {w: anchor, t: menu, dU: viewport, v: viewportDistance};
	});
var $author$project$Internal$Menu$Model$Viewport = F2(
	function (width, height) {
		return {c: height, dW: width};
	});
var $author$project$Internal$Menu$Implementation$decodeGeometry = function () {
	var decodeViewportDistance = F2(
		function (decodedViewport, decodedAnchorRect) {
			return $elm$json$Json$Decode$succeed(
				{a: (decodedViewport.c - decodedAnchorRect.f) - decodedAnchorRect.c, p: decodedAnchorRect.p, b: (decodedViewport.dW - decodedAnchorRect.p) - decodedAnchorRect.dW, f: decodedAnchorRect.f});
		});
	var decodeViewport = $debois$elm_dom$DOM$target(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['ownerDocument', 'defaultView']),
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Internal$Menu$Model$Viewport,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['innerWidth']),
					$elm$json$Json$Decode$float),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['innerHeight']),
					$elm$json$Json$Decode$float))));
	var decodeMenu = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (offsetWidth, offsetHeight) {
				return {c: offsetHeight, dW: offsetWidth};
			}),
		$debois$elm_dom$DOM$offsetWidth,
		$debois$elm_dom$DOM$offsetHeight);
	var anchorRect = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['parentRect']),
		A5(
			$elm$json$Json$Decode$map4,
			F4(
				function (top, left, width, height) {
					return {c: height, p: left, f: top, dW: width};
				}),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['top']),
				$elm$json$Json$Decode$float),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['left']),
				$elm$json$Json$Decode$float),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['width']),
				$elm$json$Json$Decode$float),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['height']),
				$elm$json$Json$Decode$float)));
	var anchor = function (_v1) {
		var width = _v1.dW;
		var height = _v1.c;
		return $elm$json$Json$Decode$succeed(
			{c: height, dW: width});
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var decodedViewport = _v0.a;
			var decodedeAnchorRect = _v0.b;
			return $debois$elm_dom$DOM$target(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Internal$Menu$Model$Geometry(decodedViewport),
					A2(decodeViewportDistance, decodedViewport, decodedeAnchorRect),
					anchor(decodedeAnchorRect),
					decodeMenu));
		},
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (x, y) {
					return _Utils_Tuple2(x, y);
				}),
			decodeViewport,
			anchorRect));
}();
var $author$project$Internal$Keyboard$decodeMeta = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (altKey, ctrlKey, metaKey, shiftKey) {
			return {ce: altKey, cm: ctrlKey, cw: metaKey, cD: shiftKey};
		}),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['altKey']),
		$elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['ctrlKey']),
		$elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['metaKey']),
		$elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['shiftKey']),
		$elm$json$Json$Decode$bool));
var $author$project$Internal$Menu$Implementation$defaultMargin = {a: 0, p: 0, b: 0, f: 0};
var $author$project$Internal$Menu$Implementation$topLeftCorner = {a: false, O: false, G: false, b: false};
var $author$project$Internal$Menu$Implementation$defaultConfig = {N: $author$project$Internal$Menu$Implementation$topLeftCorner, d: $author$project$Internal$Menu$Implementation$defaultMargin, aG: $elm$core$Maybe$Nothing, n: false, K: false};
var $author$project$Internal$Menu$Model$defaultGeometry = {
	w: {c: 0, dW: 0},
	t: {c: 0, dW: 0},
	dU: {c: 0, dW: 0},
	v: {a: 0, p: 0, b: 0, f: 0}
};
var $author$project$Internal$GlobalEvents$encodeTickConfig = function (tickConfig) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'targetRect',
				$elm$json$Json$Encode$bool(tickConfig.dN)),
				_Utils_Tuple2(
				'parentRect',
				$elm$json$Json$Encode$bool(tickConfig.dk))
			]));
};
var $author$project$Internal$GlobalEvents$listenerWithValue = F3(
	function (name, value, decoder) {
		return $author$project$Material$Options$many(
			_List_fromArray(
				[
					A2($author$project$Material$Options$on, name, decoder),
					A2(
					$author$project$Material$Options$data,
					name,
					A2($elm$json$Json$Encode$encode, 0, value))
				]));
	});
var $author$project$Internal$GlobalEvents$onTickWith = function (config) {
	return A2(
		$author$project$Internal$GlobalEvents$listenerWithValue,
		'globaltick',
		$author$project$Internal$GlobalEvents$encodeTickConfig(config));
};
var $author$project$Internal$Options$onWithOptions = function (evt) {
	return $author$project$Internal$Options$Listener(evt);
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Internal$Options$tabindex = function (value) {
	return $author$project$Internal$Options$Attribute(
		$elm$html$Html$Attributes$tabindex(value));
};
var $author$project$Internal$List$Implementation$HtmlList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$List$Implementation$defaultConfig = {aU: false, co: $elm$core$Maybe$Nothing, aB: false, at: true, aj: false, ak: false, bW: $elm$core$Maybe$Nothing, be: $elm$core$Maybe$Nothing, am: true, bm: false, bn: $elm$core$Maybe$Nothing, bB: false};
var $author$project$Internal$List$Implementation$asListItemView = F9(
	function (domId, lift, model, config, listItemsIds, focusedIndex, index, options, children) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$List$Implementation$defaultConfig, options);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			A2($elm$core$Maybe$withDefault, $elm$html$Html$div, summary.ea.bW),
			_List_Nil,
			_List_Nil,
			children);
	});
var $author$project$Internal$List$Implementation$node = function (nodeFunc) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					bW: $elm$core$Maybe$Just(nodeFunc)
				});
		});
};
var $author$project$Internal$List$Implementation$asListItem = F3(
	function (dom_node, options, children) {
		return {
			a_: $author$project$Internal$List$Implementation$HtmlList(children),
			a3: false,
			au: A2(
				$elm$core$List$cons,
				$author$project$Internal$List$Implementation$node(dom_node),
				options),
			aT: $author$project$Internal$List$Implementation$asListItemView
		};
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Internal$List$Implementation$divider = function (options) {
	return A2(
		$author$project$Internal$List$Implementation$asListItem,
		$elm$html$Html$li,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-list-divider'),
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$role('separator'),
				options)));
};
var $author$project$Internal$List$Model$FocusItem = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$List$Model$SelectItem = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$List$Implementation$disabledClass = $author$project$Internal$Options$cs('mdc-list-item--disabled');
var $author$project$Internal$List$Implementation$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.i)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.i, tail);
		return (notAppended < 0) ? {
			k: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.k),
			g: builder.g + 1,
			i: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			k: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.k),
			g: builder.g + 1,
			i: $elm$core$Elm$JsArray$empty
		} : {k: builder.k, g: builder.g, i: appended});
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						k: _List_Nil,
						g: 0,
						i: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Internal$List$Implementation$slicedIndexedList = F3(
	function (from, to, array) {
		return $elm$core$Array$toIndexedList(
			A3($elm$core$Array$slice, from, to, array));
	});
var $author$project$Internal$List$Implementation$firstNonEmptyId = F2(
	function (from, array) {
		var list = A3(
			$author$project$Internal$List$Implementation$slicedIndexedList,
			from,
			$elm$core$Array$length(array),
			array);
		var non_empty_id = A2(
			$author$project$Internal$List$Implementation$find,
			function (_v0) {
				var id = _v0.b;
				return id !== '';
			},
			list);
		return non_empty_id;
	});
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Internal$List$Implementation$lastNonEmptyId = F2(
	function (to, array) {
		var list = A3($author$project$Internal$List$Implementation$slicedIndexedList, 0, to, array);
		var non_empty_id = A2(
			$author$project$Internal$List$Implementation$find,
			function (_v0) {
				var i = _v0.a;
				var id = _v0.b;
				return id !== '';
			},
			$elm$core$List$reverse(list));
		return non_empty_id;
	});
var $author$project$Internal$List$Implementation$listItemClass = $author$project$Internal$Options$cs('mdc-list-item');
var $author$project$Internal$List$Implementation$listItemDomId = F2(
	function (domId, index) {
		return domId + ('--' + $elm$core$String$fromInt(index));
	});
var $author$project$Internal$Ripple$Implementation$none = {ex: $author$project$Internal$Options$nop, eP: $author$project$Internal$Options$nop};
var $author$project$Internal$List$Implementation$liView = F9(
	function (domId, lift, model, config, listItemIds, focusedIndex, index, options, children) {
		var tab_index = _Utils_eq(focusedIndex, index) ? 0 : (-1);
		var list_item_dom_id = A2($author$project$Internal$List$Implementation$listItemDomId, domId, index);
		var li_summary = A2($author$project$Internal$Options$collect, $author$project$Internal$List$Implementation$defaultConfig, options);
		var li_config = li_summary.ea;
		var rippled = li_config.am && config.at;
		var ripple = rippled ? A5(
			$author$project$Internal$Ripple$Implementation$view,
			false,
			list_item_dom_id,
			A2(
				$elm$core$Basics$composeL,
				lift,
				$author$project$Internal$List$Model$RippleMsg(list_item_dom_id)),
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Internal$Ripple$Model$defaultModel,
				A2($elm$core$Dict$get, list_item_dom_id, model.bk)),
			_List_Nil) : $author$project$Internal$Ripple$Implementation$none;
		var is_selected = function () {
			var _v9 = config.bn;
			if (!_v9.$) {
				var i = _v9.a;
				return _Utils_eq(i, index);
			} else {
				return li_config.bm || li_config.aU;
			}
		}();
		return A5(
			$author$project$Internal$Options$apply,
			li_summary,
			A2($elm$core$Maybe$withDefault, $elm$html$Html$li, li_config.bW),
			_List_fromArray(
				[
					$author$project$Internal$List$Implementation$listItemClass,
					A2(
					$author$project$Internal$Options$when,
					!rippled,
					$author$project$Internal$Options$id(list_item_dom_id)),
					A2(
					$author$project$Internal$Options$when,
					config.at,
					$author$project$Internal$Options$tabindex(tab_index)),
					A2(
					$author$project$Internal$Options$when,
					config.ak && (is_selected && (!config.bB)),
					$author$project$Internal$Options$cs('mdc-list-item--selected')),
					A2(
					$author$project$Internal$Options$when,
					config.ak && (is_selected && config.bB),
					$author$project$Internal$Options$cs('mdc-list-item--activated')),
					A2(
					$author$project$Internal$Options$when,
					config.aj,
					A2(
						$author$project$Internal$Options$aria,
						'checked',
						is_selected ? 'true' : 'false')),
					A2(
					$author$project$Internal$Options$when,
					(!config.aj) && config.at,
					A2(
						$author$project$Internal$Options$aria,
						'selected',
						is_selected ? 'true' : 'false')),
					A2(
					$author$project$Internal$Options$when,
					config.ak,
					$author$project$Internal$Options$role('option')),
					A2(
					$author$project$Internal$Options$when,
					config.aj,
					$author$project$Internal$Options$role('radio')),
					A2($author$project$Internal$Options$when, li_config.aB, $author$project$Internal$List$Implementation$disabledClass),
					function () {
					var _v0 = li_config.co;
					if (!_v0.$) {
						var v = _v0.a;
						return A2($author$project$Internal$Options$data, 'value', v);
					} else {
						return $author$project$Internal$Options$nop;
					}
				}(),
					A2($author$project$Internal$Options$when, rippled, ripple.ex),
					A2($author$project$Internal$Options$when, rippled, ripple.eP),
					function () {
					var _v1 = config.be;
					if (!_v1.$) {
						var onSelect = _v1.a;
						return (!li_config.aB) ? $author$project$Internal$Options$onClick(
							onSelect(index)) : $author$project$Internal$Options$nop;
					} else {
						return $author$project$Internal$Options$nop;
					}
				}(),
					A2(
					$author$project$Internal$Options$onWithOptions,
					'keydown',
					A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (key, keyCode) {
								var selectItem = _Utils_eq(
									key,
									$elm$core$Maybe$Just('Enter')) || ((keyCode === 13) || (_Utils_eq(
									key,
									$elm$core$Maybe$Just('Space')) || (keyCode === 32)));
								var _v2 = function () {
									if (_Utils_eq(
										key,
										$elm$core$Maybe$Just('ArrowDown')) || (keyCode === 40)) {
										var focusable_element = A2($author$project$Internal$List$Implementation$firstNonEmptyId, index + 1, listItemIds);
										if (!focusable_element.$) {
											var _v4 = focusable_element.a;
											var next_index = _v4.a;
											var next_item = _v4.b;
											return _Utils_Tuple2(
												$elm$core$Maybe$Just(next_index),
												$elm$core$Maybe$Just(next_item));
										} else {
											return _Utils_Tuple2(
												$elm$core$Maybe$Just(index + 1),
												$elm$core$Maybe$Nothing);
										}
									} else {
										if (_Utils_eq(
											key,
											$elm$core$Maybe$Just('ArrowUp')) || (keyCode === 38)) {
											var focusable_element = A2($author$project$Internal$List$Implementation$lastNonEmptyId, index, listItemIds);
											if (!focusable_element.$) {
												var _v6 = focusable_element.a;
												var previous_index = _v6.a;
												var previous_item = _v6.b;
												return _Utils_Tuple2(
													$elm$core$Maybe$Just(previous_index),
													$elm$core$Maybe$Just(previous_item));
											} else {
												return _Utils_Tuple2(
													$elm$core$Maybe$Just(index - 1),
													$elm$core$Maybe$Nothing);
											}
										} else {
											if (_Utils_eq(
												key,
												$elm$core$Maybe$Just('Home')) || (keyCode === 36)) {
												return _Utils_Tuple2(
													$elm$core$Maybe$Just(0),
													A2($elm$core$Array$get, 0, listItemIds));
											} else {
												if (_Utils_eq(
													key,
													$elm$core$Maybe$Just('End')) || (keyCode === 35)) {
													var last_index = $elm$core$Array$length(listItemIds) - 1;
													return _Utils_Tuple2(
														$elm$core$Maybe$Just(last_index),
														A2($elm$core$Array$get, last_index, listItemIds));
												} else {
													return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
												}
											}
										}
									}
								}();
								var index_to_focus = _v2.a;
								var id_to_focus = _v2.b;
								var msg = function () {
									if (selectItem) {
										var _v7 = config.be;
										if (!_v7.$) {
											var onSelect = _v7.a;
											return A2($author$project$Internal$List$Model$SelectItem, index, onSelect);
										} else {
											return $author$project$Internal$List$Model$NoOp;
										}
									} else {
										var _v8 = _Utils_Tuple2(index_to_focus, id_to_focus);
										if ((!_v8.a.$) && (!_v8.b.$)) {
											var idx = _v8.a.a;
											var id = _v8.b.a;
											return A2($author$project$Internal$List$Model$FocusItem, idx, id);
										} else {
											return $author$project$Internal$List$Model$NoOp;
										}
									}
								}();
								return {
									de: lift(msg),
									dq: (!_Utils_eq(index_to_focus, $elm$core$Maybe$Nothing)) || selectItem,
									dF: false
								};
							}),
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$map,
									$elm$core$Maybe$Just,
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['key']),
										$elm$json$Json$Decode$string)),
									$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
								])),
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['keyCode']),
							$elm$json$Json$Decode$int)))
				]),
			_List_Nil,
			children);
	});
var $author$project$Internal$List$Implementation$li = F2(
	function (options, children) {
		return {
			a_: $author$project$Internal$List$Implementation$HtmlList(children),
			a3: true,
			au: options,
			aT: $author$project$Internal$List$Implementation$liView
		};
	});
var $author$project$Internal$List$Implementation$ListItemList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$List$Implementation$nestedUl = F3(
	function (a_view, options, children) {
		return {
			a_: $author$project$Internal$List$Implementation$ListItemList(children),
			a3: true,
			au: options,
			aT: a_view
		};
	});
var $author$project$Internal$Menu$Implementation$selectionGroupView = F9(
	function (domId, lift, model, config, listItemIds, focusedIndex, an_index, options, children) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$List$Implementation$defaultConfig, options);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			A2($elm$core$Maybe$withDefault, $elm$html$Html$div, summary.ea.bW),
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-menu__selection-group')
				]),
			_List_Nil,
			children);
	});
var $author$project$Internal$Menu$Implementation$toListItem = function (items) {
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, item) {
				switch (item.$) {
					case 1:
						var options = item.a;
						var children = item.b;
						return A2($author$project$Internal$List$Implementation$divider, options, children);
					case 0:
						var options = item.a;
						var children = item.b;
						return A2($author$project$Internal$List$Implementation$li, options, children);
					default:
						var options = item.a;
						var children = item.b;
						return A3(
							$author$project$Internal$List$Implementation$nestedUl,
							$author$project$Internal$Menu$Implementation$selectionGroupView,
							options,
							$author$project$Internal$Menu$Implementation$toListItem(children));
				}
			}),
		items);
};
var $author$project$Internal$List$Model$ResetFocusedItem = {$: 3};
var $author$project$Internal$List$Implementation$doListItemDomId = F3(
	function (domId, index, listItem) {
		return listItem.a3 ? A2($author$project$Internal$List$Implementation$listItemDomId, domId, index) : '';
	});
var $author$project$Internal$List$Implementation$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = rest;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $author$project$Internal$List$Implementation$findIndex = $author$project$Internal$List$Implementation$findIndexHelp(0);
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{k: nodeList, g: nodeListSize, i: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Internal$List$Implementation$liIsSelectedOrActivated = function (li_) {
	var li_summary = A2($author$project$Internal$Options$collect, $author$project$Internal$List$Implementation$defaultConfig, li_.au);
	var li_config = li_summary.ea;
	return li_config.bm || li_config.aU;
};
var $author$project$Internal$List$Implementation$listItemView = F8(
	function (domId, lift, model, config, listItemsIds, focusedIndex, index, li_) {
		var _v0 = li_.a_;
		if (!_v0.$) {
			var children = _v0.a;
			return A9(li_.aT, domId, lift, model, config, listItemsIds, focusedIndex, index, li_.au, children);
		} else {
			var items = _v0.a;
			var groupDomId = domId + ('-' + $elm$core$String$fromInt(index));
			return A9(
				li_.aT,
				domId,
				lift,
				model,
				config,
				listItemsIds,
				focusedIndex,
				index,
				li_.au,
				A2(
					$elm$core$List$indexedMap,
					A6($author$project$Internal$List$Implementation$listItemView, groupDomId, lift, model, config, listItemsIds, focusedIndex),
					items));
		}
	});
var $author$project$Internal$List$Implementation$nonInteractiveClass = $author$project$Internal$Options$cs('mdc-list--non-interactive');
var $author$project$Internal$List$Implementation$invertDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybe) {
			return _Utils_eq(maybe, $elm$core$Maybe$Nothing) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('');
		},
		$elm$json$Json$Decode$maybe(decoder));
};
var $author$project$Internal$List$Implementation$succeedIfContainerOrChildOfContainer = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$Internal$List$Implementation$succeedIfContainerOrChildOfContainer(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$Internal$List$Implementation$succeedIfLeavingList = function (targetId) {
	return $author$project$Internal$List$Implementation$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$author$project$Internal$List$Implementation$succeedIfContainerOrChildOfContainer(targetId)));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Internal$List$Implementation$ul = F5(
	function (domId, lift, model, options, items) {
		var listItemIds = $elm$core$Array$fromList(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Internal$List$Implementation$doListItemDomId(domId),
				items));
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$List$Implementation$defaultConfig, options);
		var config = summary.ea;
		var focusedIndex = function () {
			var _v0 = model.bP;
			if (!_v0.$) {
				var focused = _v0.a;
				return focused;
			} else {
				var _v1 = config.bn;
				if (!_v1.$) {
					var index = _v1.a;
					return index;
				} else {
					var _v2 = A2($author$project$Internal$List$Implementation$findIndex, $author$project$Internal$List$Implementation$liIsSelectedOrActivated, items);
					if (!_v2.$) {
						var i = _v2.a;
						return i;
					} else {
						return 0;
					}
				}
			}
		}();
		var list_nodes = A2(
			$elm$core$List$indexedMap,
			A6($author$project$Internal$List$Implementation$listItemView, domId, lift, model, config, listItemIds, focusedIndex),
			items);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			A2($elm$core$Maybe$withDefault, $elm$html$Html$ul, config.bW),
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-list'),
					A2($author$project$Internal$Options$when, !config.at, $author$project$Internal$List$Implementation$nonInteractiveClass),
					A2(
					$author$project$Internal$Options$when,
					config.ak,
					$author$project$Internal$Options$role('listbox')),
					A2(
					$author$project$Internal$Options$when,
					config.aj,
					$author$project$Internal$Options$role('radiogroup')),
					$author$project$Internal$Options$id(domId),
					A2(
					$author$project$Internal$Options$on,
					'focusout',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Basics$always(
							lift($author$project$Internal$List$Model$ResetFocusedItem)),
						$author$project$Internal$List$Implementation$succeedIfLeavingList(domId)))
				]),
			_List_Nil,
			list_nodes);
	});
var $author$project$Internal$Menu$Implementation$menu = F5(
	function (domId, lift, model, options, ulNode) {
		var listId = domId + '__list';
		var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Menu$Model$defaultGeometry, model.as);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Menu$Implementation$defaultConfig, options);
		var config = summary.ea;
		var _v0 = A2($author$project$Internal$Menu$Implementation$autoPosition, config, geometry);
		var position = _v0.$7;
		var transformOrigin = _v0.dS;
		var maxHeight = _v0.dd;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-menu mdc-menu-surface'),
					A2(
					$author$project$Internal$Options$when,
					model.aX && (!config.K),
					model.n ? $author$project$Internal$Options$cs('mdc-menu-surface--animating-open') : $author$project$Internal$Options$cs('mdc-menu-surface--animating-closed')),
					A2(
					$author$project$Internal$Options$when,
					model.n && ((!_Utils_eq(model.as, $elm$core$Maybe$Nothing)) || config.K),
					$author$project$Internal$Options$many(
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-menu-surface--open'),
								A2(
								$author$project$Internal$Options$onWithOptions,
								'click',
								$elm$json$Json$Decode$succeed(
									{
										de: lift($author$project$Internal$Menu$Model$CloseDelayed),
										dq: false,
										dF: true
									}))
							]))),
					A3(
					$elm$core$Basics$composeL,
					$author$project$Internal$Options$when(
						(model.n || model.aX) && (!_Utils_eq(model.as, $elm$core$Maybe$Nothing))),
					$author$project$Internal$Options$many,
					_List_fromArray(
						[
							A2($author$project$Internal$Options$css, 'transform-origin', transformOrigin),
							A2(
							$author$project$Internal$Options$when,
							!_Utils_eq(position.f, $elm$core$Maybe$Nothing),
							A2(
								$author$project$Internal$Options$css,
								'top',
								A2($elm$core$Maybe$withDefault, '', position.f))),
							A2(
							$author$project$Internal$Options$when,
							!_Utils_eq(position.p, $elm$core$Maybe$Nothing),
							A2(
								$author$project$Internal$Options$css,
								'left',
								A2($elm$core$Maybe$withDefault, '', position.p))),
							A2(
							$author$project$Internal$Options$when,
							!_Utils_eq(position.a, $elm$core$Maybe$Nothing),
							A2(
								$author$project$Internal$Options$css,
								'bottom',
								A2($elm$core$Maybe$withDefault, '', position.a))),
							A2(
							$author$project$Internal$Options$when,
							!_Utils_eq(position.b, $elm$core$Maybe$Nothing),
							A2(
								$author$project$Internal$Options$css,
								'right',
								A2($elm$core$Maybe$withDefault, '', position.b))),
							A2($author$project$Internal$Options$css, 'max-height', maxHeight)
						])),
					A2(
					$author$project$Internal$Options$when,
					(model.n || model.aX) && _Utils_eq(model.as, $elm$core$Maybe$Nothing),
					A2(
						$author$project$Internal$GlobalEvents$onTickWith,
						{dk: true, dN: false},
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeL,
								lift,
								$author$project$Internal$Menu$Model$Init(
									{
										cX: listId + ('--' + $elm$core$String$fromInt(
											A2($elm$core$Maybe$withDefault, 0, config.aG))),
										aG: config.aG,
										K: config.K
									})),
							$author$project$Internal$Menu$Implementation$decodeGeometry))),
					A2(
					$author$project$Internal$Options$on,
					'keyup',
					A2(
						$elm$json$Json$Decode$map,
						lift,
						A4($elm$json$Json$Decode$map3, $author$project$Internal$Menu$Model$KeyUp, $author$project$Internal$Keyboard$decodeMeta, $author$project$Internal$Keyboard$decodeKey, $author$project$Internal$Keyboard$decodeKeyCode))),
					A2(
					$author$project$Internal$Options$on,
					'keydown',
					A2(
						$elm$json$Json$Decode$map,
						lift,
						A4($elm$json$Json$Decode$map3, $author$project$Internal$Menu$Model$KeyDown, $author$project$Internal$Keyboard$decodeMeta, $author$project$Internal$Keyboard$decodeKey, $author$project$Internal$Keyboard$decodeKeyCode)))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A5(
					$author$project$Internal$List$Implementation$ul,
					listId,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Menu$Model$ListMsg),
					model.dc,
					_Utils_ap(
						ulNode.au,
						_List_fromArray(
							[
								$author$project$Internal$Options$role('menu'),
								A2($author$project$Internal$Options$aria, 'hidden', 'true'),
								A2($author$project$Internal$Options$aria, 'orientation', 'vertical'),
								$author$project$Internal$Options$tabindex(-1)
							])),
					$author$project$Internal$Menu$Implementation$toListItem(ulNode.cr))
				]));
	});
var $author$project$Internal$Menu$Implementation$view = F2(
	function (lift, domId) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$Menu$Implementation$getSet.cZ,
			$author$project$Internal$Menu$Implementation$menu(domId),
			$author$project$Internal$Msg$MenuMsg,
			lift,
			domId);
	});
var $author$project$Material$Menu$view = $author$project$Internal$Menu$Implementation$view;
var $author$project$Pages$ProjectCardView$viewProjectBranchMenu = F4(
	function (generalMdc, model, bttnMsg, proj) {
		return proj.cf ? _List_fromArray(
			[
				A5(
				$author$project$Material$Menu$view,
				generalMdc,
				proj.eF + '-action-branch-menu',
				model,
				_List_Nil,
				A3(
					$author$project$Pages$ProjectCardView$projectBranchMap,
					_List_fromArray(
						['master', 'dev']),
					proj,
					bttnMsg))
			]) : _List_Nil;
	});
var $author$project$Pages$ProjectCardView$viewProjectButtonBuild = F4(
	function (generalMdc, model, bttnMsg, proj) {
		return proj.cf ? _List_fromArray(
			[
				A5(
				$author$project$Material$Button$view,
				generalMdc,
				proj.eF + '-action-button-build',
				model,
				_List_fromArray(
					[
						$author$project$Material$Card$actionButton,
						$author$project$Material$Button$ripple,
						$author$project$Material$Theme$textPrimaryOnBackground,
						$author$project$Material$Button$outlined,
						A2($author$project$Material$Menu$attach, generalMdc, proj.eF + '-action-branch-menu')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Build')
					])),
				A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Material$Menu$surfaceAnchor]),
				A4($author$project$Pages$ProjectCardView$viewProjectBranchMenu, generalMdc, model, bttnMsg, proj)),
				A5(
				$author$project$Material$Button$view,
				generalMdc,
				proj.eF + '-action-button-log',
				model,
				_List_fromArray(
					[
						$author$project$Material$Card$actionButton,
						$author$project$Material$Button$ripple,
						$author$project$Material$Options$onClick(
						A2(bttnMsg.eA, proj.ao, proj.eF)),
						$author$project$Material$Theme$textSecondaryOnLight,
						$author$project$Material$Button$outlined,
						A2($author$project$Material$Options$css, 'display', 'none')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Log')
					]))
			]) : _List_Nil;
	});
var $author$project$Pages$ProjectCardView$viewProjectButtons = F4(
	function (generalMdc, model, bttnMsg, project) {
		return A2(
			$author$project$Material$Card$actions,
			_List_fromArray(
				[
					A2($author$project$Material$Options$css, 'padding', '0.7rem')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Card$actionButtons,
					_List_fromArray(
						[
							A2($author$project$Material$Options$css, 'display', 'inline')
						]),
					A4($author$project$Pages$ProjectCardView$viewProjectButtonBuild, generalMdc, model, bttnMsg, project)),
					A2(
					$author$project$Material$Card$actionIcons,
					_List_Nil,
					_List_fromArray(
						[
							A6(
							$author$project$Pages$ProjectCardView$viewProjectButton,
							generalMdc,
							model,
							project,
							_Utils_Tuple3('menu_book', 'booklet', bttnMsg.d2),
							project.B.d1,
							8),
							A6(
							$author$project$Pages$ProjectCardView$viewProjectButton,
							generalMdc,
							model,
							project,
							_Utils_Tuple3('folder', 'folder', bttnMsg.ee),
							project.B.eh,
							8),
							A6(
							$author$project$Pages$ProjectCardView$viewProjectButton,
							generalMdc,
							model,
							project,
							_Utils_Tuple3('photo_album', 'poster', bttnMsg.eO),
							project.B.eN,
							8),
							A6(
							$author$project$Pages$ProjectCardView$viewProjectButton,
							generalMdc,
							model,
							project,
							_Utils_Tuple3('ondemand_video', 'trailer', bttnMsg.e1),
							project.B.e0,
							8),
							A6(
							$author$project$Pages$ProjectCardView$viewProjectButton,
							generalMdc,
							model,
							project,
							_Utils_Tuple3('sports_esports', 'play', bttnMsg.eM),
							project.B.eL,
							14)
						]))
				]));
	});
var $author$project$Internal$Card$Implementation$aspect16To9 = $author$project$Internal$Options$cs('mdc-card__media--16-9');
var $author$project$Material$Card$aspect16To9 = $author$project$Internal$Card$Implementation$aspect16To9;
var $author$project$Internal$Card$Implementation$backgroundImage = function (url) {
	return A2($author$project$Internal$Options$css, 'background-image', 'url(' + (url + ')'));
};
var $author$project$Material$Card$backgroundImage = $author$project$Internal$Card$Implementation$backgroundImage;
var $author$project$Internal$Card$Implementation$media = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-card__media'),
			options));
};
var $author$project$Material$Card$media = $author$project$Internal$Card$Implementation$media;
var $author$project$Pages$ProjectCardView$projectImageUrl = F2(
	function (flags, project) {
		return A3($author$project$Pages$ProjectCardView$gen_demo_url_prefix, flags, project.ao, project.eF) + '/doc/thumbnail.jpg';
	});
var $author$project$Pages$ProjectCardView$viewProjectImage = F2(
	function (flags, project) {
		return project.B.dP.B ? A2(
			$author$project$Material$Card$media,
			_List_fromArray(
				[
					$author$project$Material$Card$aspect16To9,
					$author$project$Material$Card$backgroundImage(
					A2($author$project$Pages$ProjectCardView$projectImageUrl, flags, project))
				]),
			_List_Nil) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Internal$Typography$Implementation$headline6 = $author$project$Internal$Options$cs('mdc-typography--headline6');
var $author$project$Material$Typography$headline6 = $author$project$Internal$Typography$Implementation$headline6;
var $author$project$Internal$Typography$Implementation$subtitle2 = $author$project$Internal$Options$cs('mdc-typography--subtitle2');
var $author$project$Material$Typography$subtitle2 = $author$project$Internal$Typography$Implementation$subtitle2;
var $author$project$Internal$Typography$Implementation$body2 = $author$project$Internal$Options$cs('mdc-typography--body2');
var $author$project$Material$Typography$body2 = $author$project$Internal$Typography$Implementation$body2;
var $author$project$Pages$ProjectCardView$getColorByStatus = function (status) {
	switch (status) {
		case 'success':
			return '#5BC346';
		case 'building':
			return '#F5C330';
		case 'fail':
			return '#f50000';
		default:
			return '#000000';
	}
};
var $author$project$Pages$ProjectCardView$statusPrettify = function (status) {
	switch (status) {
		case 'success':
			return 'Success';
		case 'building':
			return 'Building';
		case 'fail':
			return 'Fail';
		default:
			return status;
	}
};
var $author$project$Pages$ProjectCardView$viewProjectStatus = function (project) {
	return project.cf ? _List_fromArray(
		[
			A3(
			$author$project$Material$Options$styled,
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($author$project$Material$Options$css, 'padding', '0.5rem 1rem 0.5rem 1rem'),
					A2($author$project$Material$Options$css, 'vertical-align', 'middle'),
					$author$project$Material$Typography$body2,
					A2(
					$author$project$Material$Options$css,
					'color',
					$author$project$Pages$ProjectCardView$getColorByStatus(project.eW))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Pages$ProjectCardView$statusPrettify(project.eW))
				]))
		]) : _List_Nil;
};
var $author$project$Pages$ProjectCardView$viewProjectTitle = function (project) {
	return A3(
		$author$project$Material$Options$styled,
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($author$project$Material$Options$css, 'padding', '0.5rem 1rem 0')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($author$project$Material$Options$css, 'display', 'flex'),
						A2($author$project$Material$Options$css, 'justify-content', 'space-between'),
						A2($author$project$Material$Options$css, 'align-items', 'center')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A3(
							$author$project$Material$Options$styled,
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$author$project$Material$Typography$headline6,
									A2($author$project$Material$Options$css, 'margin', '0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(project.bv)
								]))
						]),
					$author$project$Pages$ProjectCardView$viewProjectStatus(project))),
				A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$h3,
				_List_fromArray(
					[
						$author$project$Material$Typography$subtitle2,
						$author$project$Material$Theme$textSecondaryOnLight,
						A2($author$project$Material$Options$css, 'margin', '0.1rem'),
						A2($author$project$Material$Options$css, 'min-height', '2.5rem')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('by ' + project.d_)
					]))
			]));
};
var $author$project$Pages$ProjectCardView$viewProject = F5(
	function (generalMdc, materialModel, flags, msg, project) {
		return A2(
			$elm$html$Html$div,
			$author$project$Pages$ProjectCardView$getProjectWrapperStyle(project),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Card$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$ProjectCardView$viewProjectImage, flags, project),
							$author$project$Pages$ProjectCardView$viewProjectTitle(project),
							A4($author$project$Pages$ProjectCardView$viewProjectButtons, generalMdc, materialModel, msg, project)
						]))
				]));
	});
var $author$project$Pages$FameWall$viewProjectsWithMsg = F2(
	function (model, flags) {
		return A4($author$project$Pages$ProjectCardView$viewProject, $author$project$Pages$FameWall$Mdc, model, flags, $author$project$Pages$FameWall$bttnMsgSet);
	});
var $author$project$Pages$FameWall$viewContent = F2(
	function (model, content) {
		return (!$elm$core$List$isEmpty(content.cA)) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$elm_explorations$markdown$Markdown$toHtmlWith,
					$author$project$Pages$Markdown$markdownOptions,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('markdown-body')
						]),
					A3($author$project$Pages$FameWall$injectLinks, content.cv, model.m, content)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-right', '5%')
						]),
					_List_fromArray(
						[
							A3($author$project$Pages$FameWall$viewImg, model.m, 200, content.c3)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'display', 'grid'),
									A2($elm$html$Html$Attributes$style, 'grid-template-columns', 'repeat(3, 32%)'),
									A2($elm$html$Html$Attributes$style, 'grid-auto-flow', 'row dense'),
									A2($elm$html$Html$Attributes$style, 'grid-gap', '20px 20px'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$FameWall$viewProjectsWithMsg, model.aI, model.m),
								content.cA))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$elm_explorations$markdown$Markdown$toHtmlWith,
					$author$project$Pages$Markdown$markdownOptions,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('markdown-body')
						]),
					A3($author$project$Pages$FameWall$injectLinks, content.cv, model.m, content))
				]));
	});
var $author$project$Pages$FameWall$viewContents = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Pages$FameWall$viewContent(model),
			model.bI));
};
var $author$project$Pages$FameWall$viewTitle = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$id('famewalltitle')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'max-width', '1200px'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '45px'),
					A2($elm$html$Html$Attributes$style, 'padding-right', '45px'),
					A2($elm$html$Html$Attributes$style, 'padding-bottom', '10.8px'),
					A2($elm$html$Html$Attributes$style, 'padding-top', '24px'),
					A2($elm$html$Html$Attributes$style, 'padding-left', '45px'),
					A2($elm$html$Html$Attributes$style, 'margin-right', 'auto'),
					A2($elm$html$Html$Attributes$style, 'margin-left', 'auto'),
					A2($elm$html$Html$Attributes$style, 'font-size', '36px'),
					A2($elm$html$Html$Attributes$style, 'font-weight', '600'),
					A2($elm$html$Html$Attributes$style, 'font-family', '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji'),
					A2($elm$html$Html$Attributes$style, 'border-bottom-color', 'rgb(234, 236, 239)'),
					A2($elm$html$Html$Attributes$style, 'border-bottom-style', 'solid'),
					A2($elm$html$Html$Attributes$style, 'border-bottom-width', '1px'),
					A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
					A2($elm$html$Html$Attributes$style, 'line-height', '45px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('SilverFOCS Wall of Fame')
				]))
		]));
var $author$project$Pages$FameWall$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				$author$project$Pages$FameWall$viewTitle,
				$author$project$Pages$FameWall$viewContents(model),
				A5($author$project$Pages$ProjectDialog$trailorDialog, $author$project$Pages$FameWall$Mdc, model.aI, model.cQ, $author$project$Pages$FameWall$OnCloseTrailer, model.m)
			]));
};
var $author$project$Routes$pathFor = function (route) {
	switch (route.$) {
		case 0:
			return '/silverfocs/players';
		case 1:
			var id = route.a;
			return '/silverfocs/players/' + id;
		case 2:
			return '/silverfocs';
		case 3:
			var name = route.a;
			return '/silverfocs/markdown/' + name;
		case 4:
			var array = route.a;
			return '/silverfocs/src/' + A2($elm$core$String$join, '/', array);
		case 5:
			var year = route.a;
			var projName = route.b;
			return '/silverfocs/project/' + ($elm$core$String$fromInt(year) + ('/' + projName));
		case 6:
			return '/silverfocs/famewall';
		case 7:
			return '/silverfocs/philosophy';
		default:
			return '/silverfocs';
	}
};
var $author$project$Routes$playerPath = function (id) {
	return $author$project$Routes$pathFor(
		$author$project$Routes$PlayerRoute(id));
};
var $author$project$Pages$List$editBtn = function (player) {
	var path = $author$project$Routes$playerPath(player.et);
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('btn regular'),
				$elm$html$Html$Attributes$href(path)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa fa-edit mr-1')
					]),
				_List_Nil),
				$elm$html$Html$text('Edit')
			]));
};
var $author$project$Pages$List$Click = {$: 2};
var $author$project$Pages$List$mdcBtn = F2(
	function (model, player) {
		return A5(
			$author$project$Material$Button$view,
			$author$project$Pages$List$Mdc,
			'my-button' + player.et,
			model.aI,
			_List_fromArray(
				[
					$author$project$Material$Button$ripple,
					$author$project$Material$Options$onClick($author$project$Pages$List$Click)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Click me!')
				]));
	});
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Pages$List$playerRow = F2(
	function (model, player) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(player.et)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(player.eF)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(player.ct))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-2')
						]),
					_List_fromArray(
						[
							$author$project$Pages$List$editBtn(player)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-2')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$List$mdcBtn, model, player)
						]))
				]));
	});
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Pages$List$viewWithData = F2(
	function (model, players) {
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('p-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Id')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('p-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Name')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('p-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Level')
										])),
									A2(
									$elm$html$Html$th,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('p-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Actions')
										]))
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (p) {
							return A2($author$project$Pages$List$playerRow, model, p);
						},
						players))
				]));
	});
var $author$project$Pages$List$viewList = function (model) {
	var _v0 = model.bi;
	switch (_v0.$) {
		case 0:
			return $elm$html$Html$text('');
		case 1:
			return $elm$html$Html$text('Loading ...');
		case 2:
			var players = _v0.a;
			return A2($author$project$Pages$List$viewWithData, model, players);
		default:
			return $elm$html$Html$text('Error');
	}
};
var $author$project$Pages$List$view = function (model) {
	return $author$project$Pages$List$viewList(model);
};
var $author$project$Pages$Markdown$injectLinks = F2(
	function (markdown, model) {
		return A3(
			$elm$core$String$replace,
			'(/src/',
			'(' + (model.m.dp + '/src/'),
			A3(
				$elm$core$String$replace,
				'(/demo/',
				'(' + (model.m.cJ + (model.m.dp + '/demo/')),
				A3(
					$elm$core$String$replace,
					'src=\"./',
					'src=\"' + (model.m.cJ + (model.m.dp + ('/api/markdown/' + (model.bU + '/../')))),
					A3($elm$core$String$replace, '](./', '](' + (model.m.cJ + (model.m.dp + ('/api/markdown/' + (model.bU + '/../')))), markdown))));
	});
var $author$project$Pages$Markdown$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				A3(
				$elm_explorations$markdown$Markdown$toHtmlWith,
				$author$project$Pages$Markdown$markdownOptions,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('markdown-body')
					]),
				A2($author$project$Pages$Markdown$injectLinks, model.cv, model))
			]));
};
var $author$project$Pages$Philosophy$injectLinks = F3(
	function (flags, markdown, cellName) {
		return A3(
			$elm$core$String$replace,
			'(/src/',
			'(' + (flags.dp + '/src/'),
			A3(
				$elm$core$String$replace,
				'(/demo/',
				'(' + (flags.cJ + (flags.dp + '/demo/')),
				A3(
					$elm$core$String$replace,
					'src=\"./',
					'src=\"' + (flags.cJ + (flags.dp + ('/api/philosophy/' + (cellName + '/index.md/../')))),
					A3($elm$core$String$replace, '](./', '](' + (flags.cJ + (flags.dp + ('/api/philosophy/' + (cellName + '/index.md/../')))), markdown))));
	});
var $author$project$Pages$Philosophy$viewMarkdown = F3(
	function (flags, cellName, markdown) {
		return A3(
			$elm_explorations$markdown$Markdown$toHtmlWith,
			$author$project$Pages$Markdown$markdownOptions,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(cellName),
					$elm$html$Html$Attributes$class('markdown-body')
				]),
			A3($author$project$Pages$Philosophy$injectLinks, flags, markdown, cellName));
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$canvas = _VirtualDom_node('canvas');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Philosophy$viewWheel = function (cellName) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'text-align', 'center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$canvas,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(cellName),
						$elm$html$Html$Attributes$width(550),
						$elm$html$Html$Attributes$height(600),
						$elm$html$Html$Attributes$class('wheel')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Your browser does not support this function.')
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Philosophy$viewCell = F2(
	function (flags, cell) {
		switch (cell.$) {
			case 0:
				var cellName = cell.a;
				var markdown = cell.b;
				return A3($author$project$Pages$Philosophy$viewMarkdown, flags, cellName, markdown);
			case 1:
				var cellName = cell.a;
				return $author$project$Pages$Philosophy$viewWheel(cellName);
			default:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $author$project$Pages$Philosophy$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Philosophy$viewCell(model.m),
			model.bI));
};
var $author$project$Pages$Project$OnClickDownload = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Project$getDownloadStatus = function (status) {
	if (!status) {
		return '### The server is right now packaging the data that you have required. Please wait. \n';
	} else {
		return 'If it does not start in several minutes, **Please check whether the browser has blocked the pop-up windows**.';
	}
};
var $author$project$Internal$LinearProgress$Implementation$indeterminate = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{a6: true});
	});
var $author$project$Material$LinearProgress$indeterminate = $author$project$Internal$LinearProgress$Implementation$indeterminate;
var $author$project$Internal$LinearProgress$Implementation$defaultConfig = {bE: 0, bF: false, cp: false, a6: false, b5: false, bC: 0};
var $author$project$Internal$LinearProgress$Implementation$view = F2(
	function (options, _v0) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$LinearProgress$Implementation$defaultConfig, options);
		var config = summary.ea;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-linear-progress'),
					A2(
					$author$project$Internal$Options$when,
					config.a6,
					$author$project$Internal$Options$cs('mdc-linear-progress--indeterminate')),
					A2(
					$author$project$Internal$Options$when,
					config.b5,
					$author$project$Internal$Options$cs('mdc-linear-progress--reversed'))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__buffering-dots')
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__buffer'),
							A2(
							$author$project$Internal$Options$when,
							config.bF,
							A2(
								$author$project$Internal$Options$css,
								'transform',
								'scaleX(' + ($elm$core$String$fromFloat(config.bE) + ')')))
						]),
					_List_Nil),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__bar mdc-linear-progress__primary-bar'),
							A2(
							$author$project$Internal$Options$when,
							!config.a6,
							A2(
								$author$project$Internal$Options$css,
								'transform',
								'scaleX(' + ($elm$core$String$fromFloat(config.bC) + ')')))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-linear-progress__bar-inner')
								]),
							_List_Nil)
						])),
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-linear-progress__bar mdc-linear-progress__secondary-bar')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-linear-progress__bar-inner')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Material$LinearProgress$view = $author$project$Internal$LinearProgress$Implementation$view;
var $author$project$Pages$ProjectDialog$projProgressInd = function (on) {
	return on ? A2(
		$author$project$Material$LinearProgress$view,
		_List_fromArray(
			[$author$project$Material$LinearProgress$indeterminate]),
		_List_Nil) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$Internal$Dialog$Implementation$scrollable = $author$project$Internal$Options$cs('mdc-dialog__body--scrollable');
var $author$project$Material$Dialog$scrollable = $author$project$Internal$Dialog$Implementation$scrollable;
var $elm_explorations$markdown$Markdown$defaultOptions = {
	ec: $elm$core$Maybe$Nothing,
	eq: $elm$core$Maybe$Just(
		{d3: false, e$: false}),
	eT: true,
	eV: false
};
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$Pages$Project$bulkDialogBody = function (status) {
	return _List_fromArray(
		[
			$author$project$Pages$ProjectDialog$projProgressInd(!status),
			A2(
			$author$project$Material$Dialog$content,
			_List_fromArray(
				[$author$project$Material$Dialog$scrollable]),
			_List_fromArray(
				[
					A2(
					$elm_explorations$markdown$Markdown$toHtml,
					_List_Nil,
					$author$project$Pages$Project$getDownloadStatus(status))
				]))
		]);
};
var $author$project$Pages$Project$isBulk = function (dialog) {
	if (dialog.$ === 3) {
		var x = dialog.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Project$bulkDialog = function (model) {
	return A5(
		$author$project$Material$Dialog$view,
		$author$project$Pages$Project$Mdc,
		'bulk-log',
		model.aI,
		_List_fromArray(
			[
				A2(
				$author$project$Material$Options$when,
				$author$project$Pages$Project$isBulk(model.cQ),
				$author$project$Material$Dialog$open),
				$author$project$Material$Dialog$onClose($author$project$Pages$Project$OnCloseDialog)
			]),
		function () {
			var _v0 = model.cQ;
			if (_v0.$ === 3) {
				var status = _v0.a;
				return $author$project$Pages$Project$bulkDialogBody(status);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Internal$TabBar$Implementation$activeTab = function (value) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{r: value});
		});
};
var $author$project$Material$TabBar$activeTab = $author$project$Internal$TabBar$Implementation$activeTab;
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Pages$Project$projName2Int = function (name) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(
			A2(
				$elm$core$String$right,
				$elm$core$String$length(name) - 1,
				name)));
};
var $author$project$Pages$Project$OnClickTab = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Project$projectNameFormal = function (original) {
	return A3($elm$core$String$replace, 'p', 'Project ', original);
};
var $author$project$Internal$TabBar$Implementation$tab = F2(
	function (options, childs) {
		return {ch: childs, au: options};
	});
var $author$project$Material$TabBar$tab = $author$project$Internal$TabBar$Implementation$tab;
var $author$project$Pages$Project$projectTab = function (projname) {
	return A2(
		$author$project$Material$TabBar$tab,
		_List_fromArray(
			[
				$author$project$Material$Options$onClick(
				$author$project$Pages$Project$OnClickTab(projname))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Project$projectNameFormal(projname))
			]));
};
var $author$project$Internal$TabBar$Model$SetActiveTab = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $debois$elm_dom$DOM$childNode = function (idx) {
	return $elm$json$Json$Decode$at(
		_List_fromArray(
			[
				'childNodes',
				$elm$core$String$fromInt(idx)
			]));
};
var $debois$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $author$project$Internal$TabBar$Implementation$decodeScrollLeft = $debois$elm_dom$DOM$target(
	A2(
		$debois$elm_dom$DOM$childNode,
		0,
		A2(
			$debois$elm_dom$DOM$childNode,
			0,
			A2(
				$elm$json$Json$Decode$map,
				function (scrollLeft) {
					return scrollLeft;
				},
				$debois$elm_dom$DOM$scrollLeft))));
var $author$project$Internal$TabBar$Implementation$defaultConfig = {r: 0, aD: false, aF: $elm$core$Maybe$Nothing, c4: true, a7: $elm$core$Maybe$Nothing, bp: false};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Internal$TabBar$Model$Init = function (a) {
	return {$: 3, a: a};
};
var $author$project$Internal$TabBar$Model$Geometry = F3(
	function (tabs, scrollArea, tabBar) {
		return {dB: scrollArea, dJ: tabBar, bs: tabs};
	});
var $debois$elm_dom$DOM$childNodes = function (decoder) {
	var loop = F2(
		function (idx, xs) {
			return A2(
				$elm$json$Json$Decode$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						function (x) {
							return A2(
								loop,
								idx + 1,
								A2($elm$core$List$cons, x, xs));
						}),
					$elm$core$Maybe$withDefault(
						$elm$json$Json$Decode$succeed(xs))),
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$field,
						$elm$core$String$fromInt(idx),
						decoder)));
		});
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$reverse,
		A2(
			$elm$json$Json$Decode$field,
			'childNodes',
			A2(loop, 0, _List_Nil)));
};
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Internal$TabBar$Implementation$decodeGeometry = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Internal$TabBar$Model$Geometry,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$debois$elm_dom$DOM$childNodes(
			A2(
				$elm$json$Json$Decode$andThen,
				function (tagName) {
					var _v0 = $elm$core$String$toLower(tagName);
					if (_v0 === 'button') {
						var content = $debois$elm_dom$DOM$childNode(0);
						return A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$Just,
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (offsetLeft, offsetWidth) {
										return {ck: offsetLeft + 24, cl: ((offsetLeft + offsetWidth) - 24) - 24, aJ: offsetLeft, I: offsetWidth};
									}),
								$debois$elm_dom$DOM$offsetLeft,
								$debois$elm_dom$DOM$offsetWidth));
					} else {
						return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
					}
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['tagName']),
					$elm$json$Json$Decode$string)))),
	$debois$elm_dom$DOM$parentElement(
		A2(
			$elm$json$Json$Decode$map,
			function (offsetWidth) {
				return {I: offsetWidth};
			},
			$debois$elm_dom$DOM$offsetWidth)),
	$debois$elm_dom$DOM$parentElement(
		$debois$elm_dom$DOM$parentElement(
			$debois$elm_dom$DOM$parentElement(
				A2(
					$elm$json$Json$Decode$map,
					function (offsetWidth) {
						return {I: offsetWidth};
					},
					$debois$elm_dom$DOM$offsetWidth)))));
var $author$project$Internal$TabBar$Implementation$decodeGeometryOnScrollContent = $debois$elm_dom$DOM$target($author$project$Internal$TabBar$Implementation$decodeGeometry);
var $author$project$Internal$GlobalEvents$onResize = $author$project$Internal$GlobalEvents$listener('globalresize');
var $author$project$Internal$TabBar$Implementation$scroller = F5(
	function (domId, lift, model, options, nodes) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TabBar$Implementation$defaultConfig, options);
		var config = summary.ea;
		return A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-tab-scroller')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Internal$Options$id(domId + '__scroll-area'),
							$author$project$Internal$Options$cs('mdc-tab-scroller__scroll-area'),
							$author$project$Internal$Options$cs('mdc-tab-scroller__scroll-area--scroll'),
							A2($author$project$Internal$Options$css, 'margin-bottom', 'calc(-1 * var(--elm-mdc-horizontal-scrollbar-height))')
						]),
					_List_fromArray(
						[
							A5(
							$author$project$Internal$Options$apply,
							summary,
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-tab-scroller__scroll-content'),
									A2(
									$author$project$Internal$Options$when,
									_Utils_eq(model.as, $elm$core$Maybe$Nothing),
									$author$project$Internal$GlobalEvents$onTick(
										A2(
											$elm$json$Json$Decode$map,
											A2($elm$core$Basics$composeL, lift, $author$project$Internal$TabBar$Model$Init),
											$author$project$Internal$TabBar$Implementation$decodeGeometryOnScrollContent))),
									$author$project$Internal$GlobalEvents$onResize(
									A2(
										$elm$json$Json$Decode$map,
										A2($elm$core$Basics$composeL, lift, $author$project$Internal$TabBar$Model$Init),
										$author$project$Internal$TabBar$Implementation$decodeGeometryOnScrollContent))
								]),
							_List_Nil,
							nodes)
						]))
				]));
	});
var $author$project$Internal$TabBar$Implementation$tabView = F6(
	function (domId, lift, model, options, index, tab_) {
		var tab_summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TabBar$Implementation$defaultConfig, tab_.au);
		var tab_config = tab_summary.ea;
		var tabDomId = domId + ('--' + $elm$core$String$fromInt(index));
		var ripple = A5(
			$author$project$Internal$Ripple$Implementation$view,
			false,
			tabDomId,
			A2(
				$elm$core$Basics$composeL,
				lift,
				$author$project$Internal$TabBar$Model$RippleMsg(index)),
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Internal$Ripple$Model$defaultModel,
				A2($elm$core$Dict$get, index, model.bk)),
			_List_Nil);
		var icon_span = function () {
			var _v2 = tab_config.aF;
			if (!_v2.$) {
				var name = _v2.a;
				return A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-tab__icon'),
							$author$project$Internal$Options$cs('material-icons'),
							A2($author$project$Internal$Options$aria, 'hidden', 'true')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var icon_name = function () {
			var _v1 = tab_config.a7;
			if (!_v1.$) {
				var name = _v1.a;
				return name;
			} else {
				return '';
			}
		}();
		var icon_indicator = function () {
			var _v0 = tab_config.a7;
			if (!_v0.$) {
				return true;
			} else {
				return false;
			}
		}();
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TabBar$Implementation$defaultConfig, options);
		var config = summary.ea;
		var selected = _Utils_eq(model.r, index) || (tab_config.aD && _Utils_eq(config.r, index));
		var stateChanged = !_Utils_eq(config.r, model.r);
		var to_be_selected = (stateChanged && _Utils_eq(config.r, index)) && (!tab_config.aD);
		var indicatorTransform = function () {
			if (to_be_selected) {
				var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$TabBar$Model$defaultGeometry, model.as);
				var previousTab = $elm$core$List$head(
					A2($elm$core$List$drop, model.r, geometry.bs));
				var previousTabWidth = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.I;
						},
						previousTab));
				var fromX = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aJ;
						},
						previousTab));
				var currentTab = $elm$core$List$head(
					A2($elm$core$List$drop, config.r, geometry.bs));
				var currentTabWidth = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.I;
						},
						currentTab));
				var widthDelta = previousTabWidth / currentTabWidth;
				var currentX = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.aJ;
						},
						currentTab));
				var xPosition = fromX - currentX;
				return A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'translateX(' + ($elm$core$String$fromFloat(xPosition) + 'px)'),
							'scale(' + ($elm$core$String$fromFloat(widthDelta) + ',1)')
						]));
			} else {
				return '';
			}
		}();
		var indicator_span = A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$span,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-tab-indicator'),
					A2(
					$author$project$Internal$Options$when,
					selected,
					$author$project$Internal$Options$cs('mdc-tab-indicator--active')),
					A2(
					$author$project$Internal$Options$when,
					to_be_selected,
					$author$project$Internal$Options$cs('mdc-tab-indicator--no-transition')),
					A2(
					$author$project$Internal$Options$when,
					tab_config.aD,
					$author$project$Internal$Options$cs('mdc-tab-indicator--fade'))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-tab-indicator__content'),
							A2(
							$author$project$Internal$Options$when,
							!icon_indicator,
							$author$project$Internal$Options$cs('mdc-tab-indicator__content--underline')),
							A2(
							$author$project$Internal$Options$when,
							icon_indicator,
							$author$project$Internal$Options$cs('mdc-tab-indicator__content--icon')),
							A2(
							$author$project$Internal$Options$when,
							icon_indicator,
							$author$project$Internal$Options$cs('material-icons')),
							A2(
							$author$project$Internal$Options$when,
							to_be_selected,
							A2($author$project$Internal$Options$css, 'transform', indicatorTransform))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(icon_name)
						]))
				]));
		return A5(
			$author$project$Internal$Options$apply,
			tab_summary,
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-tab'),
					A2(
					$author$project$Internal$Options$when,
					selected,
					$author$project$Internal$Options$cs('mdc-tab--active')),
					$author$project$Internal$Options$role('tab'),
					A2(
					$author$project$Internal$Options$aria,
					'selected',
					selected ? 'true' : 'false'),
					$author$project$Internal$Options$tabindex(
					selected ? 0 : (-1)),
					ripple.ex
				]),
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-tab__content')
						]),
					_List_fromArray(
						[
							icon_span,
							A3(
							$author$project$Internal$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Internal$Options$cs('mdc-tab__text-label')
								]),
							tab_.ch),
							tab_config.bp ? indicator_span : $elm$html$Html$text('')
						])),
					tab_config.bp ? $elm$html$Html$text('') : indicator_span,
					A3(
					$author$project$Internal$Options$styled,
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Internal$Options$cs('mdc-tab__ripple'),
							ripple.eP
						]),
					_List_Nil)
				]));
	});
var $author$project$Internal$TabBar$Implementation$tabbar = F5(
	function (domId, lift, model, options, nodes) {
		var tab_nodes = A2(
			$elm$core$List$indexedMap,
			A4($author$project$Internal$TabBar$Implementation$tabView, domId, lift, model, options),
			nodes);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TabBar$Implementation$defaultConfig, options);
		var config = summary.ea;
		var stateChanged = !_Utils_eq(config.r, model.r);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-tab-bar'),
					$author$project$Internal$Options$role('tablist'),
					A2(
					$author$project$Internal$Options$when,
					stateChanged,
					$author$project$Internal$GlobalEvents$onTick(
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeL,
								lift,
								A2($author$project$Internal$TabBar$Model$SetActiveTab, domId, config.r)),
							$author$project$Internal$TabBar$Implementation$decodeScrollLeft)))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Internal$TabBar$Implementation$scroller, domId, lift, model, options, tab_nodes)
				]));
	});
var $author$project$Internal$TabBar$Implementation$view = F2(
	function (lift, domId) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$TabBar$Implementation$getSet.cZ,
			$author$project$Internal$TabBar$Implementation$tabbar(domId),
			$author$project$Internal$Msg$TabBarMsg,
			lift,
			domId);
	});
var $author$project$Material$TabBar$view = $author$project$Internal$TabBar$Implementation$view;
var $author$project$Pages$Project$projTabBarView = function (model) {
	return A5(
		$author$project$Material$TabBar$view,
		$author$project$Pages$Project$Mdc,
		'proj-tab-bar',
		model.aI,
		_List_fromArray(
			[
				$author$project$Material$TabBar$activeTab(
				$author$project$Pages$Project$projName2Int(model.aN) - 1)
			]),
		_List_fromArray(
			[
				$author$project$Pages$Project$projectTab('p1'),
				$author$project$Pages$Project$projectTab('p2')
			]));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Pages$ProjectDialog$wrapOutputMarkdown = function (data) {
	return A2(
		$elm_explorations$markdown$Markdown$toHtml,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('markdown-body')
			]),
		'```\n' + (A2($elm$core$Maybe$withDefault, '', data) + '```\n'));
};
var $author$project$Pages$ProjectDialog$scrollableLogDialogBody = function (project) {
	var titleBase = 'Building log of ' + project.eF;
	var title = (project.eW === 'building') ? (titleBase + ' (refresh every 5 seconds)') : titleBase;
	return _List_fromArray(
		[
			$author$project$Pages$ProjectDialog$projProgressInd(project.eW === 'building'),
			A3(
			$author$project$Material$Options$styled,
			$elm$html$Html$h2,
			_List_fromArray(
				[$author$project$Material$Dialog$title]),
			_List_fromArray(
				[
					$elm$html$Html$text(title)
				])),
			A2(
			$author$project$Material$Dialog$content,
			_List_fromArray(
				[$author$project$Material$Dialog$scrollable]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Status: '),
							A3(
							$author$project$Material$Options$styled,
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Options$css,
									'color',
									$author$project$Pages$ProjectCardView$getColorByStatus(project.eW))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$ProjectCardView$statusPrettify(project.eW))
								]))
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Return Code: ' + $elm$core$String$fromInt(project.d9))
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Build Output: ')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$ProjectDialog$wrapOutputMarkdown(project.eY)
						])),
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Errors: ')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$ProjectDialog$wrapOutputMarkdown(project.eX)
						]))
				]))
		]);
};
var $author$project$Pages$ProjectDialog$scrollableLogDialog = F5(
	function (generalMdc, materialModel, dialog, currentProject, closeMsg) {
		return A5(
			$author$project$Material$Dialog$view,
			generalMdc,
			'dialog-log',
			materialModel,
			_List_fromArray(
				[
					A2(
					$author$project$Material$Options$when,
					_Utils_eq(dialog, $author$project$Pages$ProjectDialog$Log) && (!_Utils_eq(currentProject, $elm$core$Maybe$Nothing)),
					$author$project$Material$Dialog$open),
					$author$project$Material$Dialog$onClose(closeMsg)
				]),
			$author$project$Pages$ProjectDialog$scrollableLogDialogBody(
				A2($elm$core$Maybe$withDefault, $author$project$Project$defaultProject, currentProject)));
	});
var $author$project$Pages$Project$OnClickBooklet = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Project$OnClickBuild = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Pages$Project$OnClickDoc = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Project$OnClickLog = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Project$OnClickPlay = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Project$OnClickPoster = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Project$OnClickTrailer = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Project$bttnMsgSet = {d2: $author$project$Pages$Project$OnClickBooklet, d4: $author$project$Pages$Project$OnClickBuild, ee: $author$project$Pages$Project$OnClickDoc, eA: $author$project$Pages$Project$OnClickLog, eM: $author$project$Pages$Project$OnClickPlay, eO: $author$project$Pages$Project$OnClickPoster, e1: $author$project$Pages$Project$OnClickTrailer};
var $author$project$Pages$Project$viewProjectsWithMsg = F2(
	function (model, flags) {
		return A4($author$project$Pages$ProjectCardView$viewProject, $author$project$Pages$Project$Mdc, model, flags, $author$project$Pages$Project$bttnMsgSet);
	});
var $author$project$Pages$Project$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Project$projTabBarView(model),
				$author$project$Pages$ProjectDialog$projProgressInd(
				$elm$core$List$isEmpty(model.cA)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'grid'),
								A2($elm$html$Html$Attributes$style, 'grid-template-columns', 'repeat(3, 32%)'),
								A2($elm$html$Html$Attributes$style, 'grid-auto-flow', 'row dense'),
								A2($elm$html$Html$Attributes$style, 'grid-gap', '20px 20px'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Project$viewProjectsWithMsg, model.aI, model.m),
							model.cA)),
						A5($author$project$Pages$ProjectDialog$scrollableLogDialog, $author$project$Pages$Project$Mdc, model.aI, model.cQ, model.aq, $author$project$Pages$Project$OnCloseDialog),
						A5($author$project$Pages$ProjectDialog$trailorDialog, $author$project$Pages$Project$Mdc, model.aI, model.cQ, $author$project$Pages$Project$OnCloseDialog, model.m),
						$author$project$Pages$Project$bulkDialog(model),
						A5(
						$author$project$Material$Button$view,
						$author$project$Pages$Project$Mdc,
						$elm$core$String$fromInt(model.ao) + '-bulk-download',
						model.aI,
						_List_fromArray(
							[
								$author$project$Material$Card$actionButton,
								$author$project$Material$Button$ripple,
								$author$project$Material$Options$onClick(
								A2($author$project$Pages$Project$OnClickDownload, model.ao, model.aN))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Download All Promotional Materials')
							]))
					]))
			]));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {aG: index, eB: match, eG: number, eZ: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{d7: false, eE: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Pages$SourceCode$extension = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\.(\\w+)$'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Pages$SourceCode$getExtension = function (filename) {
	var match = A2($elm$regex$Regex$find, $author$project$Pages$SourceCode$extension, filename);
	var firstMatch = A2(
		$elm$core$Maybe$withDefault,
		A4($elm$regex$Regex$Match, '', 0, 0, _List_Nil),
		$elm$core$List$head(match));
	var firstSubMatch = A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Just('txt'),
		$elm$core$List$head(firstMatch.eZ));
	var result = A2($elm$core$Maybe$withDefault, 'txt', firstSubMatch);
	return result;
};
var $author$project$Pages$SourceCode$injectEnv = F2(
	function (src, model) {
		return '# ' + (model.b8 + ('\n```' + ($author$project$Pages$SourceCode$getExtension(model.b8) + ('\n' + (src + '\n```')))));
	});
var $author$project$Pages$SourceCode$myOptions = {
	ec: $elm$core$Maybe$Nothing,
	eq: $elm$core$Maybe$Just(
		{d3: true, e$: true}),
	eT: false,
	eV: true
};
var $author$project$Pages$SourceCode$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				A3(
				$elm_explorations$markdown$Markdown$toHtmlWith,
				$author$project$Pages$SourceCode$myOptions,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('markdown-body')
					]),
				A2($author$project$Pages$SourceCode$injectEnv, model.br, model))
			]));
};
var $author$project$Main$currentPage = function (model) {
	var page = function () {
		var _v0 = model.z;
		switch (_v0.$) {
			case 1:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ListMsg,
					$author$project$Pages$List$view(pageModel));
			case 2:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$EditMsg,
					$author$project$Pages$Edit$view(pageModel));
			case 3:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$MarkdownMsg,
					$author$project$Pages$Markdown$view(pageModel));
			case 4:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$SourceCodeMsg,
					$author$project$Pages$SourceCode$view(pageModel));
			case 5:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$ProjectMsg,
					$author$project$Pages$Project$view(pageModel));
			case 6:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$FameWallMsg,
					$author$project$Pages$FameWall$view(pageModel));
			case 7:
				var pageModel = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Main$PhilosophyMsg,
					$author$project$Pages$Philosophy$view(pageModel));
			default:
				return $author$project$Main$notFoundView;
		}
	}();
	return page;
};
var $author$project$Internal$Drawer$Dismissible$Implementation$appContent = $author$project$Internal$Options$cs('mdc-drawer-app-content');
var $author$project$Material$Drawer$Dismissible$appContent = $author$project$Internal$Drawer$Dismissible$Implementation$appContent;
var $author$project$Material$Options$cs = $author$project$Internal$Options$cs;
var $author$project$Internal$Typography$Implementation$typography = $author$project$Internal$Options$cs('mdc-typography');
var $author$project$Material$Typography$typography = $author$project$Internal$Typography$Implementation$typography;
var $author$project$Main$ToggleDrawer = {$: 10};
var $author$project$Internal$Drawer$Implementation$content = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-drawer__content'),
			options));
};
var $author$project$Internal$Drawer$Dismissible$Implementation$content = $author$project$Internal$Drawer$Implementation$content;
var $author$project$Material$Drawer$Dismissible$content = $author$project$Internal$Drawer$Dismissible$Implementation$content;
var $author$project$Material$List$a = F2(
	function (options, items) {
		return A2(
			$author$project$Internal$List$Implementation$li,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$List$Implementation$node($elm$html$Html$a),
				options),
			items);
	});
var $author$project$Internal$List$Implementation$activated = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{aU: true});
	});
var $author$project$Material$List$activated = $author$project$Internal$List$Implementation$activated;
var $author$project$Material$Options$attribute = $author$project$Internal$Options$attribute;
var $author$project$Config$current_year_title = 'Year ' + $elm$core$String$fromInt($author$project$Config$current_year);
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Internal$List$Implementation$hr = function (options) {
	return A2(
		$author$project$Internal$List$Implementation$asListItem,
		$elm$html$Html$hr,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-list-divider'),
			options));
};
var $author$project$Material$List$hr = $author$project$Internal$List$Implementation$hr;
var $author$project$Main$drawerLink = F3(
	function (currentPageId, _v0, level) {
		var pageId = _v0.a;
		var pageConfig = _v0.b;
		var p_ = function () {
			var p = pageConfig;
			return p;
		}();
		var with_tag = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('drawerTagWrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(p_.bv)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('drawerLabel'),
								A2($elm$html$Html$Attributes$style, 'display', 'none')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Coming Soon')
							]))
					]))
			]);
		var without_tag = _List_fromArray(
			[
				$elm$html$Html$text(p_.bv)
			]);
		var what_shown = _Utils_eq(p_.bv, $author$project$Config$current_year_title) ? with_tag : without_tag;
		var parent = A2(
			$author$project$Material$List$a,
			_List_fromArray(
				[
					$author$project$Material$Options$attribute(
					$elm$html$Html$Attributes$href(p_.c1)),
					A2(
					$author$project$Material$Options$when,
					_Utils_eq(pageId, currentPageId),
					$author$project$Material$List$activated)
				]),
			what_shown);
		var hr = (!level) ? _List_fromArray(
			[
				A2($author$project$Material$List$hr, _List_Nil, _List_Nil)
			]) : _List_Nil;
		var children = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (p) {
					return A3($author$project$Main$drawerLink, currentPageId, p, level + 1);
				},
				p_.a_));
		return _Utils_ap(
			_List_fromArray(
				[parent]),
			_Utils_ap(children, hr));
	});
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Internal$Drawer$Implementation$header = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$header,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-drawer__header'),
			options));
};
var $author$project$Internal$Drawer$Dismissible$Implementation$header = $author$project$Internal$Drawer$Implementation$header;
var $author$project$Material$Drawer$Dismissible$header = $author$project$Internal$Drawer$Dismissible$Implementation$header;
var $author$project$Internal$List$Implementation$view = F2(
	function (lift, domId) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$List$Implementation$getSet.cZ,
			$author$project$Internal$List$Implementation$ul(domId),
			$author$project$Internal$Msg$ListMsg,
			lift,
			domId);
	});
var $author$project$Material$List$nav = F5(
	function (lift, domId, model, options, items) {
		return A5(
			$author$project$Internal$List$Implementation$view,
			lift,
			domId,
			model,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$List$Implementation$node($elm$html$Html$nav),
				options),
			items);
	});
var $author$project$Internal$Drawer$Implementation$onClose = function (handler) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{
					bd: $elm$core$Maybe$Just(handler)
				});
		});
};
var $author$project$Internal$Drawer$Dismissible$Implementation$onClose = $author$project$Internal$Drawer$Implementation$onClose;
var $author$project$Material$Drawer$Dismissible$onClose = $author$project$Internal$Drawer$Dismissible$Implementation$onClose;
var $author$project$Internal$Drawer$Implementation$open = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{n: true});
	});
var $author$project$Internal$Drawer$Dismissible$Implementation$open = $author$project$Internal$Drawer$Implementation$open;
var $author$project$Material$Drawer$Dismissible$open = $author$project$Internal$Drawer$Dismissible$Implementation$open;
var $author$project$Internal$List$Implementation$singleSelection = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{aj: false, ak: true});
	});
var $author$project$Material$List$singleSelection = $author$project$Internal$List$Implementation$singleSelection;
var $author$project$Internal$Drawer$Implementation$title = $author$project$Internal$Options$cs('mdc-drawer__title');
var $author$project$Internal$Drawer$Dismissible$Implementation$title = $author$project$Internal$Drawer$Implementation$title;
var $author$project$Material$Drawer$Dismissible$title = $author$project$Internal$Drawer$Dismissible$Implementation$title;
var $author$project$Internal$List$Implementation$useActivated = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{bB: true});
	});
var $author$project$Material$List$useActivated = $author$project$Internal$List$Implementation$useActivated;
var $author$project$Internal$Drawer$Dismissible$Implementation$className = 'mdc-drawer--dismissible';
var $author$project$Internal$Drawer$Model$EndAnimation = {$: 2};
var $author$project$Internal$Drawer$Model$NoOp = {$: 0};
var $author$project$Internal$Drawer$Model$StartAnimation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $author$project$Internal$Drawer$Implementation$defaultConfig = {bd: $elm$core$Maybe$Nothing, n: false};
var $author$project$Internal$Drawer$Implementation$view = F5(
	function (className, lift, model, options, nodes) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$Drawer$Implementation$defaultConfig, options);
		var config = summary.ea;
		var stateChanged = (!model.bG) && (!_Utils_eq(config.n, model.n));
		return A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$aside,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Internal$Options$cs('mdc-drawer'),
						$author$project$Internal$Options$cs(className),
						A2(
						$author$project$Internal$Options$when,
						stateChanged,
						$author$project$Internal$GlobalEvents$onTick(
							$elm$json$Json$Decode$succeed(
								lift(
									$author$project$Internal$Drawer$Model$StartAnimation(config.n))))),
						A2(
						$author$project$Internal$Options$when,
						config.n || model.n,
						$author$project$Internal$Options$cs('mdc-drawer--open')),
						A2(
						$author$project$Internal$Options$when,
						config.n && (stateChanged || model.aX),
						$author$project$Internal$Options$cs('mdc-drawer--animate')),
						A2(
						$author$project$Internal$Options$when,
						config.n && model.aX,
						$author$project$Internal$Options$cs('mdc-drawer--opening')),
						A2(
						$author$project$Internal$Options$when,
						(!config.n) && model.aX,
						$author$project$Internal$Options$cs('mdc-drawer--closing')),
						A2(
						$author$project$Internal$Options$when,
						model.aX,
						A2(
							$author$project$Internal$Options$on,
							'transitionend',
							$elm$json$Json$Decode$succeed(
								lift($author$project$Internal$Drawer$Model$EndAnimation)))),
						A2(
						$author$project$Internal$Options$when,
						(!$elm$core$String$isEmpty(className)) && (config.n || model.n),
						A2($author$project$Internal$Options$data, 'focustrap', '{}')),
						A2(
						$author$project$Internal$Options$on,
						'keydown',
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (key, keyCode) {
									return (_Utils_eq(
										key,
										$elm$core$Maybe$Just('Escape')) || (keyCode === 27)) ? A2(
										$elm$core$Maybe$withDefault,
										lift($author$project$Internal$Drawer$Model$NoOp),
										config.bd) : lift($author$project$Internal$Drawer$Model$NoOp);
								}),
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$map,
										$elm$core$Maybe$Just,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['key']),
											$elm$json$Json$Decode$string)),
										$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['keyCode']),
								$elm$json$Json$Decode$int)))
					]),
				options),
			nodes);
	});
var $author$project$Internal$Drawer$Implementation$render = function (className) {
	return A3(
		$author$project$Internal$Component$render,
		$author$project$Internal$Drawer$Implementation$getSet.cZ,
		$author$project$Internal$Drawer$Implementation$view(className),
		$author$project$Internal$Msg$DrawerMsg);
};
var $author$project$Internal$Drawer$Dismissible$Implementation$view = $author$project$Internal$Drawer$Implementation$render($author$project$Internal$Drawer$Dismissible$Implementation$className);
var $author$project$Material$Drawer$Dismissible$view = $author$project$Internal$Drawer$Dismissible$Implementation$view;
var $author$project$Main$viewDrawer = function (model) {
	return A5(
		$author$project$Material$Drawer$Dismissible$view,
		$author$project$Main$Mdc,
		'my-drawer',
		model.aI,
		_List_fromArray(
			[
				A2($author$project$Material$Options$when, model.a0, $author$project$Material$Drawer$Dismissible$open),
				$author$project$Material$Drawer$Dismissible$onClose($author$project$Main$ToggleDrawer)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Drawer$Dismissible$header,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Material$Options$styled,
						$elm$html$Html$h3,
						_List_fromArray(
							[$author$project$Material$Drawer$Dismissible$title]),
						_List_fromArray(
							[
								$elm$html$Html$text('Contents')
							]))
					])),
				A2(
				$author$project$Material$Drawer$Dismissible$content,
				_List_Nil,
				_List_fromArray(
					[
						A5(
						$author$project$Material$List$nav,
						$author$project$Main$Mdc,
						'my-drawer-list',
						model.aI,
						_List_fromArray(
							[$author$project$Material$List$singleSelection, $author$project$Material$List$useActivated]),
						$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								function (p) {
									return A3($author$project$Main$drawerLink, model.b0, p, 0);
								},
								$author$project$Main$pageConfigList)))
					])),
				A3(
				$author$project$Material$Options$styled,
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Material$Options$cs('version')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Main$markdownPrefix('sfocsres'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Resources')
							])),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Main$markdownPrefix('extres'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Friends')
							])),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Main$markdownPrefix('license'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('License')
							])),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Version: ' + (model.m.aR.aR + (' (' + (model.m.aR.c_ + ')')))),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Last build: ' + model.m.aR.dQ)
					]))
			]));
};
var $author$project$Internal$TopAppBar$Implementation$alignStart = $author$project$Internal$Options$cs('mdc-top-app-bar__section--align-start');
var $author$project$Material$TopAppBar$alignStart = $author$project$Internal$TopAppBar$Implementation$alignStart;
var $author$project$Internal$TopAppBar$Implementation$fixed = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{aE: true});
	});
var $author$project$Material$TopAppBar$fixed = $author$project$Internal$TopAppBar$Implementation$fixed;
var $author$project$Internal$Icon$Implementation$node = function (ctor) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{bW: ctor});
		});
};
var $author$project$Internal$Icon$Implementation$button = $author$project$Internal$Icon$Implementation$node('button');
var $author$project$Internal$TopAppBar$Implementation$actionItemView = F5(
	function (domId, lift, model, options, name) {
		var ripple = A5(
			$author$project$Internal$Ripple$Implementation$view,
			true,
			domId,
			A2(
				$elm$core$Basics$composeL,
				lift,
				$author$project$Internal$TopAppBar$Model$RippleMsg(domId)),
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Internal$Ripple$Model$defaultModel,
				A2($elm$core$Dict$get, domId, model.bk)),
			_List_Nil);
		return A2(
			$author$project$Internal$Icon$Implementation$view,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Icon$Implementation$button,
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Options$cs('mdc-icon-button'),
					A2(
						$elm$core$List$cons,
						ripple.ex,
						A2($elm$core$List$cons, ripple.eP, options)))),
			name);
	});
var $author$project$Internal$TopAppBar$Implementation$actionItem = F2(
	function (lift, index) {
		return A5(
			$author$project$Internal$Component$render,
			$author$project$Internal$TopAppBar$Implementation$getSet.cZ,
			$author$project$Internal$TopAppBar$Implementation$actionItemView(index),
			$author$project$Internal$Msg$TopAppBarMsg,
			lift,
			index);
	});
var $author$project$Material$TopAppBar$navigationIcon = F5(
	function (lift, index, model, options, name) {
		return A5(
			$author$project$Internal$TopAppBar$Implementation$actionItem,
			lift,
			index,
			model,
			A2(
				$elm$core$List$cons,
				$author$project$Material$Options$cs('mdc-top-app-bar__navigation-icon'),
				options),
			name);
	});
var $author$project$Internal$TopAppBar$Implementation$section = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$section,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-top-app-bar__section'),
			options));
};
var $author$project$Material$TopAppBar$section = $author$project$Internal$TopAppBar$Implementation$section;
var $author$project$Internal$TopAppBar$Implementation$title = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-top-app-bar__title'),
			options));
};
var $author$project$Material$TopAppBar$title = $author$project$Internal$TopAppBar$Implementation$title;
var $author$project$Internal$TopAppBar$Model$Init = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$TopAppBar$Model$Resize = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$TopAppBar$Model$Scroll = function (a) {
	return {$: 3, a: a};
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Internal$TopAppBar$Implementation$cssClasses = {bH: 'mdc-top-app-bar--short-collapsed', bK: 'mdc-top-app-bar--dense', aE: 'mdc-top-app-bar--fixed', b2: 'mdc-top-app-bar--prominent', dC: 'mdc-top-app-bar--fixed-scrolled', aP: 'mdc-top-app-bar--short'};
var $author$project$Internal$TopAppBar$Model$defaultConfig = {bH: false, bK: false, aE: false, b2: false, aP: false};
var $author$project$Internal$TopAppBar$Implementation$getAppBarHeight = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'clientHeight']),
	$elm$json$Json$Decode$float);
var $author$project$Internal$TopAppBar$Implementation$getViewportScrollY = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'ownerDocument', 'defaultView', 'scrollY']),
	$elm$json$Json$Decode$float);
var $author$project$Internal$GlobalEvents$onScroll = $author$project$Internal$GlobalEvents$listener('globalscroll');
var $author$project$Internal$TopAppBar$Implementation$row = function (options) {
	return A2(
		$author$project$Internal$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Options$cs('mdc-top-app-bar__row'),
			options));
};
var $author$project$Internal$TopAppBar$Implementation$topAppBar = F4(
	function (lift, model, options, sections) {
		var top = A2($elm$core$Maybe$withDefault, 0, model.dG);
		var lastScrollPosition = A2($elm$core$Maybe$withDefault, 0, model.ba);
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TopAppBar$Model$defaultConfig, options);
		var config = summary.ea;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$header,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-top-app-bar'),
					A2(
					$author$project$Internal$Options$when,
					config.bK,
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.bK)),
					A2(
					$author$project$Internal$Options$when,
					config.aE,
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.aE)),
					A2(
					$author$project$Internal$Options$when,
					config.aE && (lastScrollPosition > 0),
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.dC)),
					A2(
					$author$project$Internal$Options$when,
					config.b2,
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.b2)),
					A2(
					$author$project$Internal$Options$when,
					config.aP,
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.aP)),
					A2(
					$author$project$Internal$Options$when,
					config.bH || (config.aP && (lastScrollPosition > 0)),
					$author$project$Internal$Options$cs($author$project$Internal$TopAppBar$Implementation$cssClasses.bH)),
					A2(
					$author$project$Internal$Options$when,
					(!config.aE) && (!config.aP),
					A2(
						$author$project$Internal$Options$css,
						'top',
						$elm$core$String$fromFloat(top) + 'px')),
					$author$project$Internal$GlobalEvents$onScroll(
					A2(
						$elm$json$Json$Decode$map,
						lift,
						A2(
							$elm$json$Json$Decode$map,
							function (scrollPosition) {
								return $author$project$Internal$TopAppBar$Model$Scroll(
									{ax: scrollPosition});
							},
							$author$project$Internal$TopAppBar$Implementation$getViewportScrollY))),
					$author$project$Internal$GlobalEvents$onResize(
					A2(
						$elm$json$Json$Decode$map,
						lift,
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (scrollPosition, topAppBarHeight) {
									return $author$project$Internal$TopAppBar$Model$Resize(
										{ax: scrollPosition, L: topAppBarHeight});
								}),
							$author$project$Internal$TopAppBar$Implementation$getViewportScrollY,
							$author$project$Internal$TopAppBar$Implementation$getAppBarHeight))),
					A2(
					$author$project$Internal$Options$when,
					A2(
						$elm$core$List$any,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								_Utils_eq(model.ba, $elm$core$Maybe$Nothing),
								_Utils_eq(model.L, $elm$core$Maybe$Nothing)
							])),
					$author$project$Internal$GlobalEvents$onTick(
						A2(
							$elm$json$Json$Decode$map,
							lift,
							A3(
								$elm$json$Json$Decode$map2,
								F2(
									function (scrollPosition, topAppBarHeight) {
										return $author$project$Internal$TopAppBar$Model$Init(
											{ax: scrollPosition, L: topAppBarHeight});
									}),
								$author$project$Internal$TopAppBar$Implementation$getViewportScrollY,
								$author$project$Internal$TopAppBar$Implementation$getAppBarHeight))))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Internal$TopAppBar$Implementation$row, _List_Nil, sections)
				]));
	});
var $author$project$Internal$TopAppBar$Implementation$view = A3($author$project$Internal$Component$render, $author$project$Internal$TopAppBar$Implementation$getSet.cZ, $author$project$Internal$TopAppBar$Implementation$topAppBar, $author$project$Internal$Msg$TopAppBarMsg);
var $author$project$Material$TopAppBar$view = $author$project$Internal$TopAppBar$Implementation$view;
var $author$project$Main$viewTopAppBar = function (model) {
	return A5(
		$author$project$Material$TopAppBar$view,
		$author$project$Main$Mdc,
		'my-top-app-bar',
		model.aI,
		_List_fromArray(
			[$author$project$Material$TopAppBar$fixed]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$TopAppBar$section,
				_List_fromArray(
					[$author$project$Material$TopAppBar$alignStart]),
				_List_fromArray(
					[
						A5(
						$author$project$Material$TopAppBar$navigationIcon,
						$author$project$Main$Mdc,
						'my-top-app-bar--menu',
						model.aI,
						_List_fromArray(
							[
								$author$project$Material$Options$onClick($author$project$Main$ToggleDrawer)
							]),
						'menu'),
						A2(
						$author$project$Material$TopAppBar$title,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(model.m.cJ + (model.m.dp + '/public/logo_trans.png')),
										A2($elm$html$Html$Attributes$style, 'height', '40px'),
										A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
										A2($elm$html$Html$Attributes$style, 'padding', '10px'),
										A2($elm$html$Html$Attributes$style, 'display', 'inline')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'height', '100%'),
										A2($elm$html$Html$Attributes$style, 'width', '100%'),
										A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
										A2($elm$html$Html$Attributes$style, 'display', 'inline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('SilverFOCS')
									]))
							]))
					]))
			]));
};
var $author$project$Main$viewSkeleton = F2(
	function (model, html) {
		return A3(
			$author$project$Material$Options$styled,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Material$Options$cs('drawer-frame-root'),
					$author$project$Material$Options$cs('mdc-typography'),
					A2($author$project$Material$Options$css, 'display', 'flex'),
					A2($author$project$Material$Options$css, 'height', '100vh')
				]),
			_List_fromArray(
				[
					$author$project$Main$viewDrawer(model),
					A3(
					$author$project$Material$Options$styled,
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Material$Drawer$Dismissible$appContent,
							$author$project$Material$Typography$typography,
							A2($author$project$Material$Options$css, 'width', '100%')
						]),
					_List_fromArray(
						[
							$author$project$Main$viewTopAppBar(model),
							html
						]))
				]));
	});
var $author$project$Main$view = function (model) {
	return {
		d0: _List_fromArray(
			[
				A2(
				$author$project$Main$viewSkeleton,
				model,
				$author$project$Main$currentPage(model))
			]),
		bv: 'SilverFOCS'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{ev: $author$project$Main$init, eH: $author$project$Main$OnUrlChange, eI: $author$project$Main$OnUrlRequest, e_: $author$project$Main$subscriptions, e4: $author$project$Main$update, aT: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (version) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (prefix) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (api) {
							return $elm$json$Json$Decode$succeed(
								{cJ: api, dp: prefix, aR: version});
						},
						A2($elm$json$Json$Decode$field, 'api', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'prefix', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'version',
			A2(
				$elm$json$Json$Decode$andThen,
				function (version) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (timestamp) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (name) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (git) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (env) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (dirty) {
															return $elm$json$Json$Decode$succeed(
																{ed: dirty, ei: env, c_: git, eF: name, dQ: timestamp, aR: version});
														},
														A2($elm$json$Json$Decode$field, 'dirty', $elm$json$Json$Decode$bool));
												},
												A2($elm$json$Json$Decode$field, 'env', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'git', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string)))))(0)}});}(this));